/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Api
 * Synergistic Partner Network API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptPendingTenantInviteBody,
  AcceptTenantInviteBody,
  AccessRequest,
  AddDraftTeamWorkspaceNoteBody,
  AddOpportunityToWatchlist200,
  AddPartnerBody,
  AddWatchlistEntryBody,
  AdminDeleteConversation200,
  AdminDeleteConversationBody,
  AdminDeleteTeamingPost200,
  AdminDeleteTeamingPostBody,
  AdminDeleteVendorProfile200,
  AdminGetConversation200,
  AdminListConversations200,
  AdminListConversationsParams,
  AdminListReports200,
  AdminListReportsParams,
  AdminListTeamingPosts200,
  AdminListTeamingPostsParams,
  AdminListVendorProfiles200,
  AdminListVendorProfilesParams,
  AdminResolveReport200,
  AdminResolveReportBody,
  AdminRevokeWorkspaceClaimBody,
  AdminVendorProfileDeletePreview,
  AdminVerifyWorkspaceClaimBody,
  AdminWorkspaceClaim,
  Agency,
  AgencyExperience,
  AgencyExperienceInput,
  AgencyTreeNode,
  AiExtraction,
  AnalyzeOpportunityExtractFileBody,
  AnalyzeOpportunitySamUrlBody,
  AnalyzeOpportunityTextBody,
  AnalyzedOpportunityCreated,
  ApiError,
  AuditLog,
  AuthSession,
  BulkCreateAgencyExperiences201,
  BulkCreateAgencyExperiencesBody,
  BulkCreateDraftOpportunities201,
  BulkCreateDraftOpportunitiesBody,
  BulkInviteResults,
  BulkRejectAccessRequests200,
  BulkRejectAccessRequestsBody,
  CapabilityTag,
  Certification,
  CleanupDemoData200,
  Clearance,
  ConciergeDocumentUploadInput,
  ConciergeDraftInput,
  ConciergeSetup,
  ConciergeSetupInput,
  ConciergeSetupSummary,
  ConciergeWorkspace,
  ConfirmUeiVerificationBody,
  ContractVehicle,
  Conversation,
  CreateAccessRequest200,
  CreateAccessRequestBody,
  CreateAgencyBody,
  CreateAnalyzedOpportunityBody,
  CreateCapabilityTagBody,
  CreateCertificationBody,
  CreateContractVehicleBody,
  CreateDraftTeamBody,
  CreateForumThreadBody,
  CreateNaicsBody,
  CreatePscBody,
  CreateReferenceDataRequestBody,
  CreateReport200,
  CreateReportBody,
  CreateSubmission,
  CreateTenantBody,
  CreateTenantInviteBody,
  CreateWorkspaceAccessRequestBody,
  CuratedArchiveHealth,
  CuratorExtractJob,
  CuratorExtractOpportunityPdfBody,
  DashboardSummary,
  DecideReferenceDataRequestBody,
  DeclineConciergeOwnerReviewBody,
  DeclineWorkspaceAccessRequestBody,
  DiscoverVendorsParams,
  DiscoveryDetail,
  DiscoveryResults,
  DocumentEntry,
  DraftTeam,
  DraftTeamInvite,
  DraftTeamInviteResponseInput,
  EmailCampaign,
  EnrichVendorContactParams,
  EnrichedContactResult,
  ExpressInterest200,
  ForumPost,
  ForumThread,
  GetAdminFunnelAnalytics200,
  GetAdminFunnelAnalyticsParams,
  GetForumThread200,
  GetTeamBuilderAnalysisParams,
  GrantEngagementManager200,
  GrantEngagementManagerBody,
  GrantPlatformAdmin200,
  GrantPlatformAdminBody,
  HealthStatus,
  InterestedParty,
  ListAccessRequestsParams,
  ListAgenciesParams,
  ListCapabilityTagsParams,
  ListConciergeWorkspacesParams,
  ListDraftTeamWorkspacePursuitOptionsParams,
  ListEngagementManagers200Item,
  ListForumThreadsParams,
  ListMarketplaceOpportunitiesParams,
  ListNaicsParams,
  ListOpportunityMatchesParams,
  ListOpportunitySyncRuns200,
  ListOpportunitySyncRunsParams,
  ListPlatformAdmins200Item,
  ListPscParams,
  ListReferenceDataRequestsParams,
  ListSamImportRunsParams,
  ListTeamingForYouParams,
  ListTeamingPostsParams,
  ListWorkspaceAccessRequestsParams,
  ListWorkspaceReconciliationCandidatesParams,
  Logout200,
  MarkNotificationsViewed200,
  MarkNotificationsViewedBody,
  MarketplaceActivityEvent,
  MarketplaceFilterOptions,
  MarketplaceOpportunity,
  MarketplaceOpportunityInput,
  MarketplaceOpportunityWithMatch,
  MarketplaceRecommendedOpportunities,
  MarketplaceRoadmapItem,
  MarketplaceRoadmapItemInput,
  MarketplaceSummary,
  Member,
  Message,
  ModerateForumPostBody,
  ModerateForumThreadBody,
  NaicsCode,
  NotificationPrefs,
  OpportunityMatchDetail,
  OpportunityMatchList,
  OpportunitySyncBody,
  OpportunitySyncResult,
  OpportunityWhatIfBody,
  OpportunityWhatIfResult,
  OptOutOfInvites200,
  PartnerTopOpportunitiesParams,
  PartnerTopOpportunity,
  PendingTenantInvite,
  PreviewTenantInviteParams,
  PromoteOpportunityToMarketplace201,
  PromoteOpportunityToMarketplaceBody,
  PscCode,
  ReactToPost200,
  ReactToPostBody,
  RecordFunnelEventBody,
  ReferenceDataRequest,
  RejectAccessRequestBody,
  RejectAiExtractionBody,
  RemovePartner200,
  RepairCuratedOpportunityDeduplication200,
  ReplyToForumThreadBody,
  RequestMagicLink200,
  RequestMagicLinkBody,
  RequestTeamWorkspaceFileUpload200,
  RescoreAllTenants202,
  RescoreOpportunities202,
  RevokePlatformAdmin200,
  RevokeTenantInvite200,
  RunWeeklyDigestBody,
  SamImportRunsResponse,
  SearchFacets,
  SearchVendorsParams,
  SeedReferenceDataResult,
  SendEmailCampaignBody,
  SendMessageBody,
  SendVendorInviteBody,
  SendVendorInvitesBulkBody,
  ShareSubmission201,
  ShareSubmissionBody,
  SolicitationExtractionResult,
  StartConversationBody,
  Submission,
  SubscribeRoadmapItem200,
  SwitchTenantInput,
  SystemError,
  TeamBuilderAnalysis,
  TeamWorkspace,
  TeamWorkspaceFile,
  TeamWorkspaceNote,
  TeamWorkspacePursuit,
  TeamWorkspacePursuitOption,
  TeamWorkspaceTask,
  TeamingActivityEvent,
  TeamingForYouPost,
  TeamingPartner,
  TeamingPost,
  TeamingPostInput,
  TeamingPostUpdate,
  TeamingRecommendedVendors,
  TeamingResponse,
  TeamingResponseInput,
  TeamingSaveState,
  TeamingSummary,
  Tenant,
  TenantInvite,
  TenantInvitePreview,
  TenantMembership,
  TenantSettings,
  TenantWithSettings,
  TestResult,
  TrendingCapability,
  TriggerSamImportBody,
  UnclaimedVendorDetail,
  UnreadCounts,
  UnsubscribeViaToken200,
  UnsubscribeViaTokenParams,
  UpdateAgencyBody,
  UpdateCapabilityTagBody,
  UpdateContractVehicleBody,
  UpdateDraftTeamBody,
  UpdateNaicsBody,
  UpdateNotificationPrefsBody,
  UpdatePscBody,
  UpdateSubmission,
  UpdateTenantSettingsBody,
  UpdateTourState200,
  UpdateTourStateBody,
  UpdateWeeklyDigestSchedule200,
  UpdateWeeklyDigestScheduleBody,
  UploadConciergeDocument201,
  UploadDocumentBody,
  UploadDocumentFiles201,
  UploadDocumentFilesBody,
  UploadTeamWorkspaceFileBytesParams,
  VendorContactSuggestion,
  VendorInviteRecord,
  VendorInviteResend,
  VendorProfile,
  VendorProfileClaim,
  VendorProfileDetail,
  VendorProfileInput,
  VendorSearchResult,
  VerifyMagicLinkBody,
  WatchlistEntry,
  WeeklyDigestSchedule,
  WorkspaceAccessRequest,
  WorkspaceAccessRequestRequester,
  WorkspaceAssistantConversation,
  WorkspaceAssistantConversationInput,
  WorkspaceAssistantConversationThread,
  WorkspaceAssistantInput,
  WorkspaceAssistantResponse,
  WorkspaceFileCompleteBody,
  WorkspaceFileUploadBody,
  WorkspaceKnowledgeSourceDocument,
  WorkspaceObjectivesBody,
  WorkspacePursuitInput,
  WorkspacePursuitUpdate,
  WorkspaceReconciliationBlocked,
  WorkspaceReconciliationCandidate,
  WorkspaceReconciliationExecuteInput,
  WorkspaceReconciliationPreview,
  WorkspaceReconciliationPreviewInput,
  WorkspaceReconciliationResult,
  WorkspaceTaskBody,
  WorkspaceTaskPatchBody,
  WorkspaceTaskReminderPreferences,
  WorkspaceTaskReminderPreferencesInput
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListSubmissionsUrl = () => {




  return `/api/submissions`
}

/**
 * @summary List the authenticated user's private submission history
 */
export const listSubmissions = async ( options?: Parameters<typeof customFetch>[1]): Promise<Submission[]> => {

  return customFetch<Submission[]>(getListSubmissionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSubmissionsQueryKey = () => {
    return [
    `/api/submissions`
    ] as const;
    }


export const getListSubmissionsQueryOptions = <TData = Awaited<ReturnType<typeof listSubmissions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSubmissions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSubmissionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSubmissions>>> = ({ signal }) => listSubmissions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSubmissions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSubmissionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSubmissions>>>
export type ListSubmissionsQueryError = ErrorType<unknown>


/**
 * @summary List the authenticated user's private submission history
 */

export function useListSubmissions<TData = Awaited<ReturnType<typeof listSubmissions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSubmissions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSubmissionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateSubmissionUrl = () => {




  return `/api/submissions`
}

/**
 * @summary Create a private submission record
 */
export const createSubmission = async (createSubmissionBody: CreateSubmission, options?: Parameters<typeof customFetch>[1]): Promise<Submission> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Submission>(getCreateSubmissionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createSubmissionBody)
  }
);}





export const getCreateSubmissionMutationKey = () => ['createSubmission'] as const;

export const getCreateSubmissionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubmission>>, TError,CreateSubmissionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSubmission>>, TError,CreateSubmissionMutationVariables, TContext> => {

const mutationKey = getCreateSubmissionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubmission>>, CreateSubmissionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createSubmission(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSubmissionMutationResult = NonNullable<Awaited<ReturnType<typeof createSubmission>>>
    export type CreateSubmissionMutationBody = BodyType<CreateSubmission>
    export type CreateSubmissionMutationError = ErrorType<unknown>
    export type CreateSubmissionMutationVariables = {data: BodyType<CreateSubmission>}

    /**
 * @summary Create a private submission record
 */
export const useCreateSubmission = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubmission>>, TError,CreateSubmissionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSubmission>>,
        TError,
        CreateSubmissionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateSubmissionMutationOptions(options));
    }

export const getGetSubmissionUrl = (id: string,) => {




  return `/api/submissions/${id}`
}

export const getSubmission = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<Submission> => {

  return customFetch<Submission>(getGetSubmissionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSubmissionQueryKey = (id: string,) => {
    return [
    `/api/submissions/${id}`
    ] as const;
    }


export const getGetSubmissionQueryOptions = <TData = Awaited<ReturnType<typeof getSubmission>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubmission>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubmissionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubmission>>> = ({ signal }) => getSubmission(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubmission>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubmissionQueryResult = NonNullable<Awaited<ReturnType<typeof getSubmission>>>
export type GetSubmissionQueryError = ErrorType<void>



export function useGetSubmission<TData = Awaited<ReturnType<typeof getSubmission>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubmission>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSubmissionQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateSubmissionUrl = (id: string,) => {




  return `/api/submissions/${id}`
}

export const updateSubmission = async (id: string,
    updateSubmissionBody: UpdateSubmission, options?: Parameters<typeof customFetch>[1]): Promise<Submission> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Submission>(getUpdateSubmissionUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateSubmissionBody)
  }
);}





export const getUpdateSubmissionMutationKey = () => ['updateSubmission'] as const;

export const getUpdateSubmissionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSubmission>>, TError,UpdateSubmissionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSubmission>>, TError,UpdateSubmissionMutationVariables, TContext> => {

const mutationKey = getUpdateSubmissionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSubmission>>, UpdateSubmissionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateSubmission(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSubmissionMutationResult = NonNullable<Awaited<ReturnType<typeof updateSubmission>>>
    export type UpdateSubmissionMutationBody = BodyType<UpdateSubmission>
    export type UpdateSubmissionMutationError = ErrorType<unknown>
    export type UpdateSubmissionMutationVariables = {id: string;data: BodyType<UpdateSubmission>}

    export const useUpdateSubmission = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSubmission>>, TError,UpdateSubmissionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSubmission>>,
        TError,
        UpdateSubmissionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateSubmissionMutationOptions(options));
    }

export const getDeleteSubmissionUrl = (id: string,) => {




  return `/api/submissions/${id}`
}

export const deleteSubmission = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteSubmissionUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteSubmissionMutationKey = () => ['deleteSubmission'] as const;

export const getDeleteSubmissionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSubmission>>, TError,DeleteSubmissionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSubmission>>, TError,DeleteSubmissionMutationVariables, TContext> => {

const mutationKey = getDeleteSubmissionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSubmission>>, DeleteSubmissionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteSubmission(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSubmissionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSubmission>>>

    export type DeleteSubmissionMutationError = ErrorType<unknown>
    export type DeleteSubmissionMutationVariables = {id: string}

    export const useDeleteSubmission = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSubmission>>, TError,DeleteSubmissionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteSubmission>>,
        TError,
        DeleteSubmissionMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteSubmissionMutationOptions(options));
    }

export const getShareSubmissionUrl = (id: string,) => {




  return `/api/submissions/${id}/share`
}

/**
 * @summary Publish an allowlisted submission snapshot to a team workspace
 */
export const shareSubmission = async (id: string,
    shareSubmissionBody: ShareSubmissionBody, options?: Parameters<typeof customFetch>[1]): Promise<ShareSubmission201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ShareSubmission201>(getShareSubmissionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(shareSubmissionBody)
  }
);}





export const getShareSubmissionMutationKey = () => ['shareSubmission'] as const;

export const getShareSubmissionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareSubmission>>, TError,ShareSubmissionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof shareSubmission>>, TError,ShareSubmissionMutationVariables, TContext> => {

const mutationKey = getShareSubmissionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shareSubmission>>, ShareSubmissionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  shareSubmission(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ShareSubmissionMutationResult = NonNullable<Awaited<ReturnType<typeof shareSubmission>>>
    export type ShareSubmissionMutationBody = BodyType<ShareSubmissionBody>
    export type ShareSubmissionMutationError = ErrorType<void>
    export type ShareSubmissionMutationVariables = {id: string;data: BodyType<ShareSubmissionBody>}

    /**
 * @summary Publish an allowlisted submission snapshot to a team workspace
 */
export const useShareSubmission = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareSubmission>>, TError,ShareSubmissionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof shareSubmission>>,
        TError,
        ShareSubmissionMutationVariables,
        TContext
      > => {
      return useMutation(getShareSubmissionMutationOptions(options));
    }

export const getListWorkspaceReconciliationCandidatesUrl = (params?: ListWorkspaceReconciliationCandidatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/workspace-reconciliation/candidates?${stringifiedParams}` : `/api/admin/workspace-reconciliation/candidates`
}

/**
 * @summary Find workspaces that may belong to the same company (platform admin)
 */
export const listWorkspaceReconciliationCandidates = async (params?: ListWorkspaceReconciliationCandidatesParams, options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceReconciliationCandidate[]> => {

  return customFetch<WorkspaceReconciliationCandidate[]>(getListWorkspaceReconciliationCandidatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWorkspaceReconciliationCandidatesQueryKey = (params?: ListWorkspaceReconciliationCandidatesParams,) => {
    return [
    `/api/admin/workspace-reconciliation/candidates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListWorkspaceReconciliationCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof listWorkspaceReconciliationCandidates>>, TError = ErrorType<void>>(params?: ListWorkspaceReconciliationCandidatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceReconciliationCandidates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkspaceReconciliationCandidatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkspaceReconciliationCandidates>>> = ({ signal }) => listWorkspaceReconciliationCandidates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceReconciliationCandidates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWorkspaceReconciliationCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkspaceReconciliationCandidates>>>
export type ListWorkspaceReconciliationCandidatesQueryError = ErrorType<void>


/**
 * @summary Find workspaces that may belong to the same company (platform admin)
 */

export function useListWorkspaceReconciliationCandidates<TData = Awaited<ReturnType<typeof listWorkspaceReconciliationCandidates>>, TError = ErrorType<void>>(
 params?: ListWorkspaceReconciliationCandidatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceReconciliationCandidates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWorkspaceReconciliationCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPreviewWorkspaceReconciliationUrl = () => {




  return `/api/admin/workspace-reconciliation/preview`
}

/**
 * @summary Preview combining users into a canonical workspace (platform admin)
 */
export const previewWorkspaceReconciliation = async (workspaceReconciliationPreviewInput: WorkspaceReconciliationPreviewInput, options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceReconciliationPreview> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<WorkspaceReconciliationPreview>(getPreviewWorkspaceReconciliationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workspaceReconciliationPreviewInput)
  }
);}





export const getPreviewWorkspaceReconciliationMutationKey = () => ['previewWorkspaceReconciliation'] as const;

export const getPreviewWorkspaceReconciliationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewWorkspaceReconciliation>>, TError,PreviewWorkspaceReconciliationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewWorkspaceReconciliation>>, TError,PreviewWorkspaceReconciliationMutationVariables, TContext> => {

const mutationKey = getPreviewWorkspaceReconciliationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewWorkspaceReconciliation>>, PreviewWorkspaceReconciliationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  previewWorkspaceReconciliation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewWorkspaceReconciliationMutationResult = NonNullable<Awaited<ReturnType<typeof previewWorkspaceReconciliation>>>
    export type PreviewWorkspaceReconciliationMutationBody = BodyType<WorkspaceReconciliationPreviewInput>
    export type PreviewWorkspaceReconciliationMutationError = ErrorType<void>
    export type PreviewWorkspaceReconciliationMutationVariables = {data: BodyType<WorkspaceReconciliationPreviewInput>}

    /**
 * @summary Preview combining users into a canonical workspace (platform admin)
 */
export const usePreviewWorkspaceReconciliation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewWorkspaceReconciliation>>, TError,PreviewWorkspaceReconciliationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof previewWorkspaceReconciliation>>,
        TError,
        PreviewWorkspaceReconciliationMutationVariables,
        TContext
      > => {
      return useMutation(getPreviewWorkspaceReconciliationMutationOptions(options));
    }

export const getExecuteWorkspaceReconciliationUrl = () => {




  return `/api/admin/workspace-reconciliation/execute`
}

/**
 * @summary Add selected existing users to a canonical workspace (platform admin)
 */
export const executeWorkspaceReconciliation = async (workspaceReconciliationExecuteInput: WorkspaceReconciliationExecuteInput, options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceReconciliationResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<WorkspaceReconciliationResult>(getExecuteWorkspaceReconciliationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workspaceReconciliationExecuteInput)
  }
);}





export const getExecuteWorkspaceReconciliationMutationKey = () => ['executeWorkspaceReconciliation'] as const;

export const getExecuteWorkspaceReconciliationMutationOptions = <TError = ErrorType<void | WorkspaceReconciliationBlocked>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeWorkspaceReconciliation>>, TError,ExecuteWorkspaceReconciliationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof executeWorkspaceReconciliation>>, TError,ExecuteWorkspaceReconciliationMutationVariables, TContext> => {

const mutationKey = getExecuteWorkspaceReconciliationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeWorkspaceReconciliation>>, ExecuteWorkspaceReconciliationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  executeWorkspaceReconciliation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExecuteWorkspaceReconciliationMutationResult = NonNullable<Awaited<ReturnType<typeof executeWorkspaceReconciliation>>>
    export type ExecuteWorkspaceReconciliationMutationBody = BodyType<WorkspaceReconciliationExecuteInput>
    export type ExecuteWorkspaceReconciliationMutationError = ErrorType<void | WorkspaceReconciliationBlocked>
    export type ExecuteWorkspaceReconciliationMutationVariables = {data: BodyType<WorkspaceReconciliationExecuteInput>}

    /**
 * @summary Add selected existing users to a canonical workspace (platform admin)
 */
export const useExecuteWorkspaceReconciliation = <TError = ErrorType<void | WorkspaceReconciliationBlocked>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeWorkspaceReconciliation>>, TError,ExecuteWorkspaceReconciliationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof executeWorkspaceReconciliation>>,
        TError,
        ExecuteWorkspaceReconciliationMutationVariables,
        TContext
      > => {
      return useMutation(getExecuteWorkspaceReconciliationMutationOptions(options));
    }

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestMagicLinkUrl = () => {




  return `/api/auth/request-magic-link`
}

/**
 * @summary Request a magic link by email
 */
export const requestMagicLink = async (requestMagicLinkBody: RequestMagicLinkBody, options?: Parameters<typeof customFetch>[1]): Promise<RequestMagicLink200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<RequestMagicLink200>(getRequestMagicLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(requestMagicLinkBody)
  }
);}





export const getRequestMagicLinkMutationKey = () => ['requestMagicLink'] as const;

export const getRequestMagicLinkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestMagicLink>>, TError,RequestMagicLinkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestMagicLink>>, TError,RequestMagicLinkMutationVariables, TContext> => {

const mutationKey = getRequestMagicLinkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestMagicLink>>, RequestMagicLinkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestMagicLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestMagicLinkMutationResult = NonNullable<Awaited<ReturnType<typeof requestMagicLink>>>
    export type RequestMagicLinkMutationBody = BodyType<RequestMagicLinkBody>
    export type RequestMagicLinkMutationError = ErrorType<unknown>
    export type RequestMagicLinkMutationVariables = {data: BodyType<RequestMagicLinkBody>}

    /**
 * @summary Request a magic link by email
 */
export const useRequestMagicLink = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestMagicLink>>, TError,RequestMagicLinkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestMagicLink>>,
        TError,
        RequestMagicLinkMutationVariables,
        TContext
      > => {
      return useMutation(getRequestMagicLinkMutationOptions(options));
    }

export const getVerifyMagicLinkUrl = () => {




  return `/api/auth/verify`
}

/**
 * @summary Verify magic link token and create session
 */
export const verifyMagicLink = async (verifyMagicLinkBody: VerifyMagicLinkBody, options?: Parameters<typeof customFetch>[1]): Promise<AuthSession> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AuthSession>(getVerifyMagicLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(verifyMagicLinkBody)
  }
);}





export const getVerifyMagicLinkMutationKey = () => ['verifyMagicLink'] as const;

export const getVerifyMagicLinkMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMagicLink>>, TError,VerifyMagicLinkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyMagicLink>>, TError,VerifyMagicLinkMutationVariables, TContext> => {

const mutationKey = getVerifyMagicLinkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyMagicLink>>, VerifyMagicLinkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  verifyMagicLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyMagicLinkMutationResult = NonNullable<Awaited<ReturnType<typeof verifyMagicLink>>>
    export type VerifyMagicLinkMutationBody = BodyType<VerifyMagicLinkBody>
    export type VerifyMagicLinkMutationError = ErrorType<ApiError>
    export type VerifyMagicLinkMutationVariables = {data: BodyType<VerifyMagicLinkBody>}

    /**
 * @summary Verify magic link token and create session
 */
export const useVerifyMagicLink = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyMagicLink>>, TError,VerifyMagicLinkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyMagicLink>>,
        TError,
        VerifyMagicLinkMutationVariables,
        TContext
      > => {
      return useMutation(getVerifyMagicLinkMutationOptions(options));
    }

export const getLogoutUrl = () => {




  return `/api/auth/logout`
}

/**
 * @summary End session
 */
export const logout = async ( options?: Parameters<typeof customFetch>[1]): Promise<Logout200> => {

  return customFetch<Logout200>(getLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLogoutMutationKey = () => ['logout'] as const;

export const getLogoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = getLogoutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = ErrorType<unknown>


    /**
 * @summary End session
 */
export const useLogout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options));
    }

export const getGetMeUrl = () => {




  return `/api/auth/me`
}

/**
 * @summary Current authenticated session info
 */
export const getMe = async ( options?: Parameters<typeof customFetch>[1]): Promise<AuthSession> => {

  return customFetch<AuthSession>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/auth/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ApiError>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<ApiError>


/**
 * @summary Current authenticated session info
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ApiError>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTourStateUrl = () => {




  return `/api/auth/tour-state`
}

/**
 * @summary Mark the new-user guided tour as completed or dismissed
 */
export const updateTourState = async (updateTourStateBody: UpdateTourStateBody, options?: Parameters<typeof customFetch>[1]): Promise<UpdateTourState200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<UpdateTourState200>(getUpdateTourStateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateTourStateBody)
  }
);}





export const getUpdateTourStateMutationKey = () => ['updateTourState'] as const;

export const getUpdateTourStateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTourState>>, TError,UpdateTourStateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTourState>>, TError,UpdateTourStateMutationVariables, TContext> => {

const mutationKey = getUpdateTourStateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTourState>>, UpdateTourStateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateTourState(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTourStateMutationResult = NonNullable<Awaited<ReturnType<typeof updateTourState>>>
    export type UpdateTourStateMutationBody = BodyType<UpdateTourStateBody>
    export type UpdateTourStateMutationError = ErrorType<ApiError>
    export type UpdateTourStateMutationVariables = {data: BodyType<UpdateTourStateBody>}

    /**
 * @summary Mark the new-user guided tour as completed or dismissed
 */
export const useUpdateTourState = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTourState>>, TError,UpdateTourStateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTourState>>,
        TError,
        UpdateTourStateMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTourStateMutationOptions(options));
    }

export const getListMyTenantsUrl = () => {




  return `/api/tenants`
}

/**
 * @summary Tenants the current user belongs to
 */
export const listMyTenants = async ( options?: Parameters<typeof customFetch>[1]): Promise<TenantMembership[]> => {

  return customFetch<TenantMembership[]>(getListMyTenantsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyTenantsQueryKey = () => {
    return [
    `/api/tenants`
    ] as const;
    }


export const getListMyTenantsQueryOptions = <TData = Awaited<ReturnType<typeof listMyTenants>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyTenants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyTenantsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyTenants>>> = ({ signal }) => listMyTenants({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyTenants>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMyTenantsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyTenants>>>
export type ListMyTenantsQueryError = ErrorType<unknown>


/**
 * @summary Tenants the current user belongs to
 */

export function useListMyTenants<TData = Awaited<ReturnType<typeof listMyTenants>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyTenants>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMyTenantsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTenantUrl = () => {




  return `/api/tenants`
}

/**
 * @summary Create a new tenant (becomes Tenant Admin)
 */
export const createTenant = async (createTenantBody: CreateTenantBody, options?: Parameters<typeof customFetch>[1]): Promise<Tenant> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Tenant>(getCreateTenantUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createTenantBody)
  }
);}





export const getCreateTenantMutationKey = () => ['createTenant'] as const;

export const getCreateTenantMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,CreateTenantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,CreateTenantMutationVariables, TContext> => {

const mutationKey = getCreateTenantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTenant>>, CreateTenantMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTenant(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTenantMutationResult = NonNullable<Awaited<ReturnType<typeof createTenant>>>
    export type CreateTenantMutationBody = BodyType<CreateTenantBody>
    export type CreateTenantMutationError = ErrorType<ApiError>
    export type CreateTenantMutationVariables = {data: BodyType<CreateTenantBody>}

    /**
 * @summary Create a new tenant (becomes Tenant Admin)
 */
export const useCreateTenant = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenant>>, TError,CreateTenantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTenant>>,
        TError,
        CreateTenantMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTenantMutationOptions(options));
    }

export const getSwitchTenantUrl = () => {




  return `/api/tenants/switch`
}

/**
 * @summary Switch active tenant context
 */
export const switchTenant = async (switchTenantInput: SwitchTenantInput, options?: Parameters<typeof customFetch>[1]): Promise<AuthSession> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AuthSession>(getSwitchTenantUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(switchTenantInput)
  }
);}





export const getSwitchTenantMutationKey = () => ['switchTenant'] as const;

export const getSwitchTenantMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchTenant>>, TError,SwitchTenantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof switchTenant>>, TError,SwitchTenantMutationVariables, TContext> => {

const mutationKey = getSwitchTenantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof switchTenant>>, SwitchTenantMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  switchTenant(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SwitchTenantMutationResult = NonNullable<Awaited<ReturnType<typeof switchTenant>>>
    export type SwitchTenantMutationBody = BodyType<SwitchTenantInput>
    export type SwitchTenantMutationError = ErrorType<unknown>
    export type SwitchTenantMutationVariables = {data: BodyType<SwitchTenantInput>}

    /**
 * @summary Switch active tenant context
 */
export const useSwitchTenant = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchTenant>>, TError,SwitchTenantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof switchTenant>>,
        TError,
        SwitchTenantMutationVariables,
        TContext
      > => {
      return useMutation(getSwitchTenantMutationOptions(options));
    }

export const getGetCurrentTenantUrl = () => {




  return `/api/tenants/current`
}

/**
 * @summary Get the current active tenant settings
 */
export const getCurrentTenant = async ( options?: Parameters<typeof customFetch>[1]): Promise<TenantWithSettings> => {

  return customFetch<TenantWithSettings>(getGetCurrentTenantUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentTenantQueryKey = () => {
    return [
    `/api/tenants/current`
    ] as const;
    }


export const getGetCurrentTenantQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentTenant>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentTenant>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentTenantQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentTenant>>> = ({ signal }) => getCurrentTenant({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentTenant>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentTenantQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentTenant>>>
export type GetCurrentTenantQueryError = ErrorType<unknown>


/**
 * @summary Get the current active tenant settings
 */

export function useGetCurrentTenant<TData = Awaited<ReturnType<typeof getCurrentTenant>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentTenant>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentTenantQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTenantMembersUrl = () => {




  return `/api/tenants/current/members`
}

/**
 * @summary Members in the current tenant
 */
export const listTenantMembers = async ( options?: Parameters<typeof customFetch>[1]): Promise<Member[]> => {

  return customFetch<Member[]>(getListTenantMembersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTenantMembersQueryKey = () => {
    return [
    `/api/tenants/current/members`
    ] as const;
    }


export const getListTenantMembersQueryOptions = <TData = Awaited<ReturnType<typeof listTenantMembers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTenantMembers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTenantMembersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTenantMembers>>> = ({ signal }) => listTenantMembers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTenantMembers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTenantMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listTenantMembers>>>
export type ListTenantMembersQueryError = ErrorType<unknown>


/**
 * @summary Members in the current tenant
 */

export function useListTenantMembers<TData = Awaited<ReturnType<typeof listTenantMembers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTenantMembers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTenantMembersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListWorkspaceAccessRequestsUrl = (params?: ListWorkspaceAccessRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tenants/current/access-requests?${stringifiedParams}` : `/api/tenants/current/access-requests`
}

/**
 * @summary List access requests for the current workspace (workspace admin only)
 */
export const listWorkspaceAccessRequests = async (params?: ListWorkspaceAccessRequestsParams, options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceAccessRequest[]> => {

  return customFetch<WorkspaceAccessRequest[]>(getListWorkspaceAccessRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWorkspaceAccessRequestsQueryKey = (params?: ListWorkspaceAccessRequestsParams,) => {
    return [
    `/api/tenants/current/access-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListWorkspaceAccessRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listWorkspaceAccessRequests>>, TError = ErrorType<ApiError>>(params?: ListWorkspaceAccessRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceAccessRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkspaceAccessRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkspaceAccessRequests>>> = ({ signal }) => listWorkspaceAccessRequests(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceAccessRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWorkspaceAccessRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkspaceAccessRequests>>>
export type ListWorkspaceAccessRequestsQueryError = ErrorType<ApiError>


/**
 * @summary List access requests for the current workspace (workspace admin only)
 */

export function useListWorkspaceAccessRequests<TData = Awaited<ReturnType<typeof listWorkspaceAccessRequests>>, TError = ErrorType<ApiError>>(
 params?: ListWorkspaceAccessRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceAccessRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWorkspaceAccessRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListMyWorkspaceAccessRequestsUrl = () => {




  return `/api/workspace-access-requests`
}

/**
 * @summary List the signed-in user's workspace access requests
 */
export const listMyWorkspaceAccessRequests = async ( options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceAccessRequestRequester[]> => {

  return customFetch<WorkspaceAccessRequestRequester[]>(getListMyWorkspaceAccessRequestsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyWorkspaceAccessRequestsQueryKey = () => {
    return [
    `/api/workspace-access-requests`
    ] as const;
    }


export const getListMyWorkspaceAccessRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listMyWorkspaceAccessRequests>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyWorkspaceAccessRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyWorkspaceAccessRequestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyWorkspaceAccessRequests>>> = ({ signal }) => listMyWorkspaceAccessRequests({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyWorkspaceAccessRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMyWorkspaceAccessRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyWorkspaceAccessRequests>>>
export type ListMyWorkspaceAccessRequestsQueryError = ErrorType<unknown>


/**
 * @summary List the signed-in user's workspace access requests
 */

export function useListMyWorkspaceAccessRequests<TData = Awaited<ReturnType<typeof listMyWorkspaceAccessRequests>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyWorkspaceAccessRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMyWorkspaceAccessRequestsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateWorkspaceAccessRequestUrl = () => {




  return `/api/workspace-access-requests`
}

/**
 * @summary Request access to the workspace registered to a UEI
 */
export const createWorkspaceAccessRequest = async (createWorkspaceAccessRequestBody: CreateWorkspaceAccessRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceAccessRequestRequester> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<WorkspaceAccessRequestRequester>(getCreateWorkspaceAccessRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createWorkspaceAccessRequestBody)
  }
);}





export const getCreateWorkspaceAccessRequestMutationKey = () => ['createWorkspaceAccessRequest'] as const;

export const getCreateWorkspaceAccessRequestMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspaceAccessRequest>>, TError,CreateWorkspaceAccessRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkspaceAccessRequest>>, TError,CreateWorkspaceAccessRequestMutationVariables, TContext> => {

const mutationKey = getCreateWorkspaceAccessRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkspaceAccessRequest>>, CreateWorkspaceAccessRequestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createWorkspaceAccessRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkspaceAccessRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkspaceAccessRequest>>>
    export type CreateWorkspaceAccessRequestMutationBody = BodyType<CreateWorkspaceAccessRequestBody>
    export type CreateWorkspaceAccessRequestMutationError = ErrorType<ApiError>
    export type CreateWorkspaceAccessRequestMutationVariables = {data: BodyType<CreateWorkspaceAccessRequestBody>}

    /**
 * @summary Request access to the workspace registered to a UEI
 */
export const useCreateWorkspaceAccessRequest = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspaceAccessRequest>>, TError,CreateWorkspaceAccessRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createWorkspaceAccessRequest>>,
        TError,
        CreateWorkspaceAccessRequestMutationVariables,
        TContext
      > => {
      return useMutation(getCreateWorkspaceAccessRequestMutationOptions(options));
    }

export const getApproveWorkspaceAccessRequestUrl = (id: string,) => {




  return `/api/tenants/current/access-requests/${id}/approve`
}

/**
 * @summary Approve a pending workspace access request
 */
export const approveWorkspaceAccessRequest = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceAccessRequest> => {

  return customFetch<WorkspaceAccessRequest>(getApproveWorkspaceAccessRequestUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApproveWorkspaceAccessRequestMutationKey = () => ['approveWorkspaceAccessRequest'] as const;

export const getApproveWorkspaceAccessRequestMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveWorkspaceAccessRequest>>, TError,ApproveWorkspaceAccessRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveWorkspaceAccessRequest>>, TError,ApproveWorkspaceAccessRequestMutationVariables, TContext> => {

const mutationKey = getApproveWorkspaceAccessRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveWorkspaceAccessRequest>>, ApproveWorkspaceAccessRequestMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  approveWorkspaceAccessRequest(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveWorkspaceAccessRequestMutationResult = NonNullable<Awaited<ReturnType<typeof approveWorkspaceAccessRequest>>>

    export type ApproveWorkspaceAccessRequestMutationError = ErrorType<ApiError>
    export type ApproveWorkspaceAccessRequestMutationVariables = {id: string}

    /**
 * @summary Approve a pending workspace access request
 */
export const useApproveWorkspaceAccessRequest = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveWorkspaceAccessRequest>>, TError,ApproveWorkspaceAccessRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveWorkspaceAccessRequest>>,
        TError,
        ApproveWorkspaceAccessRequestMutationVariables,
        TContext
      > => {
      return useMutation(getApproveWorkspaceAccessRequestMutationOptions(options));
    }

export const getDeclineWorkspaceAccessRequestUrl = (id: string,) => {




  return `/api/tenants/current/access-requests/${id}/decline`
}

/**
 * @summary Decline a pending workspace access request
 */
export const declineWorkspaceAccessRequest = async (id: string,
    declineWorkspaceAccessRequestBody?: DeclineWorkspaceAccessRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceAccessRequest> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<WorkspaceAccessRequest>(getDeclineWorkspaceAccessRequestUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(declineWorkspaceAccessRequestBody)
  }
);}





export const getDeclineWorkspaceAccessRequestMutationKey = () => ['declineWorkspaceAccessRequest'] as const;

export const getDeclineWorkspaceAccessRequestMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineWorkspaceAccessRequest>>, TError,DeclineWorkspaceAccessRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof declineWorkspaceAccessRequest>>, TError,DeclineWorkspaceAccessRequestMutationVariables, TContext> => {

const mutationKey = getDeclineWorkspaceAccessRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineWorkspaceAccessRequest>>, DeclineWorkspaceAccessRequestMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  declineWorkspaceAccessRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineWorkspaceAccessRequestMutationResult = NonNullable<Awaited<ReturnType<typeof declineWorkspaceAccessRequest>>>
    export type DeclineWorkspaceAccessRequestMutationBody = BodyType<DeclineWorkspaceAccessRequestBody> | undefined
    export type DeclineWorkspaceAccessRequestMutationError = ErrorType<ApiError>
    export type DeclineWorkspaceAccessRequestMutationVariables = {id: string;data?: BodyType<DeclineWorkspaceAccessRequestBody>}

    /**
 * @summary Decline a pending workspace access request
 */
export const useDeclineWorkspaceAccessRequest = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineWorkspaceAccessRequest>>, TError,DeclineWorkspaceAccessRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof declineWorkspaceAccessRequest>>,
        TError,
        DeclineWorkspaceAccessRequestMutationVariables,
        TContext
      > => {
      return useMutation(getDeclineWorkspaceAccessRequestMutationOptions(options));
    }

export const getListTenantInvitesUrl = () => {




  return `/api/tenants/current/invites`
}

/**
 * @summary List coworker invites for the current tenant (admin only)
 */
export const listTenantInvites = async ( options?: Parameters<typeof customFetch>[1]): Promise<TenantInvite[]> => {

  return customFetch<TenantInvite[]>(getListTenantInvitesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTenantInvitesQueryKey = () => {
    return [
    `/api/tenants/current/invites`
    ] as const;
    }


export const getListTenantInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listTenantInvites>>, TError = ErrorType<ApiError>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTenantInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTenantInvitesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTenantInvites>>> = ({ signal }) => listTenantInvites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTenantInvites>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTenantInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listTenantInvites>>>
export type ListTenantInvitesQueryError = ErrorType<ApiError>


/**
 * @summary List coworker invites for the current tenant (admin only)
 */

export function useListTenantInvites<TData = Awaited<ReturnType<typeof listTenantInvites>>, TError = ErrorType<ApiError>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTenantInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTenantInvitesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTenantInviteUrl = () => {




  return `/api/tenants/current/invites`
}

/**
 * @summary Invite a coworker to the current tenant (admin only)
 */
export const createTenantInvite = async (createTenantInviteBody: CreateTenantInviteBody, options?: Parameters<typeof customFetch>[1]): Promise<TenantInvite> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TenantInvite>(getCreateTenantInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createTenantInviteBody)
  }
);}





export const getCreateTenantInviteMutationKey = () => ['createTenantInvite'] as const;

export const getCreateTenantInviteMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenantInvite>>, TError,CreateTenantInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTenantInvite>>, TError,CreateTenantInviteMutationVariables, TContext> => {

const mutationKey = getCreateTenantInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTenantInvite>>, CreateTenantInviteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTenantInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTenantInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createTenantInvite>>>
    export type CreateTenantInviteMutationBody = BodyType<CreateTenantInviteBody>
    export type CreateTenantInviteMutationError = ErrorType<ApiError>
    export type CreateTenantInviteMutationVariables = {data: BodyType<CreateTenantInviteBody>}

    /**
 * @summary Invite a coworker to the current tenant (admin only)
 */
export const useCreateTenantInvite = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTenantInvite>>, TError,CreateTenantInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTenantInvite>>,
        TError,
        CreateTenantInviteMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTenantInviteMutationOptions(options));
    }

export const getRevokeTenantInviteUrl = (inviteId: string,) => {




  return `/api/tenants/current/invites/${inviteId}`
}

/**
 * @summary Revoke a pending tenant invite (admin only)
 */
export const revokeTenantInvite = async (inviteId: string, options?: Parameters<typeof customFetch>[1]): Promise<RevokeTenantInvite200> => {

  return customFetch<RevokeTenantInvite200>(getRevokeTenantInviteUrl(inviteId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeTenantInviteMutationKey = () => ['revokeTenantInvite'] as const;

export const getRevokeTenantInviteMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeTenantInvite>>, TError,RevokeTenantInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeTenantInvite>>, TError,RevokeTenantInviteMutationVariables, TContext> => {

const mutationKey = getRevokeTenantInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeTenantInvite>>, RevokeTenantInviteMutationVariables> = (props) => {
          const {inviteId} = props ?? {};

          return  revokeTenantInvite(inviteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeTenantInviteMutationResult = NonNullable<Awaited<ReturnType<typeof revokeTenantInvite>>>

    export type RevokeTenantInviteMutationError = ErrorType<ApiError>
    export type RevokeTenantInviteMutationVariables = {inviteId: string}

    /**
 * @summary Revoke a pending tenant invite (admin only)
 */
export const useRevokeTenantInvite = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeTenantInvite>>, TError,RevokeTenantInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeTenantInvite>>,
        TError,
        RevokeTenantInviteMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeTenantInviteMutationOptions(options));
    }

export const getPreviewTenantInviteUrl = (params: PreviewTenantInviteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/invites/preview?${stringifiedParams}` : `/api/invites/preview`
}

/**
 * @summary Look up an invite by token (no auth)
 */
export const previewTenantInvite = async (params: PreviewTenantInviteParams, options?: Parameters<typeof customFetch>[1]): Promise<TenantInvitePreview> => {

  return customFetch<TenantInvitePreview>(getPreviewTenantInviteUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPreviewTenantInviteQueryKey = (params?: PreviewTenantInviteParams,) => {
    return [
    `/api/invites/preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getPreviewTenantInviteQueryOptions = <TData = Awaited<ReturnType<typeof previewTenantInvite>>, TError = ErrorType<ApiError>>(params: PreviewTenantInviteParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof previewTenantInvite>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewTenantInviteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewTenantInvite>>> = ({ signal }) => previewTenantInvite(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewTenantInvite>>, TError, TData> & { queryKey: QueryKey }
}

export type PreviewTenantInviteQueryResult = NonNullable<Awaited<ReturnType<typeof previewTenantInvite>>>
export type PreviewTenantInviteQueryError = ErrorType<ApiError>


/**
 * @summary Look up an invite by token (no auth)
 */

export function usePreviewTenantInvite<TData = Awaited<ReturnType<typeof previewTenantInvite>>, TError = ErrorType<ApiError>>(
 params: PreviewTenantInviteParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof previewTenantInvite>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPreviewTenantInviteQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListMyPendingTenantInvitesUrl = () => {




  return `/api/invites/pending`
}

/**
 * Returns only non-expired pending invites addressed to the authenticated user's email. Raw tokens are never returned.
 * @summary List pending workspace invites for the signed-in user
 */
export const listMyPendingTenantInvites = async ( options?: Parameters<typeof customFetch>[1]): Promise<PendingTenantInvite[]> => {

  return customFetch<PendingTenantInvite[]>(getListMyPendingTenantInvitesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyPendingTenantInvitesQueryKey = () => {
    return [
    `/api/invites/pending`
    ] as const;
    }


export const getListMyPendingTenantInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listMyPendingTenantInvites>>, TError = ErrorType<ApiError>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyPendingTenantInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyPendingTenantInvitesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyPendingTenantInvites>>> = ({ signal }) => listMyPendingTenantInvites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyPendingTenantInvites>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMyPendingTenantInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listMyPendingTenantInvites>>>
export type ListMyPendingTenantInvitesQueryError = ErrorType<ApiError>


/**
 * @summary List pending workspace invites for the signed-in user
 */

export function useListMyPendingTenantInvites<TData = Awaited<ReturnType<typeof listMyPendingTenantInvites>>, TError = ErrorType<ApiError>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyPendingTenantInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMyPendingTenantInvitesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAcceptPendingTenantInviteUrl = () => {




  return `/api/invites/accept-pending`
}

/**
 * @summary Accept a pending workspace invite from the recovery screen
 */
export const acceptPendingTenantInvite = async (acceptPendingTenantInviteBody: AcceptPendingTenantInviteBody, options?: Parameters<typeof customFetch>[1]): Promise<AuthSession> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AuthSession>(getAcceptPendingTenantInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(acceptPendingTenantInviteBody)
  }
);}





export const getAcceptPendingTenantInviteMutationKey = () => ['acceptPendingTenantInvite'] as const;

export const getAcceptPendingTenantInviteMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptPendingTenantInvite>>, TError,AcceptPendingTenantInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptPendingTenantInvite>>, TError,AcceptPendingTenantInviteMutationVariables, TContext> => {

const mutationKey = getAcceptPendingTenantInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptPendingTenantInvite>>, AcceptPendingTenantInviteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  acceptPendingTenantInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptPendingTenantInviteMutationResult = NonNullable<Awaited<ReturnType<typeof acceptPendingTenantInvite>>>
    export type AcceptPendingTenantInviteMutationBody = BodyType<AcceptPendingTenantInviteBody>
    export type AcceptPendingTenantInviteMutationError = ErrorType<ApiError>
    export type AcceptPendingTenantInviteMutationVariables = {data: BodyType<AcceptPendingTenantInviteBody>}

    /**
 * @summary Accept a pending workspace invite from the recovery screen
 */
export const useAcceptPendingTenantInvite = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptPendingTenantInvite>>, TError,AcceptPendingTenantInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptPendingTenantInvite>>,
        TError,
        AcceptPendingTenantInviteMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptPendingTenantInviteMutationOptions(options));
    }

export const getAcceptTenantInviteUrl = () => {




  return `/api/invites/accept`
}

/**
 * @summary Accept a coworker invite (must be signed in as invited email)
 */
export const acceptTenantInvite = async (acceptTenantInviteBody: AcceptTenantInviteBody, options?: Parameters<typeof customFetch>[1]): Promise<AuthSession> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AuthSession>(getAcceptTenantInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(acceptTenantInviteBody)
  }
);}





export const getAcceptTenantInviteMutationKey = () => ['acceptTenantInvite'] as const;

export const getAcceptTenantInviteMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTenantInvite>>, TError,AcceptTenantInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptTenantInvite>>, TError,AcceptTenantInviteMutationVariables, TContext> => {

const mutationKey = getAcceptTenantInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptTenantInvite>>, AcceptTenantInviteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  acceptTenantInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptTenantInviteMutationResult = NonNullable<Awaited<ReturnType<typeof acceptTenantInvite>>>
    export type AcceptTenantInviteMutationBody = BodyType<AcceptTenantInviteBody>
    export type AcceptTenantInviteMutationError = ErrorType<ApiError>
    export type AcceptTenantInviteMutationVariables = {data: BodyType<AcceptTenantInviteBody>}

    /**
 * @summary Accept a coworker invite (must be signed in as invited email)
 */
export const useAcceptTenantInvite = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTenantInvite>>, TError,AcceptTenantInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptTenantInvite>>,
        TError,
        AcceptTenantInviteMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptTenantInviteMutationOptions(options));
    }

export const getGetMyVendorProfileUrl = () => {




  return `/api/vendor-profile`
}

/**
 * @summary Vendor profile for the current tenant
 */
export const getMyVendorProfile = async ( options?: Parameters<typeof customFetch>[1]): Promise<VendorProfile> => {

  return customFetch<VendorProfile>(getGetMyVendorProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyVendorProfileQueryKey = () => {
    return [
    `/api/vendor-profile`
    ] as const;
    }


export const getGetMyVendorProfileQueryOptions = <TData = Awaited<ReturnType<typeof getMyVendorProfile>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyVendorProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyVendorProfileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyVendorProfile>>> = ({ signal }) => getMyVendorProfile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyVendorProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyVendorProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getMyVendorProfile>>>
export type GetMyVendorProfileQueryError = ErrorType<unknown>


/**
 * @summary Vendor profile for the current tenant
 */

export function useGetMyVendorProfile<TData = Awaited<ReturnType<typeof getMyVendorProfile>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyVendorProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyVendorProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpsertVendorProfileUrl = () => {




  return `/api/vendor-profile`
}

/**
 * @summary Create or update the vendor profile for current tenant
 */
export const upsertVendorProfile = async (vendorProfileInput: VendorProfileInput, options?: Parameters<typeof customFetch>[1]): Promise<VendorProfile> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<VendorProfile>(getUpsertVendorProfileUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorProfileInput)
  }
);}





export const getUpsertVendorProfileMutationKey = () => ['upsertVendorProfile'] as const;

export const getUpsertVendorProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertVendorProfile>>, TError,UpsertVendorProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertVendorProfile>>, TError,UpsertVendorProfileMutationVariables, TContext> => {

const mutationKey = getUpsertVendorProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertVendorProfile>>, UpsertVendorProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  upsertVendorProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertVendorProfileMutationResult = NonNullable<Awaited<ReturnType<typeof upsertVendorProfile>>>
    export type UpsertVendorProfileMutationBody = BodyType<VendorProfileInput>
    export type UpsertVendorProfileMutationError = ErrorType<unknown>
    export type UpsertVendorProfileMutationVariables = {data: BodyType<VendorProfileInput>}

    /**
 * @summary Create or update the vendor profile for current tenant
 */
export const useUpsertVendorProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertVendorProfile>>, TError,UpsertVendorProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof upsertVendorProfile>>,
        TError,
        UpsertVendorProfileMutationVariables,
        TContext
      > => {
      return useMutation(getUpsertVendorProfileMutationOptions(options));
    }

export const getGetMyVerificationUrl = () => {




  return `/api/vendor-profile/verification`
}

/**
 * @summary Current tenant's UEI claim/verification status
 */
export const getMyVerification = async ( options?: Parameters<typeof customFetch>[1]): Promise<VendorProfileClaim> => {

  return customFetch<VendorProfileClaim>(getGetMyVerificationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyVerificationQueryKey = () => {
    return [
    `/api/vendor-profile/verification`
    ] as const;
    }


export const getGetMyVerificationQueryOptions = <TData = Awaited<ReturnType<typeof getMyVerification>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyVerification>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyVerificationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyVerification>>> = ({ signal }) => getMyVerification({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyVerification>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyVerificationQueryResult = NonNullable<Awaited<ReturnType<typeof getMyVerification>>>
export type GetMyVerificationQueryError = ErrorType<unknown>


/**
 * @summary Current tenant's UEI claim/verification status
 */

export function useGetMyVerification<TData = Awaited<ReturnType<typeof getMyVerification>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyVerification>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyVerificationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestUeiVerificationReviewUrl = () => {




  return `/api/vendor-profile/verification`
}

/**
 * Marks the current tenant's UEI claim as pending so an SPN platform admin can review and verify it manually. Idempotent — re-requesting when already pending or verified is a no-op.
 * @summary Request admin review of the current tenant's UEI claim
 */
export const requestUeiVerificationReview = async ( options?: Parameters<typeof customFetch>[1]): Promise<VendorProfileClaim> => {

  return customFetch<VendorProfileClaim>(getRequestUeiVerificationReviewUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRequestUeiVerificationReviewMutationKey = () => ['requestUeiVerificationReview'] as const;

export const getRequestUeiVerificationReviewMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUeiVerificationReview>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUeiVerificationReview>>, TError,void, TContext> => {

const mutationKey = getRequestUeiVerificationReviewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUeiVerificationReview>>, void> = () => {


          return  requestUeiVerificationReview(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUeiVerificationReviewMutationResult = NonNullable<Awaited<ReturnType<typeof requestUeiVerificationReview>>>

    export type RequestUeiVerificationReviewMutationError = ErrorType<ApiError>


    /**
 * @summary Request admin review of the current tenant's UEI claim
 */
export const useRequestUeiVerificationReview = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUeiVerificationReview>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestUeiVerificationReview>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRequestUeiVerificationReviewMutationOptions(options));
    }

export const getConfirmUeiVerificationUrl = () => {




  return `/api/vendor-profile/verification/confirm`
}

/**
 * @summary Consume a UEI verification token (called by the /verify-uei page)
 */
export const confirmUeiVerification = async (confirmUeiVerificationBody: ConfirmUeiVerificationBody, options?: Parameters<typeof customFetch>[1]): Promise<VendorProfileClaim> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<VendorProfileClaim>(getConfirmUeiVerificationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(confirmUeiVerificationBody)
  }
);}





export const getConfirmUeiVerificationMutationKey = () => ['confirmUeiVerification'] as const;

export const getConfirmUeiVerificationMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmUeiVerification>>, TError,ConfirmUeiVerificationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmUeiVerification>>, TError,ConfirmUeiVerificationMutationVariables, TContext> => {

const mutationKey = getConfirmUeiVerificationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmUeiVerification>>, ConfirmUeiVerificationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  confirmUeiVerification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmUeiVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof confirmUeiVerification>>>
    export type ConfirmUeiVerificationMutationBody = BodyType<ConfirmUeiVerificationBody>
    export type ConfirmUeiVerificationMutationError = ErrorType<ApiError>
    export type ConfirmUeiVerificationMutationVariables = {data: BodyType<ConfirmUeiVerificationBody>}

    /**
 * @summary Consume a UEI verification token (called by the /verify-uei page)
 */
export const useConfirmUeiVerification = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmUeiVerification>>, TError,ConfirmUeiVerificationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmUeiVerification>>,
        TError,
        ConfirmUeiVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmUeiVerificationMutationOptions(options));
    }

export const getListWorkspaceClaimsUrl = () => {




  return `/api/admin/workspace-claims`
}

/**
 * @summary All vendor workspace claims (platform admin)
 */
export const listWorkspaceClaims = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminWorkspaceClaim[]> => {

  return customFetch<AdminWorkspaceClaim[]>(getListWorkspaceClaimsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWorkspaceClaimsQueryKey = () => {
    return [
    `/api/admin/workspace-claims`
    ] as const;
    }


export const getListWorkspaceClaimsQueryOptions = <TData = Awaited<ReturnType<typeof listWorkspaceClaims>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceClaims>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkspaceClaimsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkspaceClaims>>> = ({ signal }) => listWorkspaceClaims({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceClaims>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWorkspaceClaimsQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkspaceClaims>>>
export type ListWorkspaceClaimsQueryError = ErrorType<unknown>


/**
 * @summary All vendor workspace claims (platform admin)
 */

export function useListWorkspaceClaims<TData = Awaited<ReturnType<typeof listWorkspaceClaims>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceClaims>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWorkspaceClaimsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminVerifyWorkspaceClaimUrl = (tenantId: string,) => {




  return `/api/admin/workspace-claims/${tenantId}/verify`
}

/**
 * @summary Manually mark a workspace UEI claim as verified
 */
export const adminVerifyWorkspaceClaim = async (tenantId: string,
    adminVerifyWorkspaceClaimBody: AdminVerifyWorkspaceClaimBody, options?: Parameters<typeof customFetch>[1]): Promise<VendorProfileClaim> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<VendorProfileClaim>(getAdminVerifyWorkspaceClaimUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminVerifyWorkspaceClaimBody)
  }
);}





export const getAdminVerifyWorkspaceClaimMutationKey = () => ['adminVerifyWorkspaceClaim'] as const;

export const getAdminVerifyWorkspaceClaimMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVerifyWorkspaceClaim>>, TError,AdminVerifyWorkspaceClaimMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminVerifyWorkspaceClaim>>, TError,AdminVerifyWorkspaceClaimMutationVariables, TContext> => {

const mutationKey = getAdminVerifyWorkspaceClaimMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminVerifyWorkspaceClaim>>, AdminVerifyWorkspaceClaimMutationVariables> = (props) => {
          const {tenantId,data} = props ?? {};

          return  adminVerifyWorkspaceClaim(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminVerifyWorkspaceClaimMutationResult = NonNullable<Awaited<ReturnType<typeof adminVerifyWorkspaceClaim>>>
    export type AdminVerifyWorkspaceClaimMutationBody = BodyType<AdminVerifyWorkspaceClaimBody>
    export type AdminVerifyWorkspaceClaimMutationError = ErrorType<ApiError>
    export type AdminVerifyWorkspaceClaimMutationVariables = {tenantId: string;data: BodyType<AdminVerifyWorkspaceClaimBody>}

    /**
 * @summary Manually mark a workspace UEI claim as verified
 */
export const useAdminVerifyWorkspaceClaim = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminVerifyWorkspaceClaim>>, TError,AdminVerifyWorkspaceClaimMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminVerifyWorkspaceClaim>>,
        TError,
        AdminVerifyWorkspaceClaimMutationVariables,
        TContext
      > => {
      return useMutation(getAdminVerifyWorkspaceClaimMutationOptions(options));
    }

export const getAdminRevokeWorkspaceClaimUrl = (tenantId: string,) => {




  return `/api/admin/workspace-claims/${tenantId}/revoke`
}

/**
 * @summary Revoke a verified workspace UEI claim
 */
export const adminRevokeWorkspaceClaim = async (tenantId: string,
    adminRevokeWorkspaceClaimBody: AdminRevokeWorkspaceClaimBody, options?: Parameters<typeof customFetch>[1]): Promise<VendorProfileClaim> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<VendorProfileClaim>(getAdminRevokeWorkspaceClaimUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminRevokeWorkspaceClaimBody)
  }
);}





export const getAdminRevokeWorkspaceClaimMutationKey = () => ['adminRevokeWorkspaceClaim'] as const;

export const getAdminRevokeWorkspaceClaimMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRevokeWorkspaceClaim>>, TError,AdminRevokeWorkspaceClaimMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRevokeWorkspaceClaim>>, TError,AdminRevokeWorkspaceClaimMutationVariables, TContext> => {

const mutationKey = getAdminRevokeWorkspaceClaimMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRevokeWorkspaceClaim>>, AdminRevokeWorkspaceClaimMutationVariables> = (props) => {
          const {tenantId,data} = props ?? {};

          return  adminRevokeWorkspaceClaim(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRevokeWorkspaceClaimMutationResult = NonNullable<Awaited<ReturnType<typeof adminRevokeWorkspaceClaim>>>
    export type AdminRevokeWorkspaceClaimMutationBody = BodyType<AdminRevokeWorkspaceClaimBody>
    export type AdminRevokeWorkspaceClaimMutationError = ErrorType<unknown>
    export type AdminRevokeWorkspaceClaimMutationVariables = {tenantId: string;data: BodyType<AdminRevokeWorkspaceClaimBody>}

    /**
 * @summary Revoke a verified workspace UEI claim
 */
export const useAdminRevokeWorkspaceClaim = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRevokeWorkspaceClaim>>, TError,AdminRevokeWorkspaceClaimMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminRevokeWorkspaceClaim>>,
        TError,
        AdminRevokeWorkspaceClaimMutationVariables,
        TContext
      > => {
      return useMutation(getAdminRevokeWorkspaceClaimMutationOptions(options));
    }

export const getListConciergeWorkspacesUrl = (params?: ListConciergeWorkspacesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/concierge-workspaces?${stringifiedParams}` : `/api/admin/concierge-workspaces`
}

/**
 * @summary Search existing workspaces eligible for assisted vendor setup
 */
export const listConciergeWorkspaces = async (params?: ListConciergeWorkspacesParams, options?: Parameters<typeof customFetch>[1]): Promise<ConciergeWorkspace[]> => {

  return customFetch<ConciergeWorkspace[]>(getListConciergeWorkspacesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConciergeWorkspacesQueryKey = (params?: ListConciergeWorkspacesParams,) => {
    return [
    `/api/admin/concierge-workspaces`, ...(params ? [params] : [])
    ] as const;
    }


export const getListConciergeWorkspacesQueryOptions = <TData = Awaited<ReturnType<typeof listConciergeWorkspaces>>, TError = ErrorType<unknown>>(params?: ListConciergeWorkspacesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConciergeWorkspaces>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConciergeWorkspacesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConciergeWorkspaces>>> = ({ signal }) => listConciergeWorkspaces(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConciergeWorkspaces>>, TError, TData> & { queryKey: QueryKey }
}

export type ListConciergeWorkspacesQueryResult = NonNullable<Awaited<ReturnType<typeof listConciergeWorkspaces>>>
export type ListConciergeWorkspacesQueryError = ErrorType<unknown>


/**
 * @summary Search existing workspaces eligible for assisted vendor setup
 */

export function useListConciergeWorkspaces<TData = Awaited<ReturnType<typeof listConciergeWorkspaces>>, TError = ErrorType<unknown>>(
 params?: ListConciergeWorkspacesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConciergeWorkspaces>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListConciergeWorkspacesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListConciergeSetupsUrl = () => {




  return `/api/admin/concierge-setups`
}

/**
 * @summary List concierge vendor setup work
 */
export const listConciergeSetups = async ( options?: Parameters<typeof customFetch>[1]): Promise<ConciergeSetupSummary[]> => {

  return customFetch<ConciergeSetupSummary[]>(getListConciergeSetupsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConciergeSetupsQueryKey = () => {
    return [
    `/api/admin/concierge-setups`
    ] as const;
    }


export const getListConciergeSetupsQueryOptions = <TData = Awaited<ReturnType<typeof listConciergeSetups>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConciergeSetups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConciergeSetupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConciergeSetups>>> = ({ signal }) => listConciergeSetups({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConciergeSetups>>, TError, TData> & { queryKey: QueryKey }
}

export type ListConciergeSetupsQueryResult = NonNullable<Awaited<ReturnType<typeof listConciergeSetups>>>
export type ListConciergeSetupsQueryError = ErrorType<unknown>


/**
 * @summary List concierge vendor setup work
 */

export function useListConciergeSetups<TData = Awaited<ReturnType<typeof listConciergeSetups>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConciergeSetups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListConciergeSetupsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateConciergeSetupUrl = () => {




  return `/api/admin/concierge-setups`
}

/**
 * @summary Open an assisted setup for an existing workspace
 */
export const createConciergeSetup = async (conciergeSetupInput: ConciergeSetupInput, options?: Parameters<typeof customFetch>[1]): Promise<ConciergeSetup> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ConciergeSetup>(getCreateConciergeSetupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(conciergeSetupInput)
  }
);}





export const getCreateConciergeSetupMutationKey = () => ['createConciergeSetup'] as const;

export const getCreateConciergeSetupMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConciergeSetup>>, TError,CreateConciergeSetupMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createConciergeSetup>>, TError,CreateConciergeSetupMutationVariables, TContext> => {

const mutationKey = getCreateConciergeSetupMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConciergeSetup>>, CreateConciergeSetupMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createConciergeSetup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateConciergeSetupMutationResult = NonNullable<Awaited<ReturnType<typeof createConciergeSetup>>>
    export type CreateConciergeSetupMutationBody = BodyType<ConciergeSetupInput>
    export type CreateConciergeSetupMutationError = ErrorType<void>
    export type CreateConciergeSetupMutationVariables = {data: BodyType<ConciergeSetupInput>}

    /**
 * @summary Open an assisted setup for an existing workspace
 */
export const useCreateConciergeSetup = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConciergeSetup>>, TError,CreateConciergeSetupMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createConciergeSetup>>,
        TError,
        CreateConciergeSetupMutationVariables,
        TContext
      > => {
      return useMutation(getCreateConciergeSetupMutationOptions(options));
    }

export const getGetConciergeSetupUrl = (id: string,) => {




  return `/api/admin/concierge-setups/${id}`
}

/**
 * @summary Load a scoped assisted setup
 */
export const getConciergeSetup = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ConciergeSetup> => {

  return customFetch<ConciergeSetup>(getGetConciergeSetupUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConciergeSetupQueryKey = (id: string,) => {
    return [
    `/api/admin/concierge-setups/${id}`
    ] as const;
    }


export const getGetConciergeSetupQueryOptions = <TData = Awaited<ReturnType<typeof getConciergeSetup>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConciergeSetup>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConciergeSetupQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConciergeSetup>>> = ({ signal }) => getConciergeSetup(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConciergeSetup>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConciergeSetupQueryResult = NonNullable<Awaited<ReturnType<typeof getConciergeSetup>>>
export type GetConciergeSetupQueryError = ErrorType<void>


/**
 * @summary Load a scoped assisted setup
 */

export function useGetConciergeSetup<TData = Awaited<ReturnType<typeof getConciergeSetup>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConciergeSetup>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConciergeSetupQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSaveConciergeSetupDraftUrl = (id: string,) => {




  return `/api/admin/concierge-setups/${id}`
}

/**
 * @summary Save private assisted profile and experience drafts
 */
export const saveConciergeSetupDraft = async (id: string,
    conciergeDraftInput: ConciergeDraftInput, options?: Parameters<typeof customFetch>[1]): Promise<ConciergeSetup> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ConciergeSetup>(getSaveConciergeSetupDraftUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(conciergeDraftInput)
  }
);}





export const getSaveConciergeSetupDraftMutationKey = () => ['saveConciergeSetupDraft'] as const;

export const getSaveConciergeSetupDraftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveConciergeSetupDraft>>, TError,SaveConciergeSetupDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveConciergeSetupDraft>>, TError,SaveConciergeSetupDraftMutationVariables, TContext> => {

const mutationKey = getSaveConciergeSetupDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveConciergeSetupDraft>>, SaveConciergeSetupDraftMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  saveConciergeSetupDraft(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveConciergeSetupDraftMutationResult = NonNullable<Awaited<ReturnType<typeof saveConciergeSetupDraft>>>
    export type SaveConciergeSetupDraftMutationBody = BodyType<ConciergeDraftInput>
    export type SaveConciergeSetupDraftMutationError = ErrorType<unknown>
    export type SaveConciergeSetupDraftMutationVariables = {id: string;data: BodyType<ConciergeDraftInput>}

    /**
 * @summary Save private assisted profile and experience drafts
 */
export const useSaveConciergeSetupDraft = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveConciergeSetupDraft>>, TError,SaveConciergeSetupDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveConciergeSetupDraft>>,
        TError,
        SaveConciergeSetupDraftMutationVariables,
        TContext
      > => {
      return useMutation(getSaveConciergeSetupDraftMutationOptions(options));
    }

export const getRequestConciergeOwnerReviewExplicitUrl = (id: string,) => {




  return `/api/admin/concierge-setups/${id}/request-review`
}

/**
 * @summary Send a prepared setup to the vendor owner for review
 */
export const requestConciergeOwnerReviewExplicit = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ConciergeSetup> => {

  return customFetch<ConciergeSetup>(getRequestConciergeOwnerReviewExplicitUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRequestConciergeOwnerReviewExplicitMutationKey = () => ['requestConciergeOwnerReviewExplicit'] as const;

export const getRequestConciergeOwnerReviewExplicitMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestConciergeOwnerReviewExplicit>>, TError,RequestConciergeOwnerReviewExplicitMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestConciergeOwnerReviewExplicit>>, TError,RequestConciergeOwnerReviewExplicitMutationVariables, TContext> => {

const mutationKey = getRequestConciergeOwnerReviewExplicitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestConciergeOwnerReviewExplicit>>, RequestConciergeOwnerReviewExplicitMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  requestConciergeOwnerReviewExplicit(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestConciergeOwnerReviewExplicitMutationResult = NonNullable<Awaited<ReturnType<typeof requestConciergeOwnerReviewExplicit>>>

    export type RequestConciergeOwnerReviewExplicitMutationError = ErrorType<unknown>
    export type RequestConciergeOwnerReviewExplicitMutationVariables = {id: string}

    /**
 * @summary Send a prepared setup to the vendor owner for review
 */
export const useRequestConciergeOwnerReviewExplicit = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestConciergeOwnerReviewExplicit>>, TError,RequestConciergeOwnerReviewExplicitMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestConciergeOwnerReviewExplicit>>,
        TError,
        RequestConciergeOwnerReviewExplicitMutationVariables,
        TContext
      > => {
      return useMutation(getRequestConciergeOwnerReviewExplicitMutationOptions(options));
    }

export const getUploadConciergeDocumentUrl = (id: string,) => {




  return `/api/admin/concierge-setups/${id}/documents`
}

/**
 * @summary Upload a source document for an assisted setup
 */
export const uploadConciergeDocument = async (id: string,
    conciergeDocumentUploadInput: ConciergeDocumentUploadInput, options?: Parameters<typeof customFetch>[1]): Promise<UploadConciergeDocument201> => {
    const formData = new FormData();
formData.append(`file`, conciergeDocumentUploadInput.file);

  return customFetch<UploadConciergeDocument201>(getUploadConciergeDocumentUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadConciergeDocumentMutationKey = () => ['uploadConciergeDocument'] as const;

export const getUploadConciergeDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadConciergeDocument>>, TError,UploadConciergeDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadConciergeDocument>>, TError,UploadConciergeDocumentMutationVariables, TContext> => {

const mutationKey = getUploadConciergeDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadConciergeDocument>>, UploadConciergeDocumentMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  uploadConciergeDocument(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadConciergeDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadConciergeDocument>>>
    export type UploadConciergeDocumentMutationBody = BodyType<ConciergeDocumentUploadInput>
    export type UploadConciergeDocumentMutationError = ErrorType<unknown>
    export type UploadConciergeDocumentMutationVariables = {id: string;data: BodyType<ConciergeDocumentUploadInput>}

    /**
 * @summary Upload a source document for an assisted setup
 */
export const useUploadConciergeDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadConciergeDocument>>, TError,UploadConciergeDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadConciergeDocument>>,
        TError,
        UploadConciergeDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getUploadConciergeDocumentMutationOptions(options));
    }

export const getApplyConciergeExtractionUrl = (id: string,
    extractionId: string,) => {




  return `/api/admin/concierge-setups/${id}/extractions/${extractionId}/apply`
}

/**
 * @summary Add a completed AI extraction to the private assisted draft
 */
export const applyConciergeExtraction = async (id: string,
    extractionId: string, options?: Parameters<typeof customFetch>[1]): Promise<ConciergeSetup> => {

  return customFetch<ConciergeSetup>(getApplyConciergeExtractionUrl(id,extractionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApplyConciergeExtractionMutationKey = () => ['applyConciergeExtraction'] as const;

export const getApplyConciergeExtractionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyConciergeExtraction>>, TError,ApplyConciergeExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof applyConciergeExtraction>>, TError,ApplyConciergeExtractionMutationVariables, TContext> => {

const mutationKey = getApplyConciergeExtractionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyConciergeExtraction>>, ApplyConciergeExtractionMutationVariables> = (props) => {
          const {id,extractionId} = props ?? {};

          return  applyConciergeExtraction(id,extractionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApplyConciergeExtractionMutationResult = NonNullable<Awaited<ReturnType<typeof applyConciergeExtraction>>>

    export type ApplyConciergeExtractionMutationError = ErrorType<unknown>
    export type ApplyConciergeExtractionMutationVariables = {id: string;extractionId: string}

    /**
 * @summary Add a completed AI extraction to the private assisted draft
 */
export const useApplyConciergeExtraction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof applyConciergeExtraction>>, TError,ApplyConciergeExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof applyConciergeExtraction>>,
        TError,
        ApplyConciergeExtractionMutationVariables,
        TContext
      > => {
      return useMutation(getApplyConciergeExtractionMutationOptions(options));
    }

export const getListConciergeOwnerReviewsUrl = () => {




  return `/api/concierge-review`
}

/**
 * @summary List assisted setups awaiting the current vendor owner
 */
export const listConciergeOwnerReviews = async ( options?: Parameters<typeof customFetch>[1]): Promise<ConciergeSetupSummary[]> => {

  return customFetch<ConciergeSetupSummary[]>(getListConciergeOwnerReviewsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConciergeOwnerReviewsQueryKey = () => {
    return [
    `/api/concierge-review`
    ] as const;
    }


export const getListConciergeOwnerReviewsQueryOptions = <TData = Awaited<ReturnType<typeof listConciergeOwnerReviews>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConciergeOwnerReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConciergeOwnerReviewsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConciergeOwnerReviews>>> = ({ signal }) => listConciergeOwnerReviews({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConciergeOwnerReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type ListConciergeOwnerReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof listConciergeOwnerReviews>>>
export type ListConciergeOwnerReviewsQueryError = ErrorType<unknown>


/**
 * @summary List assisted setups awaiting the current vendor owner
 */

export function useListConciergeOwnerReviews<TData = Awaited<ReturnType<typeof listConciergeOwnerReviews>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConciergeOwnerReviews>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListConciergeOwnerReviewsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetConciergeOwnerReviewUrl = (id: string,) => {




  return `/api/concierge-review/${id}`
}

/**
 * @summary Load an assisted setup for the current vendor owner
 */
export const getConciergeOwnerReview = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ConciergeSetup> => {

  return customFetch<ConciergeSetup>(getGetConciergeOwnerReviewUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConciergeOwnerReviewQueryKey = (id: string,) => {
    return [
    `/api/concierge-review/${id}`
    ] as const;
    }


export const getGetConciergeOwnerReviewQueryOptions = <TData = Awaited<ReturnType<typeof getConciergeOwnerReview>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConciergeOwnerReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConciergeOwnerReviewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConciergeOwnerReview>>> = ({ signal }) => getConciergeOwnerReview(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConciergeOwnerReview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConciergeOwnerReviewQueryResult = NonNullable<Awaited<ReturnType<typeof getConciergeOwnerReview>>>
export type GetConciergeOwnerReviewQueryError = ErrorType<unknown>


/**
 * @summary Load an assisted setup for the current vendor owner
 */

export function useGetConciergeOwnerReview<TData = Awaited<ReturnType<typeof getConciergeOwnerReview>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConciergeOwnerReview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConciergeOwnerReviewQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getEditConciergeOwnerReviewUrl = (id: string,) => {




  return `/api/concierge-review/${id}`
}

/**
 * @summary Edit a private assisted setup before approval
 */
export const editConciergeOwnerReview = async (id: string,
    conciergeDraftInput: ConciergeDraftInput, options?: Parameters<typeof customFetch>[1]): Promise<ConciergeSetup> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ConciergeSetup>(getEditConciergeOwnerReviewUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(conciergeDraftInput)
  }
);}





export const getEditConciergeOwnerReviewMutationKey = () => ['editConciergeOwnerReview'] as const;

export const getEditConciergeOwnerReviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editConciergeOwnerReview>>, TError,EditConciergeOwnerReviewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editConciergeOwnerReview>>, TError,EditConciergeOwnerReviewMutationVariables, TContext> => {

const mutationKey = getEditConciergeOwnerReviewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editConciergeOwnerReview>>, EditConciergeOwnerReviewMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  editConciergeOwnerReview(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditConciergeOwnerReviewMutationResult = NonNullable<Awaited<ReturnType<typeof editConciergeOwnerReview>>>
    export type EditConciergeOwnerReviewMutationBody = BodyType<ConciergeDraftInput>
    export type EditConciergeOwnerReviewMutationError = ErrorType<unknown>
    export type EditConciergeOwnerReviewMutationVariables = {id: string;data: BodyType<ConciergeDraftInput>}

    /**
 * @summary Edit a private assisted setup before approval
 */
export const useEditConciergeOwnerReview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editConciergeOwnerReview>>, TError,EditConciergeOwnerReviewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof editConciergeOwnerReview>>,
        TError,
        EditConciergeOwnerReviewMutationVariables,
        TContext
      > => {
      return useMutation(getEditConciergeOwnerReviewMutationOptions(options));
    }

export const getApproveConciergeOwnerReviewUrl = (id: string,) => {




  return `/api/concierge-review/${id}/approve`
}

/**
 * @summary Publish an assisted setup after owner approval
 */
export const approveConciergeOwnerReview = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ConciergeSetup> => {

  return customFetch<ConciergeSetup>(getApproveConciergeOwnerReviewUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApproveConciergeOwnerReviewMutationKey = () => ['approveConciergeOwnerReview'] as const;

export const getApproveConciergeOwnerReviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveConciergeOwnerReview>>, TError,ApproveConciergeOwnerReviewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveConciergeOwnerReview>>, TError,ApproveConciergeOwnerReviewMutationVariables, TContext> => {

const mutationKey = getApproveConciergeOwnerReviewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveConciergeOwnerReview>>, ApproveConciergeOwnerReviewMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  approveConciergeOwnerReview(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveConciergeOwnerReviewMutationResult = NonNullable<Awaited<ReturnType<typeof approveConciergeOwnerReview>>>

    export type ApproveConciergeOwnerReviewMutationError = ErrorType<unknown>
    export type ApproveConciergeOwnerReviewMutationVariables = {id: string}

    /**
 * @summary Publish an assisted setup after owner approval
 */
export const useApproveConciergeOwnerReview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveConciergeOwnerReview>>, TError,ApproveConciergeOwnerReviewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveConciergeOwnerReview>>,
        TError,
        ApproveConciergeOwnerReviewMutationVariables,
        TContext
      > => {
      return useMutation(getApproveConciergeOwnerReviewMutationOptions(options));
    }

export const getDeclineConciergeOwnerReviewUrl = (id: string,) => {




  return `/api/concierge-review/${id}/decline`
}

/**
 * @summary Return an assisted setup to SPN for changes
 */
export const declineConciergeOwnerReview = async (id: string,
    declineConciergeOwnerReviewBody: DeclineConciergeOwnerReviewBody, options?: Parameters<typeof customFetch>[1]): Promise<ConciergeSetup> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ConciergeSetup>(getDeclineConciergeOwnerReviewUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(declineConciergeOwnerReviewBody)
  }
);}





export const getDeclineConciergeOwnerReviewMutationKey = () => ['declineConciergeOwnerReview'] as const;

export const getDeclineConciergeOwnerReviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineConciergeOwnerReview>>, TError,DeclineConciergeOwnerReviewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof declineConciergeOwnerReview>>, TError,DeclineConciergeOwnerReviewMutationVariables, TContext> => {

const mutationKey = getDeclineConciergeOwnerReviewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineConciergeOwnerReview>>, DeclineConciergeOwnerReviewMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  declineConciergeOwnerReview(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineConciergeOwnerReviewMutationResult = NonNullable<Awaited<ReturnType<typeof declineConciergeOwnerReview>>>
    export type DeclineConciergeOwnerReviewMutationBody = BodyType<DeclineConciergeOwnerReviewBody>
    export type DeclineConciergeOwnerReviewMutationError = ErrorType<unknown>
    export type DeclineConciergeOwnerReviewMutationVariables = {id: string;data: BodyType<DeclineConciergeOwnerReviewBody>}

    /**
 * @summary Return an assisted setup to SPN for changes
 */
export const useDeclineConciergeOwnerReview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineConciergeOwnerReview>>, TError,DeclineConciergeOwnerReviewMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof declineConciergeOwnerReview>>,
        TError,
        DeclineConciergeOwnerReviewMutationVariables,
        TContext
      > => {
      return useMutation(getDeclineConciergeOwnerReviewMutationOptions(options));
    }

export const getGetVendorProfileUrl = (id: string,) => {




  return `/api/vendor-profile/${id}`
}

/**
 * @summary Get a vendor profile by id (respects visibility rules)
 */
export const getVendorProfile = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<VendorProfileDetail> => {

  return customFetch<VendorProfileDetail>(getGetVendorProfileUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVendorProfileQueryKey = (id: string,) => {
    return [
    `/api/vendor-profile/${id}`
    ] as const;
    }


export const getGetVendorProfileQueryOptions = <TData = Awaited<ReturnType<typeof getVendorProfile>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVendorProfileQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVendorProfile>>> = ({ signal }) => getVendorProfile(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVendorProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVendorProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getVendorProfile>>>
export type GetVendorProfileQueryError = ErrorType<unknown>


/**
 * @summary Get a vendor profile by id (respects visibility rules)
 */

export function useGetVendorProfile<TData = Awaited<ReturnType<typeof getVendorProfile>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVendorProfileQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAgencyExperiencesUrl = () => {




  return `/api/agency-experiences`
}

/**
 * @summary List agency experiences for the current tenant's vendor profile
 */
export const listAgencyExperiences = async ( options?: Parameters<typeof customFetch>[1]): Promise<AgencyExperience[]> => {

  return customFetch<AgencyExperience[]>(getListAgencyExperiencesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAgencyExperiencesQueryKey = () => {
    return [
    `/api/agency-experiences`
    ] as const;
    }


export const getListAgencyExperiencesQueryOptions = <TData = Awaited<ReturnType<typeof listAgencyExperiences>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgencyExperiences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgencyExperiencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgencyExperiences>>> = ({ signal }) => listAgencyExperiences({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgencyExperiences>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAgencyExperiencesQueryResult = NonNullable<Awaited<ReturnType<typeof listAgencyExperiences>>>
export type ListAgencyExperiencesQueryError = ErrorType<unknown>


/**
 * @summary List agency experiences for the current tenant's vendor profile
 */

export function useListAgencyExperiences<TData = Awaited<ReturnType<typeof listAgencyExperiences>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgencyExperiences>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAgencyExperiencesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAgencyExperienceUrl = () => {




  return `/api/agency-experiences`
}

/**
 * @summary Create an agency experience entry
 */
export const createAgencyExperience = async (agencyExperienceInput: AgencyExperienceInput, options?: Parameters<typeof customFetch>[1]): Promise<AgencyExperience> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AgencyExperience>(getCreateAgencyExperienceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agencyExperienceInput)
  }
);}





export const getCreateAgencyExperienceMutationKey = () => ['createAgencyExperience'] as const;

export const getCreateAgencyExperienceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgencyExperience>>, TError,CreateAgencyExperienceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAgencyExperience>>, TError,CreateAgencyExperienceMutationVariables, TContext> => {

const mutationKey = getCreateAgencyExperienceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAgencyExperience>>, CreateAgencyExperienceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAgencyExperience(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAgencyExperienceMutationResult = NonNullable<Awaited<ReturnType<typeof createAgencyExperience>>>
    export type CreateAgencyExperienceMutationBody = BodyType<AgencyExperienceInput>
    export type CreateAgencyExperienceMutationError = ErrorType<unknown>
    export type CreateAgencyExperienceMutationVariables = {data: BodyType<AgencyExperienceInput>}

    /**
 * @summary Create an agency experience entry
 */
export const useCreateAgencyExperience = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgencyExperience>>, TError,CreateAgencyExperienceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAgencyExperience>>,
        TError,
        CreateAgencyExperienceMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAgencyExperienceMutationOptions(options));
    }

export const getBulkCreateAgencyExperiencesUrl = () => {




  return `/api/agency-experiences/bulk`
}

/**
 * @summary Create multiple agency experience entries in one call
 */
export const bulkCreateAgencyExperiences = async (bulkCreateAgencyExperiencesBody: BulkCreateAgencyExperiencesBody, options?: Parameters<typeof customFetch>[1]): Promise<BulkCreateAgencyExperiences201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<BulkCreateAgencyExperiences201>(getBulkCreateAgencyExperiencesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkCreateAgencyExperiencesBody)
  }
);}





export const getBulkCreateAgencyExperiencesMutationKey = () => ['bulkCreateAgencyExperiences'] as const;

export const getBulkCreateAgencyExperiencesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateAgencyExperiences>>, TError,BulkCreateAgencyExperiencesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkCreateAgencyExperiences>>, TError,BulkCreateAgencyExperiencesMutationVariables, TContext> => {

const mutationKey = getBulkCreateAgencyExperiencesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkCreateAgencyExperiences>>, BulkCreateAgencyExperiencesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  bulkCreateAgencyExperiences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkCreateAgencyExperiencesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkCreateAgencyExperiences>>>
    export type BulkCreateAgencyExperiencesMutationBody = BodyType<BulkCreateAgencyExperiencesBody>
    export type BulkCreateAgencyExperiencesMutationError = ErrorType<unknown>
    export type BulkCreateAgencyExperiencesMutationVariables = {data: BodyType<BulkCreateAgencyExperiencesBody>}

    /**
 * @summary Create multiple agency experience entries in one call
 */
export const useBulkCreateAgencyExperiences = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateAgencyExperiences>>, TError,BulkCreateAgencyExperiencesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkCreateAgencyExperiences>>,
        TError,
        BulkCreateAgencyExperiencesMutationVariables,
        TContext
      > => {
      return useMutation(getBulkCreateAgencyExperiencesMutationOptions(options));
    }

export const getUpdateAgencyExperienceUrl = (id: string,) => {




  return `/api/agency-experiences/${id}`
}

export const updateAgencyExperience = async (id: string,
    agencyExperienceInput: AgencyExperienceInput, options?: Parameters<typeof customFetch>[1]): Promise<AgencyExperience> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AgencyExperience>(getUpdateAgencyExperienceUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(agencyExperienceInput)
  }
);}





export const getUpdateAgencyExperienceMutationKey = () => ['updateAgencyExperience'] as const;

export const getUpdateAgencyExperienceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgencyExperience>>, TError,UpdateAgencyExperienceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAgencyExperience>>, TError,UpdateAgencyExperienceMutationVariables, TContext> => {

const mutationKey = getUpdateAgencyExperienceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAgencyExperience>>, UpdateAgencyExperienceMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateAgencyExperience(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAgencyExperienceMutationResult = NonNullable<Awaited<ReturnType<typeof updateAgencyExperience>>>
    export type UpdateAgencyExperienceMutationBody = BodyType<AgencyExperienceInput>
    export type UpdateAgencyExperienceMutationError = ErrorType<unknown>
    export type UpdateAgencyExperienceMutationVariables = {id: string;data: BodyType<AgencyExperienceInput>}

    export const useUpdateAgencyExperience = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgencyExperience>>, TError,UpdateAgencyExperienceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAgencyExperience>>,
        TError,
        UpdateAgencyExperienceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAgencyExperienceMutationOptions(options));
    }

export const getDeleteAgencyExperienceUrl = (id: string,) => {




  return `/api/agency-experiences/${id}`
}

export const deleteAgencyExperience = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteAgencyExperienceUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAgencyExperienceMutationKey = () => ['deleteAgencyExperience'] as const;

export const getDeleteAgencyExperienceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgencyExperience>>, TError,DeleteAgencyExperienceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAgencyExperience>>, TError,DeleteAgencyExperienceMutationVariables, TContext> => {

const mutationKey = getDeleteAgencyExperienceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAgencyExperience>>, DeleteAgencyExperienceMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAgencyExperience(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAgencyExperienceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAgencyExperience>>>

    export type DeleteAgencyExperienceMutationError = ErrorType<unknown>
    export type DeleteAgencyExperienceMutationVariables = {id: string}

    export const useDeleteAgencyExperience = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgencyExperience>>, TError,DeleteAgencyExperienceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAgencyExperience>>,
        TError,
        DeleteAgencyExperienceMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAgencyExperienceMutationOptions(options));
    }

export const getListDocumentsUrl = () => {




  return `/api/documents`
}

export const listDocuments = async ( options?: Parameters<typeof customFetch>[1]): Promise<DocumentEntry[]> => {

  return customFetch<DocumentEntry[]>(getListDocumentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDocumentsQueryKey = () => {
    return [
    `/api/documents`
    ] as const;
    }


export const getListDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listDocuments>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocuments>>> = ({ signal }) => listDocuments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listDocuments>>>
export type ListDocumentsQueryError = ErrorType<unknown>



export function useListDocuments<TData = Awaited<ReturnType<typeof listDocuments>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDocumentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUploadDocumentUrl = () => {




  return `/api/documents`
}

/**
 * @summary Upload a capability statement (text content) for AI extraction
 */
export const uploadDocument = async (uploadDocumentBody: UploadDocumentBody, options?: Parameters<typeof customFetch>[1]): Promise<DocumentEntry> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<DocumentEntry>(getUploadDocumentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadDocumentBody)
  }
);}





export const getUploadDocumentMutationKey = () => ['uploadDocument'] as const;

export const getUploadDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,UploadDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,UploadDocumentMutationVariables, TContext> => {

const mutationKey = getUploadDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadDocument>>, UploadDocumentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadDocument(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadDocument>>>
    export type UploadDocumentMutationBody = BodyType<UploadDocumentBody>
    export type UploadDocumentMutationError = ErrorType<unknown>
    export type UploadDocumentMutationVariables = {data: BodyType<UploadDocumentBody>}

    /**
 * @summary Upload a capability statement (text content) for AI extraction
 */
export const useUploadDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,UploadDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadDocument>>,
        TError,
        UploadDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getUploadDocumentMutationOptions(options));
    }

export const getDeleteDocumentUrl = (id: string,) => {




  return `/api/documents/${id}`
}

/**
 * @summary Delete a document and all of its AI extractions
 */
export const deleteDocument = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteDocumentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDocumentMutationKey = () => ['deleteDocument'] as const;

export const getDeleteDocumentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,DeleteDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,DeleteDocumentMutationVariables, TContext> => {

const mutationKey = getDeleteDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocument>>, DeleteDocumentMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteDocument(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocument>>>

    export type DeleteDocumentMutationError = ErrorType<unknown>
    export type DeleteDocumentMutationVariables = {id: string}

    /**
 * @summary Delete a document and all of its AI extractions
 */
export const useDeleteDocument = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,DeleteDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDocument>>,
        TError,
        DeleteDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteDocumentMutationOptions(options));
    }

export const getUploadDocumentFilesUrl = () => {




  return `/api/documents/upload-files`
}

/**
 * @summary Bulk upload one or more files (PDF, DOCX, CSV, TXT, MD) and run AI extraction on each
 */
export const uploadDocumentFiles = async (uploadDocumentFilesBody: UploadDocumentFilesBody, options?: Parameters<typeof customFetch>[1]): Promise<UploadDocumentFiles201> => {
    const formData = new FormData();
uploadDocumentFilesBody.files.forEach(value => formData.append(`files`, value));

  return customFetch<UploadDocumentFiles201>(getUploadDocumentFilesUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadDocumentFilesMutationKey = () => ['uploadDocumentFiles'] as const;

export const getUploadDocumentFilesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocumentFiles>>, TError,UploadDocumentFilesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadDocumentFiles>>, TError,UploadDocumentFilesMutationVariables, TContext> => {

const mutationKey = getUploadDocumentFilesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadDocumentFiles>>, UploadDocumentFilesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadDocumentFiles(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadDocumentFilesMutationResult = NonNullable<Awaited<ReturnType<typeof uploadDocumentFiles>>>
    export type UploadDocumentFilesMutationBody = BodyType<UploadDocumentFilesBody>
    export type UploadDocumentFilesMutationError = ErrorType<unknown>
    export type UploadDocumentFilesMutationVariables = {data: BodyType<UploadDocumentFilesBody>}

    /**
 * @summary Bulk upload one or more files (PDF, DOCX, CSV, TXT, MD) and run AI extraction on each
 */
export const useUploadDocumentFiles = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocumentFiles>>, TError,UploadDocumentFilesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadDocumentFiles>>,
        TError,
        UploadDocumentFilesMutationVariables,
        TContext
      > => {
      return useMutation(getUploadDocumentFilesMutationOptions(options));
    }

export const getRunAiExtractionUrl = (id: string,) => {




  return `/api/documents/${id}/extract`
}

/**
 * @summary Run AI extraction against a document
 */
export const runAiExtraction = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<AiExtraction> => {

  return customFetch<AiExtraction>(getRunAiExtractionUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRunAiExtractionMutationKey = () => ['runAiExtraction'] as const;

export const getRunAiExtractionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runAiExtraction>>, TError,RunAiExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runAiExtraction>>, TError,RunAiExtractionMutationVariables, TContext> => {

const mutationKey = getRunAiExtractionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runAiExtraction>>, RunAiExtractionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  runAiExtraction(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunAiExtractionMutationResult = NonNullable<Awaited<ReturnType<typeof runAiExtraction>>>

    export type RunAiExtractionMutationError = ErrorType<unknown>
    export type RunAiExtractionMutationVariables = {id: string}

    /**
 * @summary Run AI extraction against a document
 */
export const useRunAiExtraction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runAiExtraction>>, TError,RunAiExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runAiExtraction>>,
        TError,
        RunAiExtractionMutationVariables,
        TContext
      > => {
      return useMutation(getRunAiExtractionMutationOptions(options));
    }

export const getListAiExtractionsUrl = () => {




  return `/api/ai-extractions`
}

export const listAiExtractions = async ( options?: Parameters<typeof customFetch>[1]): Promise<AiExtraction[]> => {

  return customFetch<AiExtraction[]>(getListAiExtractionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAiExtractionsQueryKey = () => {
    return [
    `/api/ai-extractions`
    ] as const;
    }


export const getListAiExtractionsQueryOptions = <TData = Awaited<ReturnType<typeof listAiExtractions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAiExtractions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAiExtractionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiExtractions>>> = ({ signal }) => listAiExtractions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiExtractions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAiExtractionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiExtractions>>>
export type ListAiExtractionsQueryError = ErrorType<unknown>



export function useListAiExtractions<TData = Awaited<ReturnType<typeof listAiExtractions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAiExtractions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAiExtractionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteAiExtractionUrl = (id: string,) => {




  return `/api/ai-extractions/${id}`
}

/**
 * @summary Delete a single AI extraction without touching the source document
 */
export const deleteAiExtraction = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteAiExtractionUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAiExtractionMutationKey = () => ['deleteAiExtraction'] as const;

export const getDeleteAiExtractionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiExtraction>>, TError,DeleteAiExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiExtraction>>, TError,DeleteAiExtractionMutationVariables, TContext> => {

const mutationKey = getDeleteAiExtractionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiExtraction>>, DeleteAiExtractionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAiExtraction(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiExtractionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiExtraction>>>

    export type DeleteAiExtractionMutationError = ErrorType<unknown>
    export type DeleteAiExtractionMutationVariables = {id: string}

    /**
 * @summary Delete a single AI extraction without touching the source document
 */
export const useDeleteAiExtraction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiExtraction>>, TError,DeleteAiExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAiExtraction>>,
        TError,
        DeleteAiExtractionMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAiExtractionMutationOptions(options));
    }

export const getApproveAiExtractionUrl = (id: string,) => {




  return `/api/ai-extractions/${id}/approve`
}

export const approveAiExtraction = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<AiExtraction> => {

  return customFetch<AiExtraction>(getApproveAiExtractionUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApproveAiExtractionMutationKey = () => ['approveAiExtraction'] as const;

export const getApproveAiExtractionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAiExtraction>>, TError,ApproveAiExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveAiExtraction>>, TError,ApproveAiExtractionMutationVariables, TContext> => {

const mutationKey = getApproveAiExtractionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAiExtraction>>, ApproveAiExtractionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  approveAiExtraction(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveAiExtractionMutationResult = NonNullable<Awaited<ReturnType<typeof approveAiExtraction>>>

    export type ApproveAiExtractionMutationError = ErrorType<unknown>
    export type ApproveAiExtractionMutationVariables = {id: string}

    export const useApproveAiExtraction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAiExtraction>>, TError,ApproveAiExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveAiExtraction>>,
        TError,
        ApproveAiExtractionMutationVariables,
        TContext
      > => {
      return useMutation(getApproveAiExtractionMutationOptions(options));
    }

export const getRejectAiExtractionUrl = (id: string,) => {




  return `/api/ai-extractions/${id}/reject`
}

export const rejectAiExtraction = async (id: string,
    rejectAiExtractionBody?: RejectAiExtractionBody, options?: Parameters<typeof customFetch>[1]): Promise<AiExtraction> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AiExtraction>(getRejectAiExtractionUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(rejectAiExtractionBody)
  }
);}





export const getRejectAiExtractionMutationKey = () => ['rejectAiExtraction'] as const;

export const getRejectAiExtractionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAiExtraction>>, TError,RejectAiExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectAiExtraction>>, TError,RejectAiExtractionMutationVariables, TContext> => {

const mutationKey = getRejectAiExtractionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectAiExtraction>>, RejectAiExtractionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  rejectAiExtraction(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectAiExtractionMutationResult = NonNullable<Awaited<ReturnType<typeof rejectAiExtraction>>>
    export type RejectAiExtractionMutationBody = BodyType<RejectAiExtractionBody> | undefined
    export type RejectAiExtractionMutationError = ErrorType<unknown>
    export type RejectAiExtractionMutationVariables = {id: string;data?: BodyType<RejectAiExtractionBody>}

    export const useRejectAiExtraction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAiExtraction>>, TError,RejectAiExtractionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectAiExtraction>>,
        TError,
        RejectAiExtractionMutationVariables,
        TContext
      > => {
      return useMutation(getRejectAiExtractionMutationOptions(options));
    }

export const getSearchVendorsUrl = (params?: SearchVendorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/search/vendors?${stringifiedParams}` : `/api/search/vendors`
}

export const searchVendors = async (params?: SearchVendorsParams, options?: Parameters<typeof customFetch>[1]): Promise<VendorSearchResult[]> => {

  return customFetch<VendorSearchResult[]>(getSearchVendorsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchVendorsQueryKey = (params?: SearchVendorsParams,) => {
    return [
    `/api/search/vendors`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchVendorsQueryOptions = <TData = Awaited<ReturnType<typeof searchVendors>>, TError = ErrorType<unknown>>(params?: SearchVendorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchVendors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchVendorsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchVendors>>> = ({ signal }) => searchVendors(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchVendors>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchVendorsQueryResult = NonNullable<Awaited<ReturnType<typeof searchVendors>>>
export type SearchVendorsQueryError = ErrorType<unknown>



export function useSearchVendors<TData = Awaited<ReturnType<typeof searchVendors>>, TError = ErrorType<unknown>>(
 params?: SearchVendorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchVendors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSearchVendorsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetUnclaimedVendorUrl = (uei: string,) => {




  return `/api/unclaimed-vendors/${uei}`
}

/**
 * @summary Detail view of a pre-seeded unclaimed vendor workspace
 */
export const getUnclaimedVendor = async (uei: string, options?: Parameters<typeof customFetch>[1]): Promise<UnclaimedVendorDetail> => {

  return customFetch<UnclaimedVendorDetail>(getGetUnclaimedVendorUrl(uei),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUnclaimedVendorQueryKey = (uei: string,) => {
    return [
    `/api/unclaimed-vendors/${uei}`
    ] as const;
    }


export const getGetUnclaimedVendorQueryOptions = <TData = Awaited<ReturnType<typeof getUnclaimedVendor>>, TError = ErrorType<void>>(uei: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedVendor>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnclaimedVendorQueryKey(uei);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnclaimedVendor>>> = ({ signal }) => getUnclaimedVendor(uei, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uei !== null && uei !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedVendor>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUnclaimedVendorQueryResult = NonNullable<Awaited<ReturnType<typeof getUnclaimedVendor>>>
export type GetUnclaimedVendorQueryError = ErrorType<void>


/**
 * @summary Detail view of a pre-seeded unclaimed vendor workspace
 */

export function useGetUnclaimedVendor<TData = Awaited<ReturnType<typeof getUnclaimedVendor>>, TError = ErrorType<void>>(
 uei: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUnclaimedVendor>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUnclaimedVendorQueryOptions(uei,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSamImportRunsUrl = (params?: ListSamImportRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/sam-imports?${stringifiedParams}` : `/api/admin/sam-imports`
}

/**
 * @summary List SAM monthly extract import runs
 */
export const listSamImportRuns = async (params?: ListSamImportRunsParams, options?: Parameters<typeof customFetch>[1]): Promise<SamImportRunsResponse> => {

  return customFetch<SamImportRunsResponse>(getListSamImportRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSamImportRunsQueryKey = (params?: ListSamImportRunsParams,) => {
    return [
    `/api/admin/sam-imports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSamImportRunsQueryOptions = <TData = Awaited<ReturnType<typeof listSamImportRuns>>, TError = ErrorType<unknown>>(params?: ListSamImportRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSamImportRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSamImportRunsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSamImportRuns>>> = ({ signal }) => listSamImportRuns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSamImportRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSamImportRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listSamImportRuns>>>
export type ListSamImportRunsQueryError = ErrorType<unknown>


/**
 * @summary List SAM monthly extract import runs
 */

export function useListSamImportRuns<TData = Awaited<ReturnType<typeof listSamImportRuns>>, TError = ErrorType<unknown>>(
 params?: ListSamImportRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSamImportRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSamImportRunsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getTriggerSamImportUrl = () => {




  return `/api/admin/sam-imports`
}

/**
 * @summary Trigger a SAM monthly extract import (background)
 */
export const triggerSamImport = async (triggerSamImportBody?: TriggerSamImportBody, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<void>(getTriggerSamImportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(triggerSamImportBody)
  }
);}





export const getTriggerSamImportMutationKey = () => ['triggerSamImport'] as const;

export const getTriggerSamImportMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerSamImport>>, TError,TriggerSamImportMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerSamImport>>, TError,TriggerSamImportMutationVariables, TContext> => {

const mutationKey = getTriggerSamImportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerSamImport>>, TriggerSamImportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  triggerSamImport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TriggerSamImportMutationResult = NonNullable<Awaited<ReturnType<typeof triggerSamImport>>>
    export type TriggerSamImportMutationBody = BodyType<TriggerSamImportBody> | undefined
    export type TriggerSamImportMutationError = ErrorType<void>
    export type TriggerSamImportMutationVariables = {data?: BodyType<TriggerSamImportBody>}

    /**
 * @summary Trigger a SAM monthly extract import (background)
 */
export const useTriggerSamImport = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerSamImport>>, TError,TriggerSamImportMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof triggerSamImport>>,
        TError,
        TriggerSamImportMutationVariables,
        TContext
      > => {
      return useMutation(getTriggerSamImportMutationOptions(options));
    }

export const getGetSearchFacetsUrl = () => {




  return `/api/search/facets`
}

/**
 * @summary Distinct values for filter facets
 */
export const getSearchFacets = async ( options?: Parameters<typeof customFetch>[1]): Promise<SearchFacets> => {

  return customFetch<SearchFacets>(getGetSearchFacetsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSearchFacetsQueryKey = () => {
    return [
    `/api/search/facets`
    ] as const;
    }


export const getGetSearchFacetsQueryOptions = <TData = Awaited<ReturnType<typeof getSearchFacets>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSearchFacets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchFacetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchFacets>>> = ({ signal }) => getSearchFacets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSearchFacets>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSearchFacetsQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchFacets>>>
export type GetSearchFacetsQueryError = ErrorType<unknown>


/**
 * @summary Distinct values for filter facets
 */

export function useGetSearchFacets<TData = Awaited<ReturnType<typeof getSearchFacets>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSearchFacets>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSearchFacetsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTeamingPostsUrl = (params?: ListTeamingPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teaming-posts?${stringifiedParams}` : `/api/teaming-posts`
}

export const listTeamingPosts = async (params?: ListTeamingPostsParams, options?: Parameters<typeof customFetch>[1]): Promise<TeamingPost[]> => {

  return customFetch<TeamingPost[]>(getListTeamingPostsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTeamingPostsQueryKey = (params?: ListTeamingPostsParams,) => {
    return [
    `/api/teaming-posts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTeamingPostsQueryOptions = <TData = Awaited<ReturnType<typeof listTeamingPosts>>, TError = ErrorType<unknown>>(params?: ListTeamingPostsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamingPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamingPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamingPosts>>> = ({ signal }) => listTeamingPosts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamingPosts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamingPostsQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamingPosts>>>
export type ListTeamingPostsQueryError = ErrorType<unknown>



export function useListTeamingPosts<TData = Awaited<ReturnType<typeof listTeamingPosts>>, TError = ErrorType<unknown>>(
 params?: ListTeamingPostsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamingPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamingPostsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTeamingPostUrl = () => {




  return `/api/teaming-posts`
}

export const createTeamingPost = async (teamingPostInput: TeamingPostInput, options?: Parameters<typeof customFetch>[1]): Promise<TeamingPost> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TeamingPost>(getCreateTeamingPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(teamingPostInput)
  }
);}





export const getCreateTeamingPostMutationKey = () => ['createTeamingPost'] as const;

export const getCreateTeamingPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamingPost>>, TError,CreateTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTeamingPost>>, TError,CreateTeamingPostMutationVariables, TContext> => {

const mutationKey = getCreateTeamingPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeamingPost>>, CreateTeamingPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTeamingPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTeamingPostMutationResult = NonNullable<Awaited<ReturnType<typeof createTeamingPost>>>
    export type CreateTeamingPostMutationBody = BodyType<TeamingPostInput>
    export type CreateTeamingPostMutationError = ErrorType<unknown>
    export type CreateTeamingPostMutationVariables = {data: BodyType<TeamingPostInput>}

    export const useCreateTeamingPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamingPost>>, TError,CreateTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTeamingPost>>,
        TError,
        CreateTeamingPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTeamingPostMutationOptions(options));
    }

export const getGetTeamingPostUrl = (id: string,) => {




  return `/api/teaming-posts/${id}`
}

export const getTeamingPost = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamingPost> => {

  return customFetch<TeamingPost>(getGetTeamingPostUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamingPostQueryKey = (id: string,) => {
    return [
    `/api/teaming-posts/${id}`
    ] as const;
    }


export const getGetTeamingPostQueryOptions = <TData = Awaited<ReturnType<typeof getTeamingPost>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamingPost>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamingPostQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamingPost>>> = ({ signal }) => getTeamingPost(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamingPost>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamingPostQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamingPost>>>
export type GetTeamingPostQueryError = ErrorType<unknown>



export function useGetTeamingPost<TData = Awaited<ReturnType<typeof getTeamingPost>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamingPost>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamingPostQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTeamingPostUrl = (id: string,) => {




  return `/api/teaming-posts/${id}`
}

export const updateTeamingPost = async (id: string,
    teamingPostUpdate: TeamingPostUpdate, options?: Parameters<typeof customFetch>[1]): Promise<TeamingPost> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TeamingPost>(getUpdateTeamingPostUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(teamingPostUpdate)
  }
);}





export const getUpdateTeamingPostMutationKey = () => ['updateTeamingPost'] as const;

export const getUpdateTeamingPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeamingPost>>, TError,UpdateTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTeamingPost>>, TError,UpdateTeamingPostMutationVariables, TContext> => {

const mutationKey = getUpdateTeamingPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTeamingPost>>, UpdateTeamingPostMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateTeamingPost(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTeamingPostMutationResult = NonNullable<Awaited<ReturnType<typeof updateTeamingPost>>>
    export type UpdateTeamingPostMutationBody = BodyType<TeamingPostUpdate>
    export type UpdateTeamingPostMutationError = ErrorType<unknown>
    export type UpdateTeamingPostMutationVariables = {id: string;data: BodyType<TeamingPostUpdate>}

    export const useUpdateTeamingPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeamingPost>>, TError,UpdateTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTeamingPost>>,
        TError,
        UpdateTeamingPostMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTeamingPostMutationOptions(options));
    }

export const getDeleteTeamingPostUrl = (id: string,) => {




  return `/api/teaming-posts/${id}`
}

/**
 * @summary Delete a draft teaming post (owner only)
 */
export const deleteTeamingPost = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteTeamingPostUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTeamingPostMutationKey = () => ['deleteTeamingPost'] as const;

export const getDeleteTeamingPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamingPost>>, TError,DeleteTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeamingPost>>, TError,DeleteTeamingPostMutationVariables, TContext> => {

const mutationKey = getDeleteTeamingPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeamingPost>>, DeleteTeamingPostMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteTeamingPost(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamingPostMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeamingPost>>>

    export type DeleteTeamingPostMutationError = ErrorType<unknown>
    export type DeleteTeamingPostMutationVariables = {id: string}

    /**
 * @summary Delete a draft teaming post (owner only)
 */
export const useDeleteTeamingPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamingPost>>, TError,DeleteTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeamingPost>>,
        TError,
        DeleteTeamingPostMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTeamingPostMutationOptions(options));
    }

export const getPublishTeamingPostUrl = (id: string,) => {




  return `/api/teaming-posts/${id}/publish`
}

export const publishTeamingPost = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamingPost> => {

  return customFetch<TeamingPost>(getPublishTeamingPostUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPublishTeamingPostMutationKey = () => ['publishTeamingPost'] as const;

export const getPublishTeamingPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishTeamingPost>>, TError,PublishTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publishTeamingPost>>, TError,PublishTeamingPostMutationVariables, TContext> => {

const mutationKey = getPublishTeamingPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishTeamingPost>>, PublishTeamingPostMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  publishTeamingPost(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishTeamingPostMutationResult = NonNullable<Awaited<ReturnType<typeof publishTeamingPost>>>

    export type PublishTeamingPostMutationError = ErrorType<unknown>
    export type PublishTeamingPostMutationVariables = {id: string}

    export const usePublishTeamingPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishTeamingPost>>, TError,PublishTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof publishTeamingPost>>,
        TError,
        PublishTeamingPostMutationVariables,
        TContext
      > => {
      return useMutation(getPublishTeamingPostMutationOptions(options));
    }

export const getCloseTeamingPostUrl = (id: string,) => {




  return `/api/teaming-posts/${id}/close`
}

export const closeTeamingPost = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamingPost> => {

  return customFetch<TeamingPost>(getCloseTeamingPostUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCloseTeamingPostMutationKey = () => ['closeTeamingPost'] as const;

export const getCloseTeamingPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeTeamingPost>>, TError,CloseTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof closeTeamingPost>>, TError,CloseTeamingPostMutationVariables, TContext> => {

const mutationKey = getCloseTeamingPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeTeamingPost>>, CloseTeamingPostMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  closeTeamingPost(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseTeamingPostMutationResult = NonNullable<Awaited<ReturnType<typeof closeTeamingPost>>>

    export type CloseTeamingPostMutationError = ErrorType<unknown>
    export type CloseTeamingPostMutationVariables = {id: string}

    export const useCloseTeamingPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeTeamingPost>>, TError,CloseTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof closeTeamingPost>>,
        TError,
        CloseTeamingPostMutationVariables,
        TContext
      > => {
      return useMutation(getCloseTeamingPostMutationOptions(options));
    }

export const getDuplicateTeamingPostUrl = (id: string,) => {




  return `/api/teaming-posts/${id}/duplicate`
}

/**
 * @summary Copy a post the tenant owns into a new draft
 */
export const duplicateTeamingPost = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamingPost> => {

  return customFetch<TeamingPost>(getDuplicateTeamingPostUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDuplicateTeamingPostMutationKey = () => ['duplicateTeamingPost'] as const;

export const getDuplicateTeamingPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateTeamingPost>>, TError,DuplicateTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateTeamingPost>>, TError,DuplicateTeamingPostMutationVariables, TContext> => {

const mutationKey = getDuplicateTeamingPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateTeamingPost>>, DuplicateTeamingPostMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  duplicateTeamingPost(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateTeamingPostMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateTeamingPost>>>

    export type DuplicateTeamingPostMutationError = ErrorType<unknown>
    export type DuplicateTeamingPostMutationVariables = {id: string}

    /**
 * @summary Copy a post the tenant owns into a new draft
 */
export const useDuplicateTeamingPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateTeamingPost>>, TError,DuplicateTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof duplicateTeamingPost>>,
        TError,
        DuplicateTeamingPostMutationVariables,
        TContext
      > => {
      return useMutation(getDuplicateTeamingPostMutationOptions(options));
    }

export const getListTeamingResponsesUrl = (id: string,) => {




  return `/api/teaming-posts/${id}/responses`
}

/**
 * @summary List responses (post owner sees all; others see only their own)
 */
export const listTeamingResponses = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamingResponse[]> => {

  return customFetch<TeamingResponse[]>(getListTeamingResponsesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTeamingResponsesQueryKey = (id: string,) => {
    return [
    `/api/teaming-posts/${id}/responses`
    ] as const;
    }


export const getListTeamingResponsesQueryOptions = <TData = Awaited<ReturnType<typeof listTeamingResponses>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamingResponses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamingResponsesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamingResponses>>> = ({ signal }) => listTeamingResponses(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamingResponses>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamingResponsesQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamingResponses>>>
export type ListTeamingResponsesQueryError = ErrorType<unknown>


/**
 * @summary List responses (post owner sees all; others see only their own)
 */

export function useListTeamingResponses<TData = Awaited<ReturnType<typeof listTeamingResponses>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamingResponses>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamingResponsesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateTeamingResponseUrl = (id: string,) => {




  return `/api/teaming-posts/${id}/responses`
}

/**
 * @summary Express interest in a teaming post
 */
export const createTeamingResponse = async (id: string,
    teamingResponseInput: TeamingResponseInput, options?: Parameters<typeof customFetch>[1]): Promise<TeamingResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TeamingResponse>(getCreateTeamingResponseUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(teamingResponseInput)
  }
);}





export const getCreateTeamingResponseMutationKey = () => ['createTeamingResponse'] as const;

export const getCreateTeamingResponseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamingResponse>>, TError,CreateTeamingResponseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTeamingResponse>>, TError,CreateTeamingResponseMutationVariables, TContext> => {

const mutationKey = getCreateTeamingResponseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeamingResponse>>, CreateTeamingResponseMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  createTeamingResponse(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTeamingResponseMutationResult = NonNullable<Awaited<ReturnType<typeof createTeamingResponse>>>
    export type CreateTeamingResponseMutationBody = BodyType<TeamingResponseInput>
    export type CreateTeamingResponseMutationError = ErrorType<unknown>
    export type CreateTeamingResponseMutationVariables = {id: string;data: BodyType<TeamingResponseInput>}

    /**
 * @summary Express interest in a teaming post
 */
export const useCreateTeamingResponse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamingResponse>>, TError,CreateTeamingResponseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTeamingResponse>>,
        TError,
        CreateTeamingResponseMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTeamingResponseMutationOptions(options));
    }

export const getWithdrawTeamingResponseUrl = (id: string,) => {




  return `/api/teaming-responses/${id}`
}

/**
 * @summary Withdraw a previously submitted response
 */
export const withdrawTeamingResponse = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getWithdrawTeamingResponseUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getWithdrawTeamingResponseMutationKey = () => ['withdrawTeamingResponse'] as const;

export const getWithdrawTeamingResponseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawTeamingResponse>>, TError,WithdrawTeamingResponseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof withdrawTeamingResponse>>, TError,WithdrawTeamingResponseMutationVariables, TContext> => {

const mutationKey = getWithdrawTeamingResponseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof withdrawTeamingResponse>>, WithdrawTeamingResponseMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  withdrawTeamingResponse(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WithdrawTeamingResponseMutationResult = NonNullable<Awaited<ReturnType<typeof withdrawTeamingResponse>>>

    export type WithdrawTeamingResponseMutationError = ErrorType<unknown>
    export type WithdrawTeamingResponseMutationVariables = {id: string}

    /**
 * @summary Withdraw a previously submitted response
 */
export const useWithdrawTeamingResponse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawTeamingResponse>>, TError,WithdrawTeamingResponseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof withdrawTeamingResponse>>,
        TError,
        WithdrawTeamingResponseMutationVariables,
        TContext
      > => {
      return useMutation(getWithdrawTeamingResponseMutationOptions(options));
    }

export const getSaveTeamingPostUrl = (id: string,) => {




  return `/api/teaming-posts/${id}/save`
}

export const saveTeamingPost = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamingSaveState> => {

  return customFetch<TeamingSaveState>(getSaveTeamingPostUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSaveTeamingPostMutationKey = () => ['saveTeamingPost'] as const;

export const getSaveTeamingPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTeamingPost>>, TError,SaveTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveTeamingPost>>, TError,SaveTeamingPostMutationVariables, TContext> => {

const mutationKey = getSaveTeamingPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveTeamingPost>>, SaveTeamingPostMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  saveTeamingPost(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveTeamingPostMutationResult = NonNullable<Awaited<ReturnType<typeof saveTeamingPost>>>

    export type SaveTeamingPostMutationError = ErrorType<unknown>
    export type SaveTeamingPostMutationVariables = {id: string}

    export const useSaveTeamingPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveTeamingPost>>, TError,SaveTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveTeamingPost>>,
        TError,
        SaveTeamingPostMutationVariables,
        TContext
      > => {
      return useMutation(getSaveTeamingPostMutationOptions(options));
    }

export const getUnsaveTeamingPostUrl = (id: string,) => {




  return `/api/teaming-posts/${id}/save`
}

export const unsaveTeamingPost = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamingSaveState> => {

  return customFetch<TeamingSaveState>(getUnsaveTeamingPostUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnsaveTeamingPostMutationKey = () => ['unsaveTeamingPost'] as const;

export const getUnsaveTeamingPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsaveTeamingPost>>, TError,UnsaveTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unsaveTeamingPost>>, TError,UnsaveTeamingPostMutationVariables, TContext> => {

const mutationKey = getUnsaveTeamingPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unsaveTeamingPost>>, UnsaveTeamingPostMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  unsaveTeamingPost(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnsaveTeamingPostMutationResult = NonNullable<Awaited<ReturnType<typeof unsaveTeamingPost>>>

    export type UnsaveTeamingPostMutationError = ErrorType<unknown>
    export type UnsaveTeamingPostMutationVariables = {id: string}

    export const useUnsaveTeamingPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsaveTeamingPost>>, TError,UnsaveTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unsaveTeamingPost>>,
        TError,
        UnsaveTeamingPostMutationVariables,
        TContext
      > => {
      return useMutation(getUnsaveTeamingPostMutationOptions(options));
    }

export const getGetTeamingSummaryUrl = () => {




  return `/api/teaming/summary`
}

export const getTeamingSummary = async ( options?: Parameters<typeof customFetch>[1]): Promise<TeamingSummary> => {

  return customFetch<TeamingSummary>(getGetTeamingSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamingSummaryQueryKey = () => {
    return [
    `/api/teaming/summary`
    ] as const;
    }


export const getGetTeamingSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getTeamingSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamingSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamingSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamingSummary>>> = ({ signal }) => getTeamingSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamingSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamingSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamingSummary>>>
export type GetTeamingSummaryQueryError = ErrorType<unknown>



export function useGetTeamingSummary<TData = Awaited<ReturnType<typeof getTeamingSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamingSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamingSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTeamingForYouUrl = (params?: ListTeamingForYouParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/teaming/for-you?${stringifiedParams}` : `/api/teaming/for-you`
}

/**
 * @summary Active network posts ranked by evidence-based vendor-to-post match
 */
export const listTeamingForYou = async (params?: ListTeamingForYouParams, options?: Parameters<typeof customFetch>[1]): Promise<TeamingForYouPost[]> => {

  return customFetch<TeamingForYouPost[]>(getListTeamingForYouUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTeamingForYouQueryKey = (params?: ListTeamingForYouParams,) => {
    return [
    `/api/teaming/for-you`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTeamingForYouQueryOptions = <TData = Awaited<ReturnType<typeof listTeamingForYou>>, TError = ErrorType<unknown>>(params?: ListTeamingForYouParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamingForYou>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamingForYouQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamingForYou>>> = ({ signal }) => listTeamingForYou(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamingForYou>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamingForYouQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamingForYou>>>
export type ListTeamingForYouQueryError = ErrorType<unknown>


/**
 * @summary Active network posts ranked by evidence-based vendor-to-post match
 */

export function useListTeamingForYou<TData = Awaited<ReturnType<typeof listTeamingForYou>>, TError = ErrorType<unknown>>(
 params?: ListTeamingForYouParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamingForYou>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamingForYouQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTeamingRecommendedVendorsUrl = () => {




  return `/api/teaming/recommended-vendors`
}

/**
 * @summary Up to 3 vendors recommended for the current tenant's teaming criteria
 */
export const getTeamingRecommendedVendors = async ( options?: Parameters<typeof customFetch>[1]): Promise<TeamingRecommendedVendors> => {

  return customFetch<TeamingRecommendedVendors>(getGetTeamingRecommendedVendorsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamingRecommendedVendorsQueryKey = () => {
    return [
    `/api/teaming/recommended-vendors`
    ] as const;
    }


export const getGetTeamingRecommendedVendorsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamingRecommendedVendors>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamingRecommendedVendors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamingRecommendedVendorsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamingRecommendedVendors>>> = ({ signal }) => getTeamingRecommendedVendors({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamingRecommendedVendors>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamingRecommendedVendorsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamingRecommendedVendors>>>
export type GetTeamingRecommendedVendorsQueryError = ErrorType<unknown>


/**
 * @summary Up to 3 vendors recommended for the current tenant's teaming criteria
 */

export function useGetTeamingRecommendedVendors<TData = Awaited<ReturnType<typeof getTeamingRecommendedVendors>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamingRecommendedVendors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamingRecommendedVendorsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTeamingActivityUrl = () => {




  return `/api/teaming/activity`
}

/**
 * @summary Tenant-scoped recent teaming activity feed
 */
export const getTeamingActivity = async ( options?: Parameters<typeof customFetch>[1]): Promise<TeamingActivityEvent[]> => {

  return customFetch<TeamingActivityEvent[]>(getGetTeamingActivityUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamingActivityQueryKey = () => {
    return [
    `/api/teaming/activity`
    ] as const;
    }


export const getGetTeamingActivityQueryOptions = <TData = Awaited<ReturnType<typeof getTeamingActivity>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamingActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamingActivityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamingActivity>>> = ({ signal }) => getTeamingActivity({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamingActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamingActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamingActivity>>>
export type GetTeamingActivityQueryError = ErrorType<unknown>


/**
 * @summary Tenant-scoped recent teaming activity feed
 */

export function useGetTeamingActivity<TData = Awaited<ReturnType<typeof getTeamingActivity>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamingActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamingActivityQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTeamBuilderAnalysisUrl = (params: GetTeamBuilderAnalysisParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/team-builder/analysis?${stringifiedParams}` : `/api/team-builder/analysis`
}

/**
 * @summary Coverage/gap analysis for the current tenant against an opportunity, with recommended partners
 */
export const getTeamBuilderAnalysis = async (params: GetTeamBuilderAnalysisParams, options?: Parameters<typeof customFetch>[1]): Promise<TeamBuilderAnalysis> => {

  return customFetch<TeamBuilderAnalysis>(getGetTeamBuilderAnalysisUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamBuilderAnalysisQueryKey = (params?: GetTeamBuilderAnalysisParams,) => {
    return [
    `/api/team-builder/analysis`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamBuilderAnalysisQueryOptions = <TData = Awaited<ReturnType<typeof getTeamBuilderAnalysis>>, TError = ErrorType<ApiError>>(params: GetTeamBuilderAnalysisParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamBuilderAnalysis>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamBuilderAnalysisQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamBuilderAnalysis>>> = ({ signal }) => getTeamBuilderAnalysis(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamBuilderAnalysis>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamBuilderAnalysisQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamBuilderAnalysis>>>
export type GetTeamBuilderAnalysisQueryError = ErrorType<ApiError>


/**
 * @summary Coverage/gap analysis for the current tenant against an opportunity, with recommended partners
 */

export function useGetTeamBuilderAnalysis<TData = Awaited<ReturnType<typeof getTeamBuilderAnalysis>>, TError = ErrorType<ApiError>>(
 params: GetTeamBuilderAnalysisParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamBuilderAnalysis>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamBuilderAnalysisQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListDraftTeamsUrl = () => {




  return `/api/draft-teams`
}

/**
 * @summary List the current tenant's draft teams
 */
export const listDraftTeams = async ( options?: Parameters<typeof customFetch>[1]): Promise<DraftTeam[]> => {

  return customFetch<DraftTeam[]>(getListDraftTeamsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDraftTeamsQueryKey = () => {
    return [
    `/api/draft-teams`
    ] as const;
    }


export const getListDraftTeamsQueryOptions = <TData = Awaited<ReturnType<typeof listDraftTeams>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDraftTeams>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDraftTeamsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDraftTeams>>> = ({ signal }) => listDraftTeams({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDraftTeams>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDraftTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof listDraftTeams>>>
export type ListDraftTeamsQueryError = ErrorType<unknown>


/**
 * @summary List the current tenant's draft teams
 */

export function useListDraftTeams<TData = Awaited<ReturnType<typeof listDraftTeams>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDraftTeams>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDraftTeamsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateDraftTeamUrl = () => {




  return `/api/draft-teams`
}

/**
 * @summary Save a new draft team
 */
export const createDraftTeam = async (createDraftTeamBody: CreateDraftTeamBody, options?: Parameters<typeof customFetch>[1]): Promise<DraftTeam> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<DraftTeam>(getCreateDraftTeamUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createDraftTeamBody)
  }
);}





export const getCreateDraftTeamMutationKey = () => ['createDraftTeam'] as const;

export const getCreateDraftTeamMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDraftTeam>>, TError,CreateDraftTeamMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDraftTeam>>, TError,CreateDraftTeamMutationVariables, TContext> => {

const mutationKey = getCreateDraftTeamMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDraftTeam>>, CreateDraftTeamMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createDraftTeam(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDraftTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createDraftTeam>>>
    export type CreateDraftTeamMutationBody = BodyType<CreateDraftTeamBody>
    export type CreateDraftTeamMutationError = ErrorType<ApiError>
    export type CreateDraftTeamMutationVariables = {data: BodyType<CreateDraftTeamBody>}

    /**
 * @summary Save a new draft team
 */
export const useCreateDraftTeam = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDraftTeam>>, TError,CreateDraftTeamMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDraftTeam>>,
        TError,
        CreateDraftTeamMutationVariables,
        TContext
      > => {
      return useMutation(getCreateDraftTeamMutationOptions(options));
    }

export const getListDraftTeamInvitesUrl = () => {




  return `/api/draft-team-invites`
}

/**
 * @summary List draft team invitations for the current tenant
 */
export const listDraftTeamInvites = async ( options?: Parameters<typeof customFetch>[1]): Promise<DraftTeamInvite[]> => {

  return customFetch<DraftTeamInvite[]>(getListDraftTeamInvitesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDraftTeamInvitesQueryKey = () => {
    return [
    `/api/draft-team-invites`
    ] as const;
    }


export const getListDraftTeamInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listDraftTeamInvites>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDraftTeamInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDraftTeamInvitesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDraftTeamInvites>>> = ({ signal }) => listDraftTeamInvites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDraftTeamInvites>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDraftTeamInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listDraftTeamInvites>>>
export type ListDraftTeamInvitesQueryError = ErrorType<unknown>


/**
 * @summary List draft team invitations for the current tenant
 */

export function useListDraftTeamInvites<TData = Awaited<ReturnType<typeof listDraftTeamInvites>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDraftTeamInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDraftTeamInvitesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetDraftTeamUrl = (id: string,) => {




  return `/api/draft-teams/${id}`
}

/**
 * @summary Reopen a draft team (owner tenant only)
 */
export const getDraftTeam = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<DraftTeam> => {

  return customFetch<DraftTeam>(getGetDraftTeamUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDraftTeamQueryKey = (id: string,) => {
    return [
    `/api/draft-teams/${id}`
    ] as const;
    }


export const getGetDraftTeamQueryOptions = <TData = Awaited<ReturnType<typeof getDraftTeam>>, TError = ErrorType<ApiError>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDraftTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDraftTeamQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDraftTeam>>> = ({ signal }) => getDraftTeam(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDraftTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDraftTeamQueryResult = NonNullable<Awaited<ReturnType<typeof getDraftTeam>>>
export type GetDraftTeamQueryError = ErrorType<ApiError>


/**
 * @summary Reopen a draft team (owner tenant only)
 */

export function useGetDraftTeam<TData = Awaited<ReturnType<typeof getDraftTeam>>, TError = ErrorType<ApiError>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDraftTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDraftTeamQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateDraftTeamUrl = (id: string,) => {




  return `/api/draft-teams/${id}`
}

/**
 * @summary Update a draft team (name, notes, opportunity, or full member list)
 */
export const updateDraftTeam = async (id: string,
    updateDraftTeamBody: UpdateDraftTeamBody, options?: Parameters<typeof customFetch>[1]): Promise<DraftTeam> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<DraftTeam>(getUpdateDraftTeamUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateDraftTeamBody)
  }
);}





export const getUpdateDraftTeamMutationKey = () => ['updateDraftTeam'] as const;

export const getUpdateDraftTeamMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeam>>, TError,UpdateDraftTeamMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeam>>, TError,UpdateDraftTeamMutationVariables, TContext> => {

const mutationKey = getUpdateDraftTeamMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDraftTeam>>, UpdateDraftTeamMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateDraftTeam(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDraftTeamMutationResult = NonNullable<Awaited<ReturnType<typeof updateDraftTeam>>>
    export type UpdateDraftTeamMutationBody = BodyType<UpdateDraftTeamBody>
    export type UpdateDraftTeamMutationError = ErrorType<ApiError>
    export type UpdateDraftTeamMutationVariables = {id: string;data: BodyType<UpdateDraftTeamBody>}

    /**
 * @summary Update a draft team (name, notes, opportunity, or full member list)
 */
export const useUpdateDraftTeam = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeam>>, TError,UpdateDraftTeamMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDraftTeam>>,
        TError,
        UpdateDraftTeamMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateDraftTeamMutationOptions(options));
    }

export const getDeleteDraftTeamUrl = (id: string,) => {




  return `/api/draft-teams/${id}`
}

/**
 * @summary Delete a draft team (owner tenant only)
 */
export const deleteDraftTeam = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteDraftTeamUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDraftTeamMutationKey = () => ['deleteDraftTeam'] as const;

export const getDeleteDraftTeamMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeam>>, TError,DeleteDraftTeamMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeam>>, TError,DeleteDraftTeamMutationVariables, TContext> => {

const mutationKey = getDeleteDraftTeamMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDraftTeam>>, DeleteDraftTeamMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteDraftTeam(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDraftTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDraftTeam>>>

    export type DeleteDraftTeamMutationError = ErrorType<ApiError>
    export type DeleteDraftTeamMutationVariables = {id: string}

    /**
 * @summary Delete a draft team (owner tenant only)
 */
export const useDeleteDraftTeam = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeam>>, TError,DeleteDraftTeamMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDraftTeam>>,
        TError,
        DeleteDraftTeamMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteDraftTeamMutationOptions(options));
    }

export const getConfirmDraftTeamUrl = (id: string,) => {




  return `/api/draft-teams/${id}/confirm`
}

/**
 * @summary Mark a draft team as confirmed (arrangement confirmed with partner(s))
 */
export const confirmDraftTeam = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<DraftTeam> => {

  return customFetch<DraftTeam>(getConfirmDraftTeamUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getConfirmDraftTeamMutationKey = () => ['confirmDraftTeam'] as const;

export const getConfirmDraftTeamMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmDraftTeam>>, TError,ConfirmDraftTeamMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmDraftTeam>>, TError,ConfirmDraftTeamMutationVariables, TContext> => {

const mutationKey = getConfirmDraftTeamMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmDraftTeam>>, ConfirmDraftTeamMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  confirmDraftTeam(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmDraftTeamMutationResult = NonNullable<Awaited<ReturnType<typeof confirmDraftTeam>>>

    export type ConfirmDraftTeamMutationError = ErrorType<ApiError>
    export type ConfirmDraftTeamMutationVariables = {id: string}

    /**
 * @summary Mark a draft team as confirmed (arrangement confirmed with partner(s))
 */
export const useConfirmDraftTeam = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmDraftTeam>>, TError,ConfirmDraftTeamMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof confirmDraftTeam>>,
        TError,
        ConfirmDraftTeamMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmDraftTeamMutationOptions(options));
    }

export const getAcceptDraftTeamAsOwnerUrl = (id: string,) => {




  return `/api/draft-teams/${id}/owner-accept`
}

/**
 * @summary Explicitly accept a draft team as its owner
 */
export const acceptDraftTeamAsOwner = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<DraftTeam> => {

  return customFetch<DraftTeam>(getAcceptDraftTeamAsOwnerUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAcceptDraftTeamAsOwnerMutationKey = () => ['acceptDraftTeamAsOwner'] as const;

export const getAcceptDraftTeamAsOwnerMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptDraftTeamAsOwner>>, TError,AcceptDraftTeamAsOwnerMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptDraftTeamAsOwner>>, TError,AcceptDraftTeamAsOwnerMutationVariables, TContext> => {

const mutationKey = getAcceptDraftTeamAsOwnerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptDraftTeamAsOwner>>, AcceptDraftTeamAsOwnerMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  acceptDraftTeamAsOwner(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptDraftTeamAsOwnerMutationResult = NonNullable<Awaited<ReturnType<typeof acceptDraftTeamAsOwner>>>

    export type AcceptDraftTeamAsOwnerMutationError = ErrorType<ApiError>
    export type AcceptDraftTeamAsOwnerMutationVariables = {id: string}

    /**
 * @summary Explicitly accept a draft team as its owner
 */
export const useAcceptDraftTeamAsOwner = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptDraftTeamAsOwner>>, TError,AcceptDraftTeamAsOwnerMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptDraftTeamAsOwner>>,
        TError,
        AcceptDraftTeamAsOwnerMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptDraftTeamAsOwnerMutationOptions(options));
    }

export const getGetDraftTeamWorkspaceUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace`
}

/**
 * @summary Read a private team workspace
 */
export const getDraftTeamWorkspace = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspace> => {

  return customFetch<TeamWorkspace>(getGetDraftTeamWorkspaceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDraftTeamWorkspaceQueryKey = (id: string,) => {
    return [
    `/api/draft-teams/${id}/workspace`
    ] as const;
    }


export const getGetDraftTeamWorkspaceQueryOptions = <TData = Awaited<ReturnType<typeof getDraftTeamWorkspace>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDraftTeamWorkspace>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDraftTeamWorkspaceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDraftTeamWorkspace>>> = ({ signal }) => getDraftTeamWorkspace(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDraftTeamWorkspace>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDraftTeamWorkspaceQueryResult = NonNullable<Awaited<ReturnType<typeof getDraftTeamWorkspace>>>
export type GetDraftTeamWorkspaceQueryError = ErrorType<void>


/**
 * @summary Read a private team workspace
 */

export function useGetDraftTeamWorkspace<TData = Awaited<ReturnType<typeof getDraftTeamWorkspace>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDraftTeamWorkspace>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDraftTeamWorkspaceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddDraftTeamWorkspaceNoteUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace`
}

/**
 * @summary Add a shared note to a private team workspace
 */
export const addDraftTeamWorkspaceNote = async (id: string,
    addDraftTeamWorkspaceNoteBody: AddDraftTeamWorkspaceNoteBody, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspaceNote> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TeamWorkspaceNote>(getAddDraftTeamWorkspaceNoteUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addDraftTeamWorkspaceNoteBody)
  }
);}





export const getAddDraftTeamWorkspaceNoteMutationKey = () => ['addDraftTeamWorkspaceNote'] as const;

export const getAddDraftTeamWorkspaceNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDraftTeamWorkspaceNote>>, TError,AddDraftTeamWorkspaceNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addDraftTeamWorkspaceNote>>, TError,AddDraftTeamWorkspaceNoteMutationVariables, TContext> => {

const mutationKey = getAddDraftTeamWorkspaceNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addDraftTeamWorkspaceNote>>, AddDraftTeamWorkspaceNoteMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  addDraftTeamWorkspaceNote(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddDraftTeamWorkspaceNoteMutationResult = NonNullable<Awaited<ReturnType<typeof addDraftTeamWorkspaceNote>>>
    export type AddDraftTeamWorkspaceNoteMutationBody = BodyType<AddDraftTeamWorkspaceNoteBody>
    export type AddDraftTeamWorkspaceNoteMutationError = ErrorType<void>
    export type AddDraftTeamWorkspaceNoteMutationVariables = {id: string;data: BodyType<AddDraftTeamWorkspaceNoteBody>}

    /**
 * @summary Add a shared note to a private team workspace
 */
export const useAddDraftTeamWorkspaceNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDraftTeamWorkspaceNote>>, TError,AddDraftTeamWorkspaceNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addDraftTeamWorkspaceNote>>,
        TError,
        AddDraftTeamWorkspaceNoteMutationVariables,
        TContext
      > => {
      return useMutation(getAddDraftTeamWorkspaceNoteMutationOptions(options));
    }

export const getUpdateDraftTeamWorkspaceUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace`
}

/**
 * @summary Update shared workspace objectives
 */
export const updateDraftTeamWorkspace = async (id: string,
    workspaceObjectivesBody: WorkspaceObjectivesBody, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspace> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TeamWorkspace>(getUpdateDraftTeamWorkspaceUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workspaceObjectivesBody)
  }
);}





export const getUpdateDraftTeamWorkspaceMutationKey = () => ['updateDraftTeamWorkspace'] as const;

export const getUpdateDraftTeamWorkspaceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspace>>, TError,UpdateDraftTeamWorkspaceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspace>>, TError,UpdateDraftTeamWorkspaceMutationVariables, TContext> => {

const mutationKey = getUpdateDraftTeamWorkspaceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDraftTeamWorkspace>>, UpdateDraftTeamWorkspaceMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateDraftTeamWorkspace(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDraftTeamWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof updateDraftTeamWorkspace>>>
    export type UpdateDraftTeamWorkspaceMutationBody = BodyType<WorkspaceObjectivesBody>
    export type UpdateDraftTeamWorkspaceMutationError = ErrorType<void>
    export type UpdateDraftTeamWorkspaceMutationVariables = {id: string;data: BodyType<WorkspaceObjectivesBody>}

    /**
 * @summary Update shared workspace objectives
 */
export const useUpdateDraftTeamWorkspace = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspace>>, TError,UpdateDraftTeamWorkspaceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDraftTeamWorkspace>>,
        TError,
        UpdateDraftTeamWorkspaceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateDraftTeamWorkspaceMutationOptions(options));
    }

export const getAskDraftTeamWorkspaceAssistantUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace/assistant`
}

/**
 * @summary Continue a private proposal-management conversation
 */
export const askDraftTeamWorkspaceAssistant = async (id: string,
    workspaceAssistantInput: WorkspaceAssistantInput, options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceAssistantResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<WorkspaceAssistantResponse>(getAskDraftTeamWorkspaceAssistantUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workspaceAssistantInput)
  }
);}





export const getAskDraftTeamWorkspaceAssistantMutationKey = () => ['askDraftTeamWorkspaceAssistant'] as const;

export const getAskDraftTeamWorkspaceAssistantMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof askDraftTeamWorkspaceAssistant>>, TError,AskDraftTeamWorkspaceAssistantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof askDraftTeamWorkspaceAssistant>>, TError,AskDraftTeamWorkspaceAssistantMutationVariables, TContext> => {

const mutationKey = getAskDraftTeamWorkspaceAssistantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof askDraftTeamWorkspaceAssistant>>, AskDraftTeamWorkspaceAssistantMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  askDraftTeamWorkspaceAssistant(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AskDraftTeamWorkspaceAssistantMutationResult = NonNullable<Awaited<ReturnType<typeof askDraftTeamWorkspaceAssistant>>>
    export type AskDraftTeamWorkspaceAssistantMutationBody = BodyType<WorkspaceAssistantInput>
    export type AskDraftTeamWorkspaceAssistantMutationError = ErrorType<void>
    export type AskDraftTeamWorkspaceAssistantMutationVariables = {id: string;data: BodyType<WorkspaceAssistantInput>}

    /**
 * @summary Continue a private proposal-management conversation
 */
export const useAskDraftTeamWorkspaceAssistant = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof askDraftTeamWorkspaceAssistant>>, TError,AskDraftTeamWorkspaceAssistantMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof askDraftTeamWorkspaceAssistant>>,
        TError,
        AskDraftTeamWorkspaceAssistantMutationVariables,
        TContext
      > => {
      return useMutation(getAskDraftTeamWorkspaceAssistantMutationOptions(options));
    }

export const getListDraftTeamWorkspaceAssistantConversationsUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace/assistant/conversations`
}

/**
 * @summary List the current member's private workspace conversations
 */
export const listDraftTeamWorkspaceAssistantConversations = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceAssistantConversation[]> => {

  return customFetch<WorkspaceAssistantConversation[]>(getListDraftTeamWorkspaceAssistantConversationsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDraftTeamWorkspaceAssistantConversationsQueryKey = (id: string,) => {
    return [
    `/api/draft-teams/${id}/workspace/assistant/conversations`
    ] as const;
    }


export const getListDraftTeamWorkspaceAssistantConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listDraftTeamWorkspaceAssistantConversations>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDraftTeamWorkspaceAssistantConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDraftTeamWorkspaceAssistantConversationsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDraftTeamWorkspaceAssistantConversations>>> = ({ signal }) => listDraftTeamWorkspaceAssistantConversations(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDraftTeamWorkspaceAssistantConversations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDraftTeamWorkspaceAssistantConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listDraftTeamWorkspaceAssistantConversations>>>
export type ListDraftTeamWorkspaceAssistantConversationsQueryError = ErrorType<void>


/**
 * @summary List the current member's private workspace conversations
 */

export function useListDraftTeamWorkspaceAssistantConversations<TData = Awaited<ReturnType<typeof listDraftTeamWorkspaceAssistantConversations>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDraftTeamWorkspaceAssistantConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDraftTeamWorkspaceAssistantConversationsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateDraftTeamWorkspaceAssistantConversationUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace/assistant/conversations`
}

/**
 * @summary Start a private workspace conversation
 */
export const createDraftTeamWorkspaceAssistantConversation = async (id: string,
    workspaceAssistantConversationInput: WorkspaceAssistantConversationInput, options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceAssistantConversationThread> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<WorkspaceAssistantConversationThread>(getCreateDraftTeamWorkspaceAssistantConversationUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workspaceAssistantConversationInput)
  }
);}





export const getCreateDraftTeamWorkspaceAssistantConversationMutationKey = () => ['createDraftTeamWorkspaceAssistantConversation'] as const;

export const getCreateDraftTeamWorkspaceAssistantConversationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDraftTeamWorkspaceAssistantConversation>>, TError,CreateDraftTeamWorkspaceAssistantConversationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDraftTeamWorkspaceAssistantConversation>>, TError,CreateDraftTeamWorkspaceAssistantConversationMutationVariables, TContext> => {

const mutationKey = getCreateDraftTeamWorkspaceAssistantConversationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDraftTeamWorkspaceAssistantConversation>>, CreateDraftTeamWorkspaceAssistantConversationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  createDraftTeamWorkspaceAssistantConversation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDraftTeamWorkspaceAssistantConversationMutationResult = NonNullable<Awaited<ReturnType<typeof createDraftTeamWorkspaceAssistantConversation>>>
    export type CreateDraftTeamWorkspaceAssistantConversationMutationBody = BodyType<WorkspaceAssistantConversationInput>
    export type CreateDraftTeamWorkspaceAssistantConversationMutationError = ErrorType<void>
    export type CreateDraftTeamWorkspaceAssistantConversationMutationVariables = {id: string;data: BodyType<WorkspaceAssistantConversationInput>}

    /**
 * @summary Start a private workspace conversation
 */
export const useCreateDraftTeamWorkspaceAssistantConversation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDraftTeamWorkspaceAssistantConversation>>, TError,CreateDraftTeamWorkspaceAssistantConversationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDraftTeamWorkspaceAssistantConversation>>,
        TError,
        CreateDraftTeamWorkspaceAssistantConversationMutationVariables,
        TContext
      > => {
      return useMutation(getCreateDraftTeamWorkspaceAssistantConversationMutationOptions(options));
    }

export const getGetDraftTeamWorkspaceAssistantConversationUrl = (id: string,
    conversationId: string,) => {




  return `/api/draft-teams/${id}/workspace/assistant/conversations/${conversationId}`
}

/**
 * @summary Return one of the current member's private conversations
 */
export const getDraftTeamWorkspaceAssistantConversation = async (id: string,
    conversationId: string, options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceAssistantConversationThread> => {

  return customFetch<WorkspaceAssistantConversationThread>(getGetDraftTeamWorkspaceAssistantConversationUrl(id,conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDraftTeamWorkspaceAssistantConversationQueryKey = (id: string,
    conversationId: string,) => {
    return [
    `/api/draft-teams/${id}/workspace/assistant/conversations/${conversationId}`
    ] as const;
    }


export const getGetDraftTeamWorkspaceAssistantConversationQueryOptions = <TData = Awaited<ReturnType<typeof getDraftTeamWorkspaceAssistantConversation>>, TError = ErrorType<void>>(id: string,
    conversationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDraftTeamWorkspaceAssistantConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDraftTeamWorkspaceAssistantConversationQueryKey(id,conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDraftTeamWorkspaceAssistantConversation>>> = ({ signal }) => getDraftTeamWorkspaceAssistantConversation(id,conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && conversationId !== null && conversationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDraftTeamWorkspaceAssistantConversation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDraftTeamWorkspaceAssistantConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getDraftTeamWorkspaceAssistantConversation>>>
export type GetDraftTeamWorkspaceAssistantConversationQueryError = ErrorType<void>


/**
 * @summary Return one of the current member's private conversations
 */

export function useGetDraftTeamWorkspaceAssistantConversation<TData = Awaited<ReturnType<typeof getDraftTeamWorkspaceAssistantConversation>>, TError = ErrorType<void>>(
 id: string,
    conversationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDraftTeamWorkspaceAssistantConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDraftTeamWorkspaceAssistantConversationQueryOptions(id,conversationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteDraftTeamWorkspaceAssistantConversationUrl = (id: string,
    conversationId: string,) => {




  return `/api/draft-teams/${id}/workspace/assistant/conversations/${conversationId}`
}

/**
 * @summary Delete one of the current member's private conversations
 */
export const deleteDraftTeamWorkspaceAssistantConversation = async (id: string,
    conversationId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteDraftTeamWorkspaceAssistantConversationUrl(id,conversationId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDraftTeamWorkspaceAssistantConversationMutationKey = () => ['deleteDraftTeamWorkspaceAssistantConversation'] as const;

export const getDeleteDraftTeamWorkspaceAssistantConversationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceAssistantConversation>>, TError,DeleteDraftTeamWorkspaceAssistantConversationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceAssistantConversation>>, TError,DeleteDraftTeamWorkspaceAssistantConversationMutationVariables, TContext> => {

const mutationKey = getDeleteDraftTeamWorkspaceAssistantConversationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceAssistantConversation>>, DeleteDraftTeamWorkspaceAssistantConversationMutationVariables> = (props) => {
          const {id,conversationId} = props ?? {};

          return  deleteDraftTeamWorkspaceAssistantConversation(id,conversationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDraftTeamWorkspaceAssistantConversationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceAssistantConversation>>>

    export type DeleteDraftTeamWorkspaceAssistantConversationMutationError = ErrorType<void>
    export type DeleteDraftTeamWorkspaceAssistantConversationMutationVariables = {id: string;conversationId: string}

    /**
 * @summary Delete one of the current member's private conversations
 */
export const useDeleteDraftTeamWorkspaceAssistantConversation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceAssistantConversation>>, TError,DeleteDraftTeamWorkspaceAssistantConversationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDraftTeamWorkspaceAssistantConversation>>,
        TError,
        DeleteDraftTeamWorkspaceAssistantConversationMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteDraftTeamWorkspaceAssistantConversationMutationOptions(options));
    }

export const getListDraftTeamWorkspacePursuitOptionsUrl = (id: string,
    params: ListDraftTeamWorkspacePursuitOptionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/draft-teams/${id}/workspace/pursuit-options?${stringifiedParams}` : `/api/draft-teams/${id}/workspace/pursuit-options`
}

/**
 * @summary Search opportunity sources that the current tenant may share with this workspace
 */
export const listDraftTeamWorkspacePursuitOptions = async (id: string,
    params: ListDraftTeamWorkspacePursuitOptionsParams, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspacePursuitOption[]> => {

  return customFetch<TeamWorkspacePursuitOption[]>(getListDraftTeamWorkspacePursuitOptionsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDraftTeamWorkspacePursuitOptionsQueryKey = (id: string,
    params?: ListDraftTeamWorkspacePursuitOptionsParams,) => {
    return [
    `/api/draft-teams/${id}/workspace/pursuit-options`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDraftTeamWorkspacePursuitOptionsQueryOptions = <TData = Awaited<ReturnType<typeof listDraftTeamWorkspacePursuitOptions>>, TError = ErrorType<void>>(id: string,
    params: ListDraftTeamWorkspacePursuitOptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDraftTeamWorkspacePursuitOptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDraftTeamWorkspacePursuitOptionsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDraftTeamWorkspacePursuitOptions>>> = ({ signal }) => listDraftTeamWorkspacePursuitOptions(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDraftTeamWorkspacePursuitOptions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDraftTeamWorkspacePursuitOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listDraftTeamWorkspacePursuitOptions>>>
export type ListDraftTeamWorkspacePursuitOptionsQueryError = ErrorType<void>


/**
 * @summary Search opportunity sources that the current tenant may share with this workspace
 */

export function useListDraftTeamWorkspacePursuitOptions<TData = Awaited<ReturnType<typeof listDraftTeamWorkspacePursuitOptions>>, TError = ErrorType<void>>(
 id: string,
    params: ListDraftTeamWorkspacePursuitOptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDraftTeamWorkspacePursuitOptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDraftTeamWorkspacePursuitOptionsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListDraftTeamWorkspacePursuitsUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace/pursuits`
}

/**
 * @summary List durable opportunity pursuits in a private team workspace
 */
export const listDraftTeamWorkspacePursuits = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspacePursuit[]> => {

  return customFetch<TeamWorkspacePursuit[]>(getListDraftTeamWorkspacePursuitsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDraftTeamWorkspacePursuitsQueryKey = (id: string,) => {
    return [
    `/api/draft-teams/${id}/workspace/pursuits`
    ] as const;
    }


export const getListDraftTeamWorkspacePursuitsQueryOptions = <TData = Awaited<ReturnType<typeof listDraftTeamWorkspacePursuits>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDraftTeamWorkspacePursuits>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDraftTeamWorkspacePursuitsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDraftTeamWorkspacePursuits>>> = ({ signal }) => listDraftTeamWorkspacePursuits(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDraftTeamWorkspacePursuits>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDraftTeamWorkspacePursuitsQueryResult = NonNullable<Awaited<ReturnType<typeof listDraftTeamWorkspacePursuits>>>
export type ListDraftTeamWorkspacePursuitsQueryError = ErrorType<void>


/**
 * @summary List durable opportunity pursuits in a private team workspace
 */

export function useListDraftTeamWorkspacePursuits<TData = Awaited<ReturnType<typeof listDraftTeamWorkspacePursuits>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDraftTeamWorkspacePursuits>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDraftTeamWorkspacePursuitsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddDraftTeamWorkspacePursuitUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace/pursuits`
}

/**
 * @summary Add an accessible opportunity source to a private team workspace
 */
export const addDraftTeamWorkspacePursuit = async (id: string,
    workspacePursuitInput: WorkspacePursuitInput, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspacePursuit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TeamWorkspacePursuit>(getAddDraftTeamWorkspacePursuitUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workspacePursuitInput)
  }
);}





export const getAddDraftTeamWorkspacePursuitMutationKey = () => ['addDraftTeamWorkspacePursuit'] as const;

export const getAddDraftTeamWorkspacePursuitMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDraftTeamWorkspacePursuit>>, TError,AddDraftTeamWorkspacePursuitMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addDraftTeamWorkspacePursuit>>, TError,AddDraftTeamWorkspacePursuitMutationVariables, TContext> => {

const mutationKey = getAddDraftTeamWorkspacePursuitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addDraftTeamWorkspacePursuit>>, AddDraftTeamWorkspacePursuitMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  addDraftTeamWorkspacePursuit(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddDraftTeamWorkspacePursuitMutationResult = NonNullable<Awaited<ReturnType<typeof addDraftTeamWorkspacePursuit>>>
    export type AddDraftTeamWorkspacePursuitMutationBody = BodyType<WorkspacePursuitInput>
    export type AddDraftTeamWorkspacePursuitMutationError = ErrorType<void>
    export type AddDraftTeamWorkspacePursuitMutationVariables = {id: string;data: BodyType<WorkspacePursuitInput>}

    /**
 * @summary Add an accessible opportunity source to a private team workspace
 */
export const useAddDraftTeamWorkspacePursuit = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDraftTeamWorkspacePursuit>>, TError,AddDraftTeamWorkspacePursuitMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addDraftTeamWorkspacePursuit>>,
        TError,
        AddDraftTeamWorkspacePursuitMutationVariables,
        TContext
      > => {
      return useMutation(getAddDraftTeamWorkspacePursuitMutationOptions(options));
    }

export const getUpdateDraftTeamWorkspacePursuitUrl = (id: string,
    pursuitId: string,) => {




  return `/api/draft-teams/${id}/workspace/pursuits/${pursuitId}`
}

/**
 * @summary Update workspace pursuit status
 */
export const updateDraftTeamWorkspacePursuit = async (id: string,
    pursuitId: string,
    workspacePursuitUpdate: WorkspacePursuitUpdate, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspacePursuit> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TeamWorkspacePursuit>(getUpdateDraftTeamWorkspacePursuitUrl(id,pursuitId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workspacePursuitUpdate)
  }
);}





export const getUpdateDraftTeamWorkspacePursuitMutationKey = () => ['updateDraftTeamWorkspacePursuit'] as const;

export const getUpdateDraftTeamWorkspacePursuitMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspacePursuit>>, TError,UpdateDraftTeamWorkspacePursuitMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspacePursuit>>, TError,UpdateDraftTeamWorkspacePursuitMutationVariables, TContext> => {

const mutationKey = getUpdateDraftTeamWorkspacePursuitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDraftTeamWorkspacePursuit>>, UpdateDraftTeamWorkspacePursuitMutationVariables> = (props) => {
          const {id,pursuitId,data} = props ?? {};

          return  updateDraftTeamWorkspacePursuit(id,pursuitId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDraftTeamWorkspacePursuitMutationResult = NonNullable<Awaited<ReturnType<typeof updateDraftTeamWorkspacePursuit>>>
    export type UpdateDraftTeamWorkspacePursuitMutationBody = BodyType<WorkspacePursuitUpdate>
    export type UpdateDraftTeamWorkspacePursuitMutationError = ErrorType<void>
    export type UpdateDraftTeamWorkspacePursuitMutationVariables = {id: string;pursuitId: string;data: BodyType<WorkspacePursuitUpdate>}

    /**
 * @summary Update workspace pursuit status
 */
export const useUpdateDraftTeamWorkspacePursuit = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspacePursuit>>, TError,UpdateDraftTeamWorkspacePursuitMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDraftTeamWorkspacePursuit>>,
        TError,
        UpdateDraftTeamWorkspacePursuitMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateDraftTeamWorkspacePursuitMutationOptions(options));
    }

export const getDeleteDraftTeamWorkspacePursuitUrl = (id: string,
    pursuitId: string,) => {




  return `/api/draft-teams/${id}/workspace/pursuits/${pursuitId}`
}

/**
 * @summary Remove a pursuit while retaining the workspace
 */
export const deleteDraftTeamWorkspacePursuit = async (id: string,
    pursuitId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteDraftTeamWorkspacePursuitUrl(id,pursuitId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDraftTeamWorkspacePursuitMutationKey = () => ['deleteDraftTeamWorkspacePursuit'] as const;

export const getDeleteDraftTeamWorkspacePursuitMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeamWorkspacePursuit>>, TError,DeleteDraftTeamWorkspacePursuitMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeamWorkspacePursuit>>, TError,DeleteDraftTeamWorkspacePursuitMutationVariables, TContext> => {

const mutationKey = getDeleteDraftTeamWorkspacePursuitMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDraftTeamWorkspacePursuit>>, DeleteDraftTeamWorkspacePursuitMutationVariables> = (props) => {
          const {id,pursuitId} = props ?? {};

          return  deleteDraftTeamWorkspacePursuit(id,pursuitId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDraftTeamWorkspacePursuitMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDraftTeamWorkspacePursuit>>>

    export type DeleteDraftTeamWorkspacePursuitMutationError = ErrorType<void>
    export type DeleteDraftTeamWorkspacePursuitMutationVariables = {id: string;pursuitId: string}

    /**
 * @summary Remove a pursuit while retaining the workspace
 */
export const useDeleteDraftTeamWorkspacePursuit = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeamWorkspacePursuit>>, TError,DeleteDraftTeamWorkspacePursuitMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDraftTeamWorkspacePursuit>>,
        TError,
        DeleteDraftTeamWorkspacePursuitMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteDraftTeamWorkspacePursuitMutationOptions(options));
    }

export const getListTeamWorkspacesUrl = () => {




  return `/api/team-workspaces`
}

/**
 * @summary List accessible confirmed team workspaces
 */
export const listTeamWorkspaces = async ( options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspace[]> => {

  return customFetch<TeamWorkspace[]>(getListTeamWorkspacesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTeamWorkspacesQueryKey = () => {
    return [
    `/api/team-workspaces`
    ] as const;
    }


export const getListTeamWorkspacesQueryOptions = <TData = Awaited<ReturnType<typeof listTeamWorkspaces>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamWorkspaces>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamWorkspacesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamWorkspaces>>> = ({ signal }) => listTeamWorkspaces({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamWorkspaces>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamWorkspacesQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamWorkspaces>>>
export type ListTeamWorkspacesQueryError = ErrorType<unknown>


/**
 * @summary List accessible confirmed team workspaces
 */

export function useListTeamWorkspaces<TData = Awaited<ReturnType<typeof listTeamWorkspaces>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamWorkspaces>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamWorkspacesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCloseDraftTeamWorkspaceUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace/close`
}

/**
 * @summary Close a confirmed team workspace
 */
export const closeDraftTeamWorkspace = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspace> => {

  return customFetch<TeamWorkspace>(getCloseDraftTeamWorkspaceUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCloseDraftTeamWorkspaceMutationKey = () => ['closeDraftTeamWorkspace'] as const;

export const getCloseDraftTeamWorkspaceMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeDraftTeamWorkspace>>, TError,CloseDraftTeamWorkspaceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof closeDraftTeamWorkspace>>, TError,CloseDraftTeamWorkspaceMutationVariables, TContext> => {

const mutationKey = getCloseDraftTeamWorkspaceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeDraftTeamWorkspace>>, CloseDraftTeamWorkspaceMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  closeDraftTeamWorkspace(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseDraftTeamWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof closeDraftTeamWorkspace>>>

    export type CloseDraftTeamWorkspaceMutationError = ErrorType<void>
    export type CloseDraftTeamWorkspaceMutationVariables = {id: string}

    /**
 * @summary Close a confirmed team workspace
 */
export const useCloseDraftTeamWorkspace = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeDraftTeamWorkspace>>, TError,CloseDraftTeamWorkspaceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof closeDraftTeamWorkspace>>,
        TError,
        CloseDraftTeamWorkspaceMutationVariables,
        TContext
      > => {
      return useMutation(getCloseDraftTeamWorkspaceMutationOptions(options));
    }

export const getCreateDraftTeamWorkspaceTaskUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace/tasks`
}

/**
 * @summary Add a shared proposal planning task
 */
export const createDraftTeamWorkspaceTask = async (id: string,
    workspaceTaskBody: WorkspaceTaskBody, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspaceTask> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TeamWorkspaceTask>(getCreateDraftTeamWorkspaceTaskUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workspaceTaskBody)
  }
);}





export const getCreateDraftTeamWorkspaceTaskMutationKey = () => ['createDraftTeamWorkspaceTask'] as const;

export const getCreateDraftTeamWorkspaceTaskMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDraftTeamWorkspaceTask>>, TError,CreateDraftTeamWorkspaceTaskMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDraftTeamWorkspaceTask>>, TError,CreateDraftTeamWorkspaceTaskMutationVariables, TContext> => {

const mutationKey = getCreateDraftTeamWorkspaceTaskMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDraftTeamWorkspaceTask>>, CreateDraftTeamWorkspaceTaskMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  createDraftTeamWorkspaceTask(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDraftTeamWorkspaceTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createDraftTeamWorkspaceTask>>>
    export type CreateDraftTeamWorkspaceTaskMutationBody = BodyType<WorkspaceTaskBody>
    export type CreateDraftTeamWorkspaceTaskMutationError = ErrorType<void>
    export type CreateDraftTeamWorkspaceTaskMutationVariables = {id: string;data: BodyType<WorkspaceTaskBody>}

    /**
 * @summary Add a shared proposal planning task
 */
export const useCreateDraftTeamWorkspaceTask = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDraftTeamWorkspaceTask>>, TError,CreateDraftTeamWorkspaceTaskMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDraftTeamWorkspaceTask>>,
        TError,
        CreateDraftTeamWorkspaceTaskMutationVariables,
        TContext
      > => {
      return useMutation(getCreateDraftTeamWorkspaceTaskMutationOptions(options));
    }

export const getUpdateDraftTeamWorkspaceTaskRemindersUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace/task-reminders`
}

/**
 * @summary Configure task deadline and overdue reminders for the current workspace member
 */
export const updateDraftTeamWorkspaceTaskReminders = async (id: string,
    workspaceTaskReminderPreferencesInput: WorkspaceTaskReminderPreferencesInput, options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceTaskReminderPreferences> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<WorkspaceTaskReminderPreferences>(getUpdateDraftTeamWorkspaceTaskRemindersUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workspaceTaskReminderPreferencesInput)
  }
);}





export const getUpdateDraftTeamWorkspaceTaskRemindersMutationKey = () => ['updateDraftTeamWorkspaceTaskReminders'] as const;

export const getUpdateDraftTeamWorkspaceTaskRemindersMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspaceTaskReminders>>, TError,UpdateDraftTeamWorkspaceTaskRemindersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspaceTaskReminders>>, TError,UpdateDraftTeamWorkspaceTaskRemindersMutationVariables, TContext> => {

const mutationKey = getUpdateDraftTeamWorkspaceTaskRemindersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDraftTeamWorkspaceTaskReminders>>, UpdateDraftTeamWorkspaceTaskRemindersMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateDraftTeamWorkspaceTaskReminders(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDraftTeamWorkspaceTaskRemindersMutationResult = NonNullable<Awaited<ReturnType<typeof updateDraftTeamWorkspaceTaskReminders>>>
    export type UpdateDraftTeamWorkspaceTaskRemindersMutationBody = BodyType<WorkspaceTaskReminderPreferencesInput>
    export type UpdateDraftTeamWorkspaceTaskRemindersMutationError = ErrorType<void>
    export type UpdateDraftTeamWorkspaceTaskRemindersMutationVariables = {id: string;data: BodyType<WorkspaceTaskReminderPreferencesInput>}

    /**
 * @summary Configure task deadline and overdue reminders for the current workspace member
 */
export const useUpdateDraftTeamWorkspaceTaskReminders = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspaceTaskReminders>>, TError,UpdateDraftTeamWorkspaceTaskRemindersMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDraftTeamWorkspaceTaskReminders>>,
        TError,
        UpdateDraftTeamWorkspaceTaskRemindersMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateDraftTeamWorkspaceTaskRemindersMutationOptions(options));
    }

export const getRequestTeamWorkspaceFileUploadUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace/files/request-upload`
}

/**
 * @summary Request a same-origin upload URL for a scoped workspace knowledge file
 */
export const requestTeamWorkspaceFileUpload = async (id: string,
    workspaceFileUploadBody: WorkspaceFileUploadBody, options?: Parameters<typeof customFetch>[1]): Promise<RequestTeamWorkspaceFileUpload200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<RequestTeamWorkspaceFileUpload200>(getRequestTeamWorkspaceFileUploadUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workspaceFileUploadBody)
  }
);}





export const getRequestTeamWorkspaceFileUploadMutationKey = () => ['requestTeamWorkspaceFileUpload'] as const;

export const getRequestTeamWorkspaceFileUploadMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestTeamWorkspaceFileUpload>>, TError,RequestTeamWorkspaceFileUploadMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestTeamWorkspaceFileUpload>>, TError,RequestTeamWorkspaceFileUploadMutationVariables, TContext> => {

const mutationKey = getRequestTeamWorkspaceFileUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestTeamWorkspaceFileUpload>>, RequestTeamWorkspaceFileUploadMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  requestTeamWorkspaceFileUpload(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestTeamWorkspaceFileUploadMutationResult = NonNullable<Awaited<ReturnType<typeof requestTeamWorkspaceFileUpload>>>
    export type RequestTeamWorkspaceFileUploadMutationBody = BodyType<WorkspaceFileUploadBody>
    export type RequestTeamWorkspaceFileUploadMutationError = ErrorType<void>
    export type RequestTeamWorkspaceFileUploadMutationVariables = {id: string;data: BodyType<WorkspaceFileUploadBody>}

    /**
 * @summary Request a same-origin upload URL for a scoped workspace knowledge file
 */
export const useRequestTeamWorkspaceFileUpload = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestTeamWorkspaceFileUpload>>, TError,RequestTeamWorkspaceFileUploadMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestTeamWorkspaceFileUpload>>,
        TError,
        RequestTeamWorkspaceFileUploadMutationVariables,
        TContext
      > => {
      return useMutation(getRequestTeamWorkspaceFileUploadMutationOptions(options));
    }

export const getListTeamWorkspaceFilesUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace/files`
}

/**
 * @summary List workspace files visible to the current member
 */
export const listTeamWorkspaceFiles = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspaceFile[]> => {

  return customFetch<TeamWorkspaceFile[]>(getListTeamWorkspaceFilesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTeamWorkspaceFilesQueryKey = (id: string,) => {
    return [
    `/api/draft-teams/${id}/workspace/files`
    ] as const;
    }


export const getListTeamWorkspaceFilesQueryOptions = <TData = Awaited<ReturnType<typeof listTeamWorkspaceFiles>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamWorkspaceFiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamWorkspaceFilesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamWorkspaceFiles>>> = ({ signal }) => listTeamWorkspaceFiles(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamWorkspaceFiles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamWorkspaceFilesQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamWorkspaceFiles>>>
export type ListTeamWorkspaceFilesQueryError = ErrorType<void>


/**
 * @summary List workspace files visible to the current member
 */

export function useListTeamWorkspaceFiles<TData = Awaited<ReturnType<typeof listTeamWorkspaceFiles>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamWorkspaceFiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamWorkspaceFilesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCompleteTeamWorkspaceFileUploadUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace/files`
}

/**
 * @summary Register a completed App Storage upload
 */
export const completeTeamWorkspaceFileUpload = async (id: string,
    workspaceFileCompleteBody: WorkspaceFileCompleteBody, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspaceFile> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TeamWorkspaceFile>(getCompleteTeamWorkspaceFileUploadUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workspaceFileCompleteBody)
  }
);}





export const getCompleteTeamWorkspaceFileUploadMutationKey = () => ['completeTeamWorkspaceFileUpload'] as const;

export const getCompleteTeamWorkspaceFileUploadMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTeamWorkspaceFileUpload>>, TError,CompleteTeamWorkspaceFileUploadMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeTeamWorkspaceFileUpload>>, TError,CompleteTeamWorkspaceFileUploadMutationVariables, TContext> => {

const mutationKey = getCompleteTeamWorkspaceFileUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeTeamWorkspaceFileUpload>>, CompleteTeamWorkspaceFileUploadMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  completeTeamWorkspaceFileUpload(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteTeamWorkspaceFileUploadMutationResult = NonNullable<Awaited<ReturnType<typeof completeTeamWorkspaceFileUpload>>>
    export type CompleteTeamWorkspaceFileUploadMutationBody = BodyType<WorkspaceFileCompleteBody>
    export type CompleteTeamWorkspaceFileUploadMutationError = ErrorType<void>
    export type CompleteTeamWorkspaceFileUploadMutationVariables = {id: string;data: BodyType<WorkspaceFileCompleteBody>}

    /**
 * @summary Register a completed App Storage upload
 */
export const useCompleteTeamWorkspaceFileUpload = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTeamWorkspaceFileUpload>>, TError,CompleteTeamWorkspaceFileUploadMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeTeamWorkspaceFileUpload>>,
        TError,
        CompleteTeamWorkspaceFileUploadMutationVariables,
        TContext
      > => {
      return useMutation(getCompleteTeamWorkspaceFileUploadMutationOptions(options));
    }

export const getUploadTeamWorkspaceFileBytesUrl = (id: string,
    params: UploadTeamWorkspaceFileBytesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/draft-teams/${id}/workspace/files/upload?${stringifiedParams}` : `/api/draft-teams/${id}/workspace/files/upload`
}

/**
 * @summary Upload shared workspace file bytes through the same origin
 */
export const uploadTeamWorkspaceFileBytes = async (id: string,
    uploadTeamWorkspaceFileBytesBody: Blob,
    params: UploadTeamWorkspaceFileBytesParams, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<void>(getUploadTeamWorkspaceFileBytesUrl(id,params),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/octet-stream', ...getHeaders(options?.headers) },
    body: uploadTeamWorkspaceFileBytesBody
  }
);}





export const getUploadTeamWorkspaceFileBytesMutationKey = () => ['uploadTeamWorkspaceFileBytes'] as const;

export const getUploadTeamWorkspaceFileBytesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadTeamWorkspaceFileBytes>>, TError,UploadTeamWorkspaceFileBytesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadTeamWorkspaceFileBytes>>, TError,UploadTeamWorkspaceFileBytesMutationVariables, TContext> => {

const mutationKey = getUploadTeamWorkspaceFileBytesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadTeamWorkspaceFileBytes>>, UploadTeamWorkspaceFileBytesMutationVariables> = (props) => {
          const {id,data,params} = props ?? {};

          return  uploadTeamWorkspaceFileBytes(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadTeamWorkspaceFileBytesMutationResult = NonNullable<Awaited<ReturnType<typeof uploadTeamWorkspaceFileBytes>>>
    export type UploadTeamWorkspaceFileBytesMutationBody = BodyType<Blob>
    export type UploadTeamWorkspaceFileBytesMutationError = ErrorType<void>
    export type UploadTeamWorkspaceFileBytesMutationVariables = {id: string;data: BodyType<Blob>;params: UploadTeamWorkspaceFileBytesParams}

    /**
 * @summary Upload shared workspace file bytes through the same origin
 */
export const useUploadTeamWorkspaceFileBytes = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadTeamWorkspaceFileBytes>>, TError,UploadTeamWorkspaceFileBytesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadTeamWorkspaceFileBytes>>,
        TError,
        UploadTeamWorkspaceFileBytesMutationVariables,
        TContext
      > => {
      return useMutation(getUploadTeamWorkspaceFileBytesMutationOptions(options));
    }

export const getDownloadTeamWorkspaceFileUrl = (id: string,
    fileId: string,) => {




  return `/api/draft-teams/${id}/workspace/files/${fileId}`
}

/**
 * @summary Download a shared workspace file
 */
export const downloadTeamWorkspaceFile = async (id: string,
    fileId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDownloadTeamWorkspaceFileUrl(id,fileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadTeamWorkspaceFileQueryKey = (id: string,
    fileId: string,) => {
    return [
    `/api/draft-teams/${id}/workspace/files/${fileId}`
    ] as const;
    }


export const getDownloadTeamWorkspaceFileQueryOptions = <TData = Awaited<ReturnType<typeof downloadTeamWorkspaceFile>>, TError = ErrorType<void>>(id: string,
    fileId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadTeamWorkspaceFile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadTeamWorkspaceFileQueryKey(id,fileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadTeamWorkspaceFile>>> = ({ signal }) => downloadTeamWorkspaceFile(id,fileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && fileId !== null && fileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadTeamWorkspaceFile>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadTeamWorkspaceFileQueryResult = NonNullable<Awaited<ReturnType<typeof downloadTeamWorkspaceFile>>>
export type DownloadTeamWorkspaceFileQueryError = ErrorType<void>


/**
 * @summary Download a shared workspace file
 */

export function useDownloadTeamWorkspaceFile<TData = Awaited<ReturnType<typeof downloadTeamWorkspaceFile>>, TError = ErrorType<void>>(
 id: string,
    fileId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadTeamWorkspaceFile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadTeamWorkspaceFileQueryOptions(id,fileId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteTeamWorkspaceFileUrl = (id: string,
    fileId: string,) => {




  return `/api/draft-teams/${id}/workspace/files/${fileId}`
}

/**
 * @summary Remove a shared workspace file
 */
export const deleteTeamWorkspaceFile = async (id: string,
    fileId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteTeamWorkspaceFileUrl(id,fileId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteTeamWorkspaceFileMutationKey = () => ['deleteTeamWorkspaceFile'] as const;

export const getDeleteTeamWorkspaceFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamWorkspaceFile>>, TError,DeleteTeamWorkspaceFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeamWorkspaceFile>>, TError,DeleteTeamWorkspaceFileMutationVariables, TContext> => {

const mutationKey = getDeleteTeamWorkspaceFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeamWorkspaceFile>>, DeleteTeamWorkspaceFileMutationVariables> = (props) => {
          const {id,fileId} = props ?? {};

          return  deleteTeamWorkspaceFile(id,fileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamWorkspaceFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeamWorkspaceFile>>>

    export type DeleteTeamWorkspaceFileMutationError = ErrorType<void>
    export type DeleteTeamWorkspaceFileMutationVariables = {id: string;fileId: string}

    /**
 * @summary Remove a shared workspace file
 */
export const useDeleteTeamWorkspaceFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamWorkspaceFile>>, TError,DeleteTeamWorkspaceFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeamWorkspaceFile>>,
        TError,
        DeleteTeamWorkspaceFileMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTeamWorkspaceFileMutationOptions(options));
    }

export const getPreviewTeamWorkspaceFileUrl = (id: string,
    fileId: string,) => {




  return `/api/draft-teams/${id}/workspace/files/${fileId}/preview`
}

/**
 * @summary Preview a PDF, Word, or text shared workspace file inline
 */
export const previewTeamWorkspaceFile = async (id: string,
    fileId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getPreviewTeamWorkspaceFileUrl(id,fileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPreviewTeamWorkspaceFileQueryKey = (id: string,
    fileId: string,) => {
    return [
    `/api/draft-teams/${id}/workspace/files/${fileId}/preview`
    ] as const;
    }


export const getPreviewTeamWorkspaceFileQueryOptions = <TData = Awaited<ReturnType<typeof previewTeamWorkspaceFile>>, TError = ErrorType<void>>(id: string,
    fileId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof previewTeamWorkspaceFile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewTeamWorkspaceFileQueryKey(id,fileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewTeamWorkspaceFile>>> = ({ signal }) => previewTeamWorkspaceFile(id,fileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && fileId !== null && fileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewTeamWorkspaceFile>>, TError, TData> & { queryKey: QueryKey }
}

export type PreviewTeamWorkspaceFileQueryResult = NonNullable<Awaited<ReturnType<typeof previewTeamWorkspaceFile>>>
export type PreviewTeamWorkspaceFileQueryError = ErrorType<void>


/**
 * @summary Preview a PDF, Word, or text shared workspace file inline
 */

export function usePreviewTeamWorkspaceFile<TData = Awaited<ReturnType<typeof previewTeamWorkspaceFile>>, TError = ErrorType<void>>(
 id: string,
    fileId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof previewTeamWorkspaceFile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPreviewTeamWorkspaceFileQueryOptions(id,fileId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getShareTeamWorkspaceKnowledgeFileUrl = (id: string,
    fileId: string,) => {




  return `/api/draft-teams/${id}/workspace/files/${fileId}/share`
}

/**
 * @summary Grant this workspace access to partner-owned knowledge
 */
export const shareTeamWorkspaceKnowledgeFile = async (id: string,
    fileId: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspaceFile> => {

  return customFetch<TeamWorkspaceFile>(getShareTeamWorkspaceKnowledgeFileUrl(id,fileId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getShareTeamWorkspaceKnowledgeFileMutationKey = () => ['shareTeamWorkspaceKnowledgeFile'] as const;

export const getShareTeamWorkspaceKnowledgeFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareTeamWorkspaceKnowledgeFile>>, TError,ShareTeamWorkspaceKnowledgeFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof shareTeamWorkspaceKnowledgeFile>>, TError,ShareTeamWorkspaceKnowledgeFileMutationVariables, TContext> => {

const mutationKey = getShareTeamWorkspaceKnowledgeFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shareTeamWorkspaceKnowledgeFile>>, ShareTeamWorkspaceKnowledgeFileMutationVariables> = (props) => {
          const {id,fileId} = props ?? {};

          return  shareTeamWorkspaceKnowledgeFile(id,fileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ShareTeamWorkspaceKnowledgeFileMutationResult = NonNullable<Awaited<ReturnType<typeof shareTeamWorkspaceKnowledgeFile>>>

    export type ShareTeamWorkspaceKnowledgeFileMutationError = ErrorType<void>
    export type ShareTeamWorkspaceKnowledgeFileMutationVariables = {id: string;fileId: string}

    /**
 * @summary Grant this workspace access to partner-owned knowledge
 */
export const useShareTeamWorkspaceKnowledgeFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareTeamWorkspaceKnowledgeFile>>, TError,ShareTeamWorkspaceKnowledgeFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof shareTeamWorkspaceKnowledgeFile>>,
        TError,
        ShareTeamWorkspaceKnowledgeFileMutationVariables,
        TContext
      > => {
      return useMutation(getShareTeamWorkspaceKnowledgeFileMutationOptions(options));
    }

export const getRevokeTeamWorkspaceKnowledgeFileUrl = (id: string,
    fileId: string,) => {




  return `/api/draft-teams/${id}/workspace/files/${fileId}/revoke`
}

/**
 * @summary Revoke a partner-owned knowledge grant
 */
export const revokeTeamWorkspaceKnowledgeFile = async (id: string,
    fileId: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspaceFile> => {

  return customFetch<TeamWorkspaceFile>(getRevokeTeamWorkspaceKnowledgeFileUrl(id,fileId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRevokeTeamWorkspaceKnowledgeFileMutationKey = () => ['revokeTeamWorkspaceKnowledgeFile'] as const;

export const getRevokeTeamWorkspaceKnowledgeFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeTeamWorkspaceKnowledgeFile>>, TError,RevokeTeamWorkspaceKnowledgeFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeTeamWorkspaceKnowledgeFile>>, TError,RevokeTeamWorkspaceKnowledgeFileMutationVariables, TContext> => {

const mutationKey = getRevokeTeamWorkspaceKnowledgeFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeTeamWorkspaceKnowledgeFile>>, RevokeTeamWorkspaceKnowledgeFileMutationVariables> = (props) => {
          const {id,fileId} = props ?? {};

          return  revokeTeamWorkspaceKnowledgeFile(id,fileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeTeamWorkspaceKnowledgeFileMutationResult = NonNullable<Awaited<ReturnType<typeof revokeTeamWorkspaceKnowledgeFile>>>

    export type RevokeTeamWorkspaceKnowledgeFileMutationError = ErrorType<void>
    export type RevokeTeamWorkspaceKnowledgeFileMutationVariables = {id: string;fileId: string}

    /**
 * @summary Revoke a partner-owned knowledge grant
 */
export const useRevokeTeamWorkspaceKnowledgeFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeTeamWorkspaceKnowledgeFile>>, TError,RevokeTeamWorkspaceKnowledgeFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeTeamWorkspaceKnowledgeFile>>,
        TError,
        RevokeTeamWorkspaceKnowledgeFileMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeTeamWorkspaceKnowledgeFileMutationOptions(options));
    }

export const getListWorkspaceKnowledgeSourceDocumentsUrl = (id: string,) => {




  return `/api/draft-teams/${id}/workspace/knowledge/documents`
}

/**
 * @summary List the current tenant's private documents and workspace grant state
 */
export const listWorkspaceKnowledgeSourceDocuments = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<WorkspaceKnowledgeSourceDocument[]> => {

  return customFetch<WorkspaceKnowledgeSourceDocument[]>(getListWorkspaceKnowledgeSourceDocumentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWorkspaceKnowledgeSourceDocumentsQueryKey = (id: string,) => {
    return [
    `/api/draft-teams/${id}/workspace/knowledge/documents`
    ] as const;
    }


export const getListWorkspaceKnowledgeSourceDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listWorkspaceKnowledgeSourceDocuments>>, TError = ErrorType<void>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceKnowledgeSourceDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWorkspaceKnowledgeSourceDocumentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorkspaceKnowledgeSourceDocuments>>> = ({ signal }) => listWorkspaceKnowledgeSourceDocuments(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceKnowledgeSourceDocuments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWorkspaceKnowledgeSourceDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listWorkspaceKnowledgeSourceDocuments>>>
export type ListWorkspaceKnowledgeSourceDocumentsQueryError = ErrorType<void>


/**
 * @summary List the current tenant's private documents and workspace grant state
 */

export function useListWorkspaceKnowledgeSourceDocuments<TData = Awaited<ReturnType<typeof listWorkspaceKnowledgeSourceDocuments>>, TError = ErrorType<void>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWorkspaceKnowledgeSourceDocuments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWorkspaceKnowledgeSourceDocumentsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGrantWorkspaceKnowledgeSourceDocumentUrl = (id: string,
    documentId: string,) => {




  return `/api/draft-teams/${id}/workspace/knowledge/documents/${documentId}/share`
}

/**
 * @summary Explicitly share one private tenant document with this workspace
 */
export const grantWorkspaceKnowledgeSourceDocument = async (id: string,
    documentId: string, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspaceFile> => {

  return customFetch<TeamWorkspaceFile>(getGrantWorkspaceKnowledgeSourceDocumentUrl(id,documentId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getGrantWorkspaceKnowledgeSourceDocumentMutationKey = () => ['grantWorkspaceKnowledgeSourceDocument'] as const;

export const getGrantWorkspaceKnowledgeSourceDocumentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantWorkspaceKnowledgeSourceDocument>>, TError,GrantWorkspaceKnowledgeSourceDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof grantWorkspaceKnowledgeSourceDocument>>, TError,GrantWorkspaceKnowledgeSourceDocumentMutationVariables, TContext> => {

const mutationKey = getGrantWorkspaceKnowledgeSourceDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof grantWorkspaceKnowledgeSourceDocument>>, GrantWorkspaceKnowledgeSourceDocumentMutationVariables> = (props) => {
          const {id,documentId} = props ?? {};

          return  grantWorkspaceKnowledgeSourceDocument(id,documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GrantWorkspaceKnowledgeSourceDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof grantWorkspaceKnowledgeSourceDocument>>>

    export type GrantWorkspaceKnowledgeSourceDocumentMutationError = ErrorType<void>
    export type GrantWorkspaceKnowledgeSourceDocumentMutationVariables = {id: string;documentId: string}

    /**
 * @summary Explicitly share one private tenant document with this workspace
 */
export const useGrantWorkspaceKnowledgeSourceDocument = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantWorkspaceKnowledgeSourceDocument>>, TError,GrantWorkspaceKnowledgeSourceDocumentMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof grantWorkspaceKnowledgeSourceDocument>>,
        TError,
        GrantWorkspaceKnowledgeSourceDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getGrantWorkspaceKnowledgeSourceDocumentMutationOptions(options));
    }

export const getUpdateDraftTeamWorkspaceTaskUrl = (id: string,
    taskId: string,) => {




  return `/api/draft-teams/${id}/workspace/tasks/${taskId}`
}

/**
 * @summary Update a shared proposal planning task
 */
export const updateDraftTeamWorkspaceTask = async (id: string,
    taskId: string,
    workspaceTaskPatchBody: WorkspaceTaskPatchBody, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspaceTask> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TeamWorkspaceTask>(getUpdateDraftTeamWorkspaceTaskUrl(id,taskId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workspaceTaskPatchBody)
  }
);}





export const getUpdateDraftTeamWorkspaceTaskMutationKey = () => ['updateDraftTeamWorkspaceTask'] as const;

export const getUpdateDraftTeamWorkspaceTaskMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspaceTask>>, TError,UpdateDraftTeamWorkspaceTaskMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspaceTask>>, TError,UpdateDraftTeamWorkspaceTaskMutationVariables, TContext> => {

const mutationKey = getUpdateDraftTeamWorkspaceTaskMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDraftTeamWorkspaceTask>>, UpdateDraftTeamWorkspaceTaskMutationVariables> = (props) => {
          const {id,taskId,data} = props ?? {};

          return  updateDraftTeamWorkspaceTask(id,taskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDraftTeamWorkspaceTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateDraftTeamWorkspaceTask>>>
    export type UpdateDraftTeamWorkspaceTaskMutationBody = BodyType<WorkspaceTaskPatchBody>
    export type UpdateDraftTeamWorkspaceTaskMutationError = ErrorType<void>
    export type UpdateDraftTeamWorkspaceTaskMutationVariables = {id: string;taskId: string;data: BodyType<WorkspaceTaskPatchBody>}

    /**
 * @summary Update a shared proposal planning task
 */
export const useUpdateDraftTeamWorkspaceTask = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspaceTask>>, TError,UpdateDraftTeamWorkspaceTaskMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDraftTeamWorkspaceTask>>,
        TError,
        UpdateDraftTeamWorkspaceTaskMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateDraftTeamWorkspaceTaskMutationOptions(options));
    }

export const getDeleteDraftTeamWorkspaceTaskUrl = (id: string,
    taskId: string,) => {




  return `/api/draft-teams/${id}/workspace/tasks/${taskId}`
}

/**
 * @summary Delete a shared proposal planning task
 */
export const deleteDraftTeamWorkspaceTask = async (id: string,
    taskId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteDraftTeamWorkspaceTaskUrl(id,taskId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDraftTeamWorkspaceTaskMutationKey = () => ['deleteDraftTeamWorkspaceTask'] as const;

export const getDeleteDraftTeamWorkspaceTaskMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceTask>>, TError,DeleteDraftTeamWorkspaceTaskMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceTask>>, TError,DeleteDraftTeamWorkspaceTaskMutationVariables, TContext> => {

const mutationKey = getDeleteDraftTeamWorkspaceTaskMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceTask>>, DeleteDraftTeamWorkspaceTaskMutationVariables> = (props) => {
          const {id,taskId} = props ?? {};

          return  deleteDraftTeamWorkspaceTask(id,taskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDraftTeamWorkspaceTaskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceTask>>>

    export type DeleteDraftTeamWorkspaceTaskMutationError = ErrorType<void>
    export type DeleteDraftTeamWorkspaceTaskMutationVariables = {id: string;taskId: string}

    /**
 * @summary Delete a shared proposal planning task
 */
export const useDeleteDraftTeamWorkspaceTask = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceTask>>, TError,DeleteDraftTeamWorkspaceTaskMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDraftTeamWorkspaceTask>>,
        TError,
        DeleteDraftTeamWorkspaceTaskMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteDraftTeamWorkspaceTaskMutationOptions(options));
    }

export const getUpdateDraftTeamWorkspaceNoteUrl = (id: string,
    noteId: string,) => {




  return `/api/draft-teams/${id}/workspace/notes/${noteId}`
}

/**
 * @summary Edit a shared workspace note authored by the current tenant
 */
export const updateDraftTeamWorkspaceNote = async (id: string,
    noteId: string,
    addDraftTeamWorkspaceNoteBody: AddDraftTeamWorkspaceNoteBody, options?: Parameters<typeof customFetch>[1]): Promise<TeamWorkspaceNote> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TeamWorkspaceNote>(getUpdateDraftTeamWorkspaceNoteUrl(id,noteId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addDraftTeamWorkspaceNoteBody)
  }
);}





export const getUpdateDraftTeamWorkspaceNoteMutationKey = () => ['updateDraftTeamWorkspaceNote'] as const;

export const getUpdateDraftTeamWorkspaceNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspaceNote>>, TError,UpdateDraftTeamWorkspaceNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspaceNote>>, TError,UpdateDraftTeamWorkspaceNoteMutationVariables, TContext> => {

const mutationKey = getUpdateDraftTeamWorkspaceNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDraftTeamWorkspaceNote>>, UpdateDraftTeamWorkspaceNoteMutationVariables> = (props) => {
          const {id,noteId,data} = props ?? {};

          return  updateDraftTeamWorkspaceNote(id,noteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDraftTeamWorkspaceNoteMutationResult = NonNullable<Awaited<ReturnType<typeof updateDraftTeamWorkspaceNote>>>
    export type UpdateDraftTeamWorkspaceNoteMutationBody = BodyType<AddDraftTeamWorkspaceNoteBody>
    export type UpdateDraftTeamWorkspaceNoteMutationError = ErrorType<void>
    export type UpdateDraftTeamWorkspaceNoteMutationVariables = {id: string;noteId: string;data: BodyType<AddDraftTeamWorkspaceNoteBody>}

    /**
 * @summary Edit a shared workspace note authored by the current tenant
 */
export const useUpdateDraftTeamWorkspaceNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftTeamWorkspaceNote>>, TError,UpdateDraftTeamWorkspaceNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDraftTeamWorkspaceNote>>,
        TError,
        UpdateDraftTeamWorkspaceNoteMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateDraftTeamWorkspaceNoteMutationOptions(options));
    }

export const getDeleteDraftTeamWorkspaceNoteUrl = (id: string,
    noteId: string,) => {




  return `/api/draft-teams/${id}/workspace/notes/${noteId}`
}

/**
 * @summary Remove a shared workspace note (author or workspace owner)
 */
export const deleteDraftTeamWorkspaceNote = async (id: string,
    noteId: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteDraftTeamWorkspaceNoteUrl(id,noteId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDraftTeamWorkspaceNoteMutationKey = () => ['deleteDraftTeamWorkspaceNote'] as const;

export const getDeleteDraftTeamWorkspaceNoteMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceNote>>, TError,DeleteDraftTeamWorkspaceNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceNote>>, TError,DeleteDraftTeamWorkspaceNoteMutationVariables, TContext> => {

const mutationKey = getDeleteDraftTeamWorkspaceNoteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceNote>>, DeleteDraftTeamWorkspaceNoteMutationVariables> = (props) => {
          const {id,noteId} = props ?? {};

          return  deleteDraftTeamWorkspaceNote(id,noteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDraftTeamWorkspaceNoteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceNote>>>

    export type DeleteDraftTeamWorkspaceNoteMutationError = ErrorType<void>
    export type DeleteDraftTeamWorkspaceNoteMutationVariables = {id: string;noteId: string}

    /**
 * @summary Remove a shared workspace note (author or workspace owner)
 */
export const useDeleteDraftTeamWorkspaceNote = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftTeamWorkspaceNote>>, TError,DeleteDraftTeamWorkspaceNoteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDraftTeamWorkspaceNote>>,
        TError,
        DeleteDraftTeamWorkspaceNoteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteDraftTeamWorkspaceNoteMutationOptions(options));
    }

export const getInviteDraftTeamMemberUrl = (id: string,
    memberTenantId: string,) => {




  return `/api/draft-teams/${id}/members/${memberTenantId}/invite`
}

/**
 * @summary Invite a prospective partner to a draft team
 */
export const inviteDraftTeamMember = async (id: string,
    memberTenantId: string, options?: Parameters<typeof customFetch>[1]): Promise<DraftTeam> => {

  return customFetch<DraftTeam>(getInviteDraftTeamMemberUrl(id,memberTenantId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getInviteDraftTeamMemberMutationKey = () => ['inviteDraftTeamMember'] as const;

export const getInviteDraftTeamMemberMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteDraftTeamMember>>, TError,InviteDraftTeamMemberMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteDraftTeamMember>>, TError,InviteDraftTeamMemberMutationVariables, TContext> => {

const mutationKey = getInviteDraftTeamMemberMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteDraftTeamMember>>, InviteDraftTeamMemberMutationVariables> = (props) => {
          const {id,memberTenantId} = props ?? {};

          return  inviteDraftTeamMember(id,memberTenantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InviteDraftTeamMemberMutationResult = NonNullable<Awaited<ReturnType<typeof inviteDraftTeamMember>>>

    export type InviteDraftTeamMemberMutationError = ErrorType<ApiError>
    export type InviteDraftTeamMemberMutationVariables = {id: string;memberTenantId: string}

    /**
 * @summary Invite a prospective partner to a draft team
 */
export const useInviteDraftTeamMember = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteDraftTeamMember>>, TError,InviteDraftTeamMemberMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof inviteDraftTeamMember>>,
        TError,
        InviteDraftTeamMemberMutationVariables,
        TContext
      > => {
      return useMutation(getInviteDraftTeamMemberMutationOptions(options));
    }

export const getRespondToDraftTeamInviteUrl = (id: string,
    memberTenantId: string,) => {




  return `/api/draft-teams/${id}/members/${memberTenantId}/respond`
}

/**
 * @summary Accept or decline a draft team invitation
 */
export const respondToDraftTeamInvite = async (id: string,
    memberTenantId: string,
    draftTeamInviteResponseInput: DraftTeamInviteResponseInput, options?: Parameters<typeof customFetch>[1]): Promise<DraftTeam> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<DraftTeam>(getRespondToDraftTeamInviteUrl(id,memberTenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(draftTeamInviteResponseInput)
  }
);}





export const getRespondToDraftTeamInviteMutationKey = () => ['respondToDraftTeamInvite'] as const;

export const getRespondToDraftTeamInviteMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToDraftTeamInvite>>, TError,RespondToDraftTeamInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof respondToDraftTeamInvite>>, TError,RespondToDraftTeamInviteMutationVariables, TContext> => {

const mutationKey = getRespondToDraftTeamInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof respondToDraftTeamInvite>>, RespondToDraftTeamInviteMutationVariables> = (props) => {
          const {id,memberTenantId,data} = props ?? {};

          return  respondToDraftTeamInvite(id,memberTenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RespondToDraftTeamInviteMutationResult = NonNullable<Awaited<ReturnType<typeof respondToDraftTeamInvite>>>
    export type RespondToDraftTeamInviteMutationBody = BodyType<DraftTeamInviteResponseInput>
    export type RespondToDraftTeamInviteMutationError = ErrorType<ApiError>
    export type RespondToDraftTeamInviteMutationVariables = {id: string;memberTenantId: string;data: BodyType<DraftTeamInviteResponseInput>}

    /**
 * @summary Accept or decline a draft team invitation
 */
export const useRespondToDraftTeamInvite = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof respondToDraftTeamInvite>>, TError,RespondToDraftTeamInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof respondToDraftTeamInvite>>,
        TError,
        RespondToDraftTeamInviteMutationVariables,
        TContext
      > => {
      return useMutation(getRespondToDraftTeamInviteMutationOptions(options));
    }

export const getListConversationsUrl = () => {




  return `/api/conversations`
}

export const listConversations = async ( options?: Parameters<typeof customFetch>[1]): Promise<Conversation[]> => {

  return customFetch<Conversation[]>(getListConversationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConversationsQueryKey = () => {
    return [
    `/api/conversations`
    ] as const;
    }


export const getListConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listConversations>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConversationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConversations>>> = ({ signal }) => listConversations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listConversations>>>
export type ListConversationsQueryError = ErrorType<unknown>



export function useListConversations<TData = Awaited<ReturnType<typeof listConversations>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListConversationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStartConversationUrl = () => {




  return `/api/conversations`
}

export const startConversation = async (startConversationBody: StartConversationBody, options?: Parameters<typeof customFetch>[1]): Promise<Conversation> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Conversation>(getStartConversationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startConversationBody)
  }
);}





export const getStartConversationMutationKey = () => ['startConversation'] as const;

export const getStartConversationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startConversation>>, TError,StartConversationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startConversation>>, TError,StartConversationMutationVariables, TContext> => {

const mutationKey = getStartConversationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startConversation>>, StartConversationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startConversation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartConversationMutationResult = NonNullable<Awaited<ReturnType<typeof startConversation>>>
    export type StartConversationMutationBody = BodyType<StartConversationBody>
    export type StartConversationMutationError = ErrorType<unknown>
    export type StartConversationMutationVariables = {data: BodyType<StartConversationBody>}

    export const useStartConversation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startConversation>>, TError,StartConversationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startConversation>>,
        TError,
        StartConversationMutationVariables,
        TContext
      > => {
      return useMutation(getStartConversationMutationOptions(options));
    }

export const getListMessagesUrl = (id: string,) => {




  return `/api/conversations/${id}/messages`
}

export const listMessages = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<Message[]> => {

  return customFetch<Message[]>(getListMessagesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMessagesQueryKey = (id: string,) => {
    return [
    `/api/conversations/${id}/messages`
    ] as const;
    }


export const getListMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listMessages>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMessagesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMessages>>> = ({ signal }) => listMessages(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listMessages>>>
export type ListMessagesQueryError = ErrorType<unknown>



export function useListMessages<TData = Awaited<ReturnType<typeof listMessages>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMessagesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendMessageUrl = (id: string,) => {




  return `/api/conversations/${id}/messages`
}

export const sendMessage = async (id: string,
    sendMessageBody: SendMessageBody, options?: Parameters<typeof customFetch>[1]): Promise<Message> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Message>(getSendMessageUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendMessageBody)
  }
);}





export const getSendMessageMutationKey = () => ['sendMessage'] as const;

export const getSendMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,SendMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,SendMessageMutationVariables, TContext> => {

const mutationKey = getSendMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendMessage>>, SendMessageMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  sendMessage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendMessage>>>
    export type SendMessageMutationBody = BodyType<SendMessageBody>
    export type SendMessageMutationError = ErrorType<unknown>
    export type SendMessageMutationVariables = {id: string;data: BodyType<SendMessageBody>}

    export const useSendMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,SendMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendMessage>>,
        TError,
        SendMessageMutationVariables,
        TContext
      > => {
      return useMutation(getSendMessageMutationOptions(options));
    }

export const getGetDashboardSummaryUrl = () => {




  return `/api/dashboard/summary`
}

/**
 * @summary Aggregate counts and recent activity for the active tenant
 */
export const getDashboardSummary = async ( options?: Parameters<typeof customFetch>[1]): Promise<DashboardSummary> => {

  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardSummaryQueryKey = () => {
    return [
    `/api/dashboard/summary`
    ] as const;
    }


export const getGetDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSummary>>> = ({ signal }) => getDashboardSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardSummary>>>
export type GetDashboardSummaryQueryError = ErrorType<unknown>


/**
 * @summary Aggregate counts and recent activity for the active tenant
 */

export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetUnreadCountsUrl = () => {




  return `/api/notifications/unread`
}

/**
 * @summary Sidebar unread/new badge counts for the active workspace
 */
export const getUnreadCounts = async ( options?: Parameters<typeof customFetch>[1]): Promise<UnreadCounts> => {

  return customFetch<UnreadCounts>(getGetUnreadCountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUnreadCountsQueryKey = () => {
    return [
    `/api/notifications/unread`
    ] as const;
    }


export const getGetUnreadCountsQueryOptions = <TData = Awaited<ReturnType<typeof getUnreadCounts>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUnreadCounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnreadCountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadCounts>>> = ({ signal }) => getUnreadCounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnreadCounts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUnreadCountsQueryResult = NonNullable<Awaited<ReturnType<typeof getUnreadCounts>>>
export type GetUnreadCountsQueryError = ErrorType<unknown>


/**
 * @summary Sidebar unread/new badge counts for the active workspace
 */

export function useGetUnreadCounts<TData = Awaited<ReturnType<typeof getUnreadCounts>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUnreadCounts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUnreadCountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getMarkNotificationsViewedUrl = () => {




  return `/api/notifications/mark-viewed`
}

/**
 * @summary Record that the active workspace has just viewed a notification surface
 */
export const markNotificationsViewed = async (markNotificationsViewedBody: MarkNotificationsViewedBody, options?: Parameters<typeof customFetch>[1]): Promise<MarkNotificationsViewed200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<MarkNotificationsViewed200>(getMarkNotificationsViewedUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(markNotificationsViewedBody)
  }
);}





export const getMarkNotificationsViewedMutationKey = () => ['markNotificationsViewed'] as const;

export const getMarkNotificationsViewedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationsViewed>>, TError,MarkNotificationsViewedMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationsViewed>>, TError,MarkNotificationsViewedMutationVariables, TContext> => {

const mutationKey = getMarkNotificationsViewedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationsViewed>>, MarkNotificationsViewedMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  markNotificationsViewed(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationsViewedMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationsViewed>>>
    export type MarkNotificationsViewedMutationBody = BodyType<MarkNotificationsViewedBody>
    export type MarkNotificationsViewedMutationError = ErrorType<unknown>
    export type MarkNotificationsViewedMutationVariables = {data: BodyType<MarkNotificationsViewedBody>}

    /**
 * @summary Record that the active workspace has just viewed a notification surface
 */
export const useMarkNotificationsViewed = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationsViewed>>, TError,MarkNotificationsViewedMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationsViewed>>,
        TError,
        MarkNotificationsViewedMutationVariables,
        TContext
      > => {
      return useMutation(getMarkNotificationsViewedMutationOptions(options));
    }

export const getAdminListVendorProfilesUrl = (params?: AdminListVendorProfilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/vendor-profiles?${stringifiedParams}` : `/api/admin/vendor-profiles`
}

/**
 * @summary List every vendor profile on the platform (platform admin only)
 */
export const adminListVendorProfiles = async (params?: AdminListVendorProfilesParams, options?: Parameters<typeof customFetch>[1]): Promise<AdminListVendorProfiles200> => {

  return customFetch<AdminListVendorProfiles200>(getAdminListVendorProfilesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListVendorProfilesQueryKey = (params?: AdminListVendorProfilesParams,) => {
    return [
    `/api/admin/vendor-profiles`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListVendorProfilesQueryOptions = <TData = Awaited<ReturnType<typeof adminListVendorProfiles>>, TError = ErrorType<unknown>>(params?: AdminListVendorProfilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListVendorProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListVendorProfilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListVendorProfiles>>> = ({ signal }) => adminListVendorProfiles(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListVendorProfiles>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListVendorProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof adminListVendorProfiles>>>
export type AdminListVendorProfilesQueryError = ErrorType<unknown>


/**
 * @summary List every vendor profile on the platform (platform admin only)
 */

export function useAdminListVendorProfiles<TData = Awaited<ReturnType<typeof adminListVendorProfiles>>, TError = ErrorType<unknown>>(
 params?: AdminListVendorProfilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListVendorProfiles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListVendorProfilesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminGetVendorProfileDeletePreviewUrl = (id: string,) => {




  return `/api/admin/vendor-profiles/${id}`
}

/**
 * @summary Counts of rows that will be removed when deleting this vendor (platform admin only)
 */
export const adminGetVendorProfileDeletePreview = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<AdminVendorProfileDeletePreview> => {

  return customFetch<AdminVendorProfileDeletePreview>(getAdminGetVendorProfileDeletePreviewUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetVendorProfileDeletePreviewQueryKey = (id: string,) => {
    return [
    `/api/admin/vendor-profiles/${id}`
    ] as const;
    }


export const getAdminGetVendorProfileDeletePreviewQueryOptions = <TData = Awaited<ReturnType<typeof adminGetVendorProfileDeletePreview>>, TError = ErrorType<ApiError>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetVendorProfileDeletePreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetVendorProfileDeletePreviewQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetVendorProfileDeletePreview>>> = ({ signal }) => adminGetVendorProfileDeletePreview(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetVendorProfileDeletePreview>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminGetVendorProfileDeletePreviewQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetVendorProfileDeletePreview>>>
export type AdminGetVendorProfileDeletePreviewQueryError = ErrorType<ApiError>


/**
 * @summary Counts of rows that will be removed when deleting this vendor (platform admin only)
 */

export function useAdminGetVendorProfileDeletePreview<TData = Awaited<ReturnType<typeof adminGetVendorProfileDeletePreview>>, TError = ErrorType<ApiError>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetVendorProfileDeletePreview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminGetVendorProfileDeletePreviewQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminDeleteVendorProfileUrl = (id: string,) => {




  return `/api/admin/vendor-profiles/${id}`
}

/**
 * @summary Hard-delete a vendor profile and all directly related rows (platform admin only)
 */
export const adminDeleteVendorProfile = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<AdminDeleteVendorProfile200> => {

  return customFetch<AdminDeleteVendorProfile200>(getAdminDeleteVendorProfileUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAdminDeleteVendorProfileMutationKey = () => ['adminDeleteVendorProfile'] as const;

export const getAdminDeleteVendorProfileMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteVendorProfile>>, TError,AdminDeleteVendorProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteVendorProfile>>, TError,AdminDeleteVendorProfileMutationVariables, TContext> => {

const mutationKey = getAdminDeleteVendorProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteVendorProfile>>, AdminDeleteVendorProfileMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  adminDeleteVendorProfile(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteVendorProfileMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteVendorProfile>>>

    export type AdminDeleteVendorProfileMutationError = ErrorType<ApiError>
    export type AdminDeleteVendorProfileMutationVariables = {id: string}

    /**
 * @summary Hard-delete a vendor profile and all directly related rows (platform admin only)
 */
export const useAdminDeleteVendorProfile = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteVendorProfile>>, TError,AdminDeleteVendorProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminDeleteVendorProfile>>,
        TError,
        AdminDeleteVendorProfileMutationVariables,
        TContext
      > => {
      return useMutation(getAdminDeleteVendorProfileMutationOptions(options));
    }

export const getCleanupDemoDataUrl = () => {




  return `/api/admin/cleanup-demo-data`
}

/**
 * @summary One-shot platform-admin action to delete any seed/demo rows lingering in the database
 */
export const cleanupDemoData = async ( options?: Parameters<typeof customFetch>[1]): Promise<CleanupDemoData200> => {

  return customFetch<CleanupDemoData200>(getCleanupDemoDataUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCleanupDemoDataMutationKey = () => ['cleanupDemoData'] as const;

export const getCleanupDemoDataMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cleanupDemoData>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cleanupDemoData>>, TError,void, TContext> => {

const mutationKey = getCleanupDemoDataMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cleanupDemoData>>, void> = () => {


          return  cleanupDemoData(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CleanupDemoDataMutationResult = NonNullable<Awaited<ReturnType<typeof cleanupDemoData>>>

    export type CleanupDemoDataMutationError = ErrorType<unknown>


    /**
 * @summary One-shot platform-admin action to delete any seed/demo rows lingering in the database
 */
export const useCleanupDemoData = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cleanupDemoData>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cleanupDemoData>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCleanupDemoDataMutationOptions(options));
    }

export const getListAuditLogsUrl = () => {




  return `/api/admin/audit-logs`
}

export const listAuditLogs = async ( options?: Parameters<typeof customFetch>[1]): Promise<AuditLog[]> => {

  return customFetch<AuditLog[]>(getListAuditLogsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAuditLogsQueryKey = () => {
    return [
    `/api/admin/audit-logs`
    ] as const;
    }


export const getListAuditLogsQueryOptions = <TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAuditLogsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAuditLogs>>> = ({ signal }) => listAuditLogs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAuditLogsQueryResult = NonNullable<Awaited<ReturnType<typeof listAuditLogs>>>
export type ListAuditLogsQueryError = ErrorType<unknown>



export function useListAuditLogs<TData = Awaited<ReturnType<typeof listAuditLogs>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAuditLogs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAuditLogsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSystemErrorsUrl = () => {




  return `/api/admin/system-errors`
}

export const listSystemErrors = async ( options?: Parameters<typeof customFetch>[1]): Promise<SystemError[]> => {

  return customFetch<SystemError[]>(getListSystemErrorsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSystemErrorsQueryKey = () => {
    return [
    `/api/admin/system-errors`
    ] as const;
    }


export const getListSystemErrorsQueryOptions = <TData = Awaited<ReturnType<typeof listSystemErrors>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSystemErrors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSystemErrorsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSystemErrors>>> = ({ signal }) => listSystemErrors({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSystemErrors>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSystemErrorsQueryResult = NonNullable<Awaited<ReturnType<typeof listSystemErrors>>>
export type ListSystemErrorsQueryError = ErrorType<unknown>



export function useListSystemErrors<TData = Awaited<ReturnType<typeof listSystemErrors>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSystemErrors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSystemErrorsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminListTeamingPostsUrl = (params?: AdminListTeamingPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/teaming-posts?${stringifiedParams}` : `/api/admin/teaming-posts`
}

/**
 * @summary List teaming posts platform-wide for moderation (platform admin only)
 */
export const adminListTeamingPosts = async (params?: AdminListTeamingPostsParams, options?: Parameters<typeof customFetch>[1]): Promise<AdminListTeamingPosts200> => {

  return customFetch<AdminListTeamingPosts200>(getAdminListTeamingPostsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListTeamingPostsQueryKey = (params?: AdminListTeamingPostsParams,) => {
    return [
    `/api/admin/teaming-posts`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListTeamingPostsQueryOptions = <TData = Awaited<ReturnType<typeof adminListTeamingPosts>>, TError = ErrorType<unknown>>(params?: AdminListTeamingPostsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListTeamingPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListTeamingPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListTeamingPosts>>> = ({ signal }) => adminListTeamingPosts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListTeamingPosts>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListTeamingPostsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListTeamingPosts>>>
export type AdminListTeamingPostsQueryError = ErrorType<unknown>


/**
 * @summary List teaming posts platform-wide for moderation (platform admin only)
 */

export function useAdminListTeamingPosts<TData = Awaited<ReturnType<typeof adminListTeamingPosts>>, TError = ErrorType<unknown>>(
 params?: AdminListTeamingPostsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListTeamingPosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListTeamingPostsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminDeleteTeamingPostUrl = (id: string,) => {




  return `/api/admin/teaming-posts/${id}`
}

/**
 * @summary Hard-delete a teaming post (platform admin only)
 */
export const adminDeleteTeamingPost = async (id: string,
    adminDeleteTeamingPostBody: AdminDeleteTeamingPostBody, options?: Parameters<typeof customFetch>[1]): Promise<AdminDeleteTeamingPost200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AdminDeleteTeamingPost200>(getAdminDeleteTeamingPostUrl(id),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminDeleteTeamingPostBody)
  }
);}





export const getAdminDeleteTeamingPostMutationKey = () => ['adminDeleteTeamingPost'] as const;

export const getAdminDeleteTeamingPostMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteTeamingPost>>, TError,AdminDeleteTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteTeamingPost>>, TError,AdminDeleteTeamingPostMutationVariables, TContext> => {

const mutationKey = getAdminDeleteTeamingPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteTeamingPost>>, AdminDeleteTeamingPostMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminDeleteTeamingPost(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteTeamingPostMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteTeamingPost>>>
    export type AdminDeleteTeamingPostMutationBody = BodyType<AdminDeleteTeamingPostBody>
    export type AdminDeleteTeamingPostMutationError = ErrorType<ApiError>
    export type AdminDeleteTeamingPostMutationVariables = {id: string;data: BodyType<AdminDeleteTeamingPostBody>}

    /**
 * @summary Hard-delete a teaming post (platform admin only)
 */
export const useAdminDeleteTeamingPost = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteTeamingPost>>, TError,AdminDeleteTeamingPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminDeleteTeamingPost>>,
        TError,
        AdminDeleteTeamingPostMutationVariables,
        TContext
      > => {
      return useMutation(getAdminDeleteTeamingPostMutationOptions(options));
    }

export const getAdminListConversationsUrl = (params?: AdminListConversationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/conversations?${stringifiedParams}` : `/api/admin/conversations`
}

/**
 * @summary List direct conversations platform-wide for moderation (platform admin only)
 */
export const adminListConversations = async (params?: AdminListConversationsParams, options?: Parameters<typeof customFetch>[1]): Promise<AdminListConversations200> => {

  return customFetch<AdminListConversations200>(getAdminListConversationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListConversationsQueryKey = (params?: AdminListConversationsParams,) => {
    return [
    `/api/admin/conversations`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListConversationsQueryOptions = <TData = Awaited<ReturnType<typeof adminListConversations>>, TError = ErrorType<unknown>>(params?: AdminListConversationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListConversationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListConversations>>> = ({ signal }) => adminListConversations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListConversations>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListConversations>>>
export type AdminListConversationsQueryError = ErrorType<unknown>


/**
 * @summary List direct conversations platform-wide for moderation (platform admin only)
 */

export function useAdminListConversations<TData = Awaited<ReturnType<typeof adminListConversations>>, TError = ErrorType<unknown>>(
 params?: AdminListConversationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminGetConversationUrl = (id: string,) => {




  return `/api/admin/conversations/${id}`
}

/**
 * @summary Read a conversation and its messages in context (platform admin only)
 */
export const adminGetConversation = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<AdminGetConversation200> => {

  return customFetch<AdminGetConversation200>(getAdminGetConversationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminGetConversationQueryKey = (id: string,) => {
    return [
    `/api/admin/conversations/${id}`
    ] as const;
    }


export const getAdminGetConversationQueryOptions = <TData = Awaited<ReturnType<typeof adminGetConversation>>, TError = ErrorType<ApiError>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetConversationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetConversation>>> = ({ signal }) => adminGetConversation(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetConversation>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminGetConversationQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetConversation>>>
export type AdminGetConversationQueryError = ErrorType<ApiError>


/**
 * @summary Read a conversation and its messages in context (platform admin only)
 */

export function useAdminGetConversation<TData = Awaited<ReturnType<typeof adminGetConversation>>, TError = ErrorType<ApiError>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminGetConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminGetConversationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminDeleteConversationUrl = (id: string,) => {




  return `/api/admin/conversations/${id}`
}

/**
 * @summary Hard-delete a conversation and every message in it (platform admin only)
 */
export const adminDeleteConversation = async (id: string,
    adminDeleteConversationBody: AdminDeleteConversationBody, options?: Parameters<typeof customFetch>[1]): Promise<AdminDeleteConversation200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AdminDeleteConversation200>(getAdminDeleteConversationUrl(id),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminDeleteConversationBody)
  }
);}





export const getAdminDeleteConversationMutationKey = () => ['adminDeleteConversation'] as const;

export const getAdminDeleteConversationMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteConversation>>, TError,AdminDeleteConversationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteConversation>>, TError,AdminDeleteConversationMutationVariables, TContext> => {

const mutationKey = getAdminDeleteConversationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteConversation>>, AdminDeleteConversationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminDeleteConversation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteConversationMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteConversation>>>
    export type AdminDeleteConversationMutationBody = BodyType<AdminDeleteConversationBody>
    export type AdminDeleteConversationMutationError = ErrorType<ApiError>
    export type AdminDeleteConversationMutationVariables = {id: string;data: BodyType<AdminDeleteConversationBody>}

    /**
 * @summary Hard-delete a conversation and every message in it (platform admin only)
 */
export const useAdminDeleteConversation = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteConversation>>, TError,AdminDeleteConversationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminDeleteConversation>>,
        TError,
        AdminDeleteConversationMutationVariables,
        TContext
      > => {
      return useMutation(getAdminDeleteConversationMutationOptions(options));
    }

export const getCreateReportUrl = () => {




  return `/api/reports`
}

/**
 * @summary Report an abusive teaming post or conversation to admins
 */
export const createReport = async (createReportBody: CreateReportBody, options?: Parameters<typeof customFetch>[1]): Promise<CreateReport200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<CreateReport200>(getCreateReportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createReportBody)
  }
);}





export const getCreateReportMutationKey = () => ['createReport'] as const;

export const getCreateReportMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReport>>, TError,CreateReportMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createReport>>, TError,CreateReportMutationVariables, TContext> => {

const mutationKey = getCreateReportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReport>>, CreateReportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReportMutationResult = NonNullable<Awaited<ReturnType<typeof createReport>>>
    export type CreateReportMutationBody = BodyType<CreateReportBody>
    export type CreateReportMutationError = ErrorType<ApiError>
    export type CreateReportMutationVariables = {data: BodyType<CreateReportBody>}

    /**
 * @summary Report an abusive teaming post or conversation to admins
 */
export const useCreateReport = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReport>>, TError,CreateReportMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createReport>>,
        TError,
        CreateReportMutationVariables,
        TContext
      > => {
      return useMutation(getCreateReportMutationOptions(options));
    }

export const getAdminListReportsUrl = (params?: AdminListReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/reports?${stringifiedParams}` : `/api/admin/reports`
}

/**
 * @summary List user-submitted reports (platform admin only)
 */
export const adminListReports = async (params?: AdminListReportsParams, options?: Parameters<typeof customFetch>[1]): Promise<AdminListReports200> => {

  return customFetch<AdminListReports200>(getAdminListReportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListReportsQueryKey = (params?: AdminListReportsParams,) => {
    return [
    `/api/admin/reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListReportsQueryOptions = <TData = Awaited<ReturnType<typeof adminListReports>>, TError = ErrorType<unknown>>(params?: AdminListReportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListReportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListReports>>> = ({ signal }) => adminListReports(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListReports>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminListReportsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListReports>>>
export type AdminListReportsQueryError = ErrorType<unknown>


/**
 * @summary List user-submitted reports (platform admin only)
 */

export function useAdminListReports<TData = Awaited<ReturnType<typeof adminListReports>>, TError = ErrorType<unknown>>(
 params?: AdminListReportsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof adminListReports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAdminListReportsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminResolveReportUrl = (id: string,) => {




  return `/api/admin/reports/${id}/resolve`
}

/**
 * @summary Mark a report as reviewed (platform admin only)
 */
export const adminResolveReport = async (id: string,
    adminResolveReportBody?: AdminResolveReportBody, options?: Parameters<typeof customFetch>[1]): Promise<AdminResolveReport200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AdminResolveReport200>(getAdminResolveReportUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminResolveReportBody)
  }
);}





export const getAdminResolveReportMutationKey = () => ['adminResolveReport'] as const;

export const getAdminResolveReportMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminResolveReport>>, TError,AdminResolveReportMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminResolveReport>>, TError,AdminResolveReportMutationVariables, TContext> => {

const mutationKey = getAdminResolveReportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminResolveReport>>, AdminResolveReportMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  adminResolveReport(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminResolveReportMutationResult = NonNullable<Awaited<ReturnType<typeof adminResolveReport>>>
    export type AdminResolveReportMutationBody = BodyType<AdminResolveReportBody> | undefined
    export type AdminResolveReportMutationError = ErrorType<ApiError>
    export type AdminResolveReportMutationVariables = {id: string;data?: BodyType<AdminResolveReportBody>}

    /**
 * @summary Mark a report as reviewed (platform admin only)
 */
export const useAdminResolveReport = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminResolveReport>>, TError,AdminResolveReportMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof adminResolveReport>>,
        TError,
        AdminResolveReportMutationVariables,
        TContext
      > => {
      return useMutation(getAdminResolveReportMutationOptions(options));
    }

export const getListAiReviewQueueUrl = () => {




  return `/api/admin/ai-queue`
}

/**
 * @summary AI extractions awaiting human review
 */
export const listAiReviewQueue = async ( options?: Parameters<typeof customFetch>[1]): Promise<AiExtraction[]> => {

  return customFetch<AiExtraction[]>(getListAiReviewQueueUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAiReviewQueueQueryKey = () => {
    return [
    `/api/admin/ai-queue`
    ] as const;
    }


export const getListAiReviewQueueQueryOptions = <TData = Awaited<ReturnType<typeof listAiReviewQueue>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAiReviewQueue>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAiReviewQueueQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiReviewQueue>>> = ({ signal }) => listAiReviewQueue({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiReviewQueue>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAiReviewQueueQueryResult = NonNullable<Awaited<ReturnType<typeof listAiReviewQueue>>>
export type ListAiReviewQueueQueryError = ErrorType<unknown>


/**
 * @summary AI extractions awaiting human review
 */

export function useListAiReviewQueue<TData = Awaited<ReturnType<typeof listAiReviewQueue>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAiReviewQueue>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAiReviewQueueQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListTestResultsUrl = () => {




  return `/api/admin/test-results`
}

export const listTestResults = async ( options?: Parameters<typeof customFetch>[1]): Promise<TestResult[]> => {

  return customFetch<TestResult[]>(getListTestResultsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTestResultsQueryKey = () => {
    return [
    `/api/admin/test-results`
    ] as const;
    }


export const getListTestResultsQueryOptions = <TData = Awaited<ReturnType<typeof listTestResults>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTestResults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTestResultsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTestResults>>> = ({ signal }) => listTestResults({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTestResults>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTestResultsQueryResult = NonNullable<Awaited<ReturnType<typeof listTestResults>>>
export type ListTestResultsQueryError = ErrorType<unknown>



export function useListTestResults<TData = Awaited<ReturnType<typeof listTestResults>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTestResults>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTestResultsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDiscoverVendorsUrl = (params?: DiscoverVendorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/discovery/vendors?${stringifiedParams}` : `/api/discovery/vendors`
}

/**
 * @summary Search the SAM.gov vendor universe with On-SPN flags
 */
export const discoverVendors = async (params?: DiscoverVendorsParams, options?: Parameters<typeof customFetch>[1]): Promise<DiscoveryResults> => {

  return customFetch<DiscoveryResults>(getDiscoverVendorsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDiscoverVendorsQueryKey = (params?: DiscoverVendorsParams,) => {
    return [
    `/api/discovery/vendors`, ...(params ? [params] : [])
    ] as const;
    }


export const getDiscoverVendorsQueryOptions = <TData = Awaited<ReturnType<typeof discoverVendors>>, TError = ErrorType<ApiError>>(params?: DiscoverVendorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof discoverVendors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDiscoverVendorsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof discoverVendors>>> = ({ signal }) => discoverVendors(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof discoverVendors>>, TError, TData> & { queryKey: QueryKey }
}

export type DiscoverVendorsQueryResult = NonNullable<Awaited<ReturnType<typeof discoverVendors>>>
export type DiscoverVendorsQueryError = ErrorType<ApiError>


/**
 * @summary Search the SAM.gov vendor universe with On-SPN flags
 */

export function useDiscoverVendors<TData = Awaited<ReturnType<typeof discoverVendors>>, TError = ErrorType<ApiError>>(
 params?: DiscoverVendorsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof discoverVendors>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDiscoverVendorsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetDiscoveryVendorUrl = (uei: string,) => {




  return `/api/discovery/vendors/${uei}`
}

/**
 * @summary SAM.gov entity + USAspending summary for one UEI
 */
export const getDiscoveryVendor = async (uei: string, options?: Parameters<typeof customFetch>[1]): Promise<DiscoveryDetail> => {

  return customFetch<DiscoveryDetail>(getGetDiscoveryVendorUrl(uei),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDiscoveryVendorQueryKey = (uei: string,) => {
    return [
    `/api/discovery/vendors/${uei}`
    ] as const;
    }


export const getGetDiscoveryVendorQueryOptions = <TData = Awaited<ReturnType<typeof getDiscoveryVendor>>, TError = ErrorType<ApiError>>(uei: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDiscoveryVendor>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDiscoveryVendorQueryKey(uei);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscoveryVendor>>> = ({ signal }) => getDiscoveryVendor(uei, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uei !== null && uei !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDiscoveryVendor>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDiscoveryVendorQueryResult = NonNullable<Awaited<ReturnType<typeof getDiscoveryVendor>>>
export type GetDiscoveryVendorQueryError = ErrorType<ApiError>


/**
 * @summary SAM.gov entity + USAspending summary for one UEI
 */

export function useGetDiscoveryVendor<TData = Awaited<ReturnType<typeof getDiscoveryVendor>>, TError = ErrorType<ApiError>>(
 uei: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDiscoveryVendor>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDiscoveryVendorQueryOptions(uei,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getEnrichVendorContactUrl = (uei: string,
    params?: EnrichVendorContactParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/discovery/vendors/${uei}/enrich-contact?${stringifiedParams}` : `/api/discovery/vendors/${uei}/enrich-contact`
}

/**
 * Runs the Seamless.ai search → research → poll flow for the vendor's
 * SAM.gov point-of-contact name and permanently caches the result
 * (email, phone, title) against the UEI, shared across all workspaces.
 * Each successful research call consumes a paid Seamless credit, so a
 * vendor whose contact was already found is never looked up again —
 * the cached data is returned with `cached: true` instead. A prior
 * `not_found`/`error` outcome can be explicitly retried by calling
 * this endpoint again.
 * @summary Look up contact email/phone via Seamless.ai (workspace admin or platform admin)
 */
export const enrichVendorContact = async (uei: string,
    params?: EnrichVendorContactParams, options?: Parameters<typeof customFetch>[1]): Promise<EnrichedContactResult> => {

  return customFetch<EnrichedContactResult>(getEnrichVendorContactUrl(uei,params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getEnrichVendorContactMutationKey = () => ['enrichVendorContact'] as const;

export const getEnrichVendorContactMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrichVendorContact>>, TError,EnrichVendorContactMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof enrichVendorContact>>, TError,EnrichVendorContactMutationVariables, TContext> => {

const mutationKey = getEnrichVendorContactMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enrichVendorContact>>, EnrichVendorContactMutationVariables> = (props) => {
          const {uei,params} = props ?? {};

          return  enrichVendorContact(uei,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnrichVendorContactMutationResult = NonNullable<Awaited<ReturnType<typeof enrichVendorContact>>>

    export type EnrichVendorContactMutationError = ErrorType<ApiError>
    export type EnrichVendorContactMutationVariables = {uei: string;params?: EnrichVendorContactParams}

    /**
 * @summary Look up contact email/phone via Seamless.ai (workspace admin or platform admin)
 */
export const useEnrichVendorContact = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enrichVendorContact>>, TError,EnrichVendorContactMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof enrichVendorContact>>,
        TError,
        EnrichVendorContactMutationVariables,
        TContext
      > => {
      return useMutation(getEnrichVendorContactMutationOptions(options));
    }

export const getGetVendorContactSuggestionUrl = (uei: string,) => {




  return `/api/discovery/vendors/${uei}/contact-suggestion`
}

/**
 * @summary Suggest likely contact emails for an off-SPN vendor
 */
export const getVendorContactSuggestion = async (uei: string, options?: Parameters<typeof customFetch>[1]): Promise<VendorContactSuggestion> => {

  return customFetch<VendorContactSuggestion>(getGetVendorContactSuggestionUrl(uei),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetVendorContactSuggestionQueryKey = (uei: string,) => {
    return [
    `/api/discovery/vendors/${uei}/contact-suggestion`
    ] as const;
    }


export const getGetVendorContactSuggestionQueryOptions = <TData = Awaited<ReturnType<typeof getVendorContactSuggestion>>, TError = ErrorType<unknown>>(uei: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorContactSuggestion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVendorContactSuggestionQueryKey(uei);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVendorContactSuggestion>>> = ({ signal }) => getVendorContactSuggestion(uei, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uei !== null && uei !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVendorContactSuggestion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVendorContactSuggestionQueryResult = NonNullable<Awaited<ReturnType<typeof getVendorContactSuggestion>>>
export type GetVendorContactSuggestionQueryError = ErrorType<unknown>


/**
 * @summary Suggest likely contact emails for an off-SPN vendor
 */

export function useGetVendorContactSuggestion<TData = Awaited<ReturnType<typeof getVendorContactSuggestion>>, TError = ErrorType<unknown>>(
 uei: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVendorContactSuggestion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetVendorContactSuggestionQueryOptions(uei,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListWatchlistUrl = () => {




  return `/api/watchlist`
}

/**
 * @summary Current user's vendor watchlist
 */
export const listWatchlist = async ( options?: Parameters<typeof customFetch>[1]): Promise<WatchlistEntry[]> => {

  return customFetch<WatchlistEntry[]>(getListWatchlistUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWatchlistQueryKey = () => {
    return [
    `/api/watchlist`
    ] as const;
    }


export const getListWatchlistQueryOptions = <TData = Awaited<ReturnType<typeof listWatchlist>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWatchlist>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWatchlistQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWatchlist>>> = ({ signal }) => listWatchlist({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWatchlist>>, TError, TData> & { queryKey: QueryKey }
}

export type ListWatchlistQueryResult = NonNullable<Awaited<ReturnType<typeof listWatchlist>>>
export type ListWatchlistQueryError = ErrorType<unknown>


/**
 * @summary Current user's vendor watchlist
 */

export function useListWatchlist<TData = Awaited<ReturnType<typeof listWatchlist>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listWatchlist>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListWatchlistQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddWatchlistEntryUrl = () => {




  return `/api/watchlist`
}

/**
 * @summary Add a SAM.gov vendor to the watchlist
 */
export const addWatchlistEntry = async (addWatchlistEntryBody: AddWatchlistEntryBody, options?: Parameters<typeof customFetch>[1]): Promise<WatchlistEntry> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<WatchlistEntry>(getAddWatchlistEntryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addWatchlistEntryBody)
  }
);}





export const getAddWatchlistEntryMutationKey = () => ['addWatchlistEntry'] as const;

export const getAddWatchlistEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWatchlistEntry>>, TError,AddWatchlistEntryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addWatchlistEntry>>, TError,AddWatchlistEntryMutationVariables, TContext> => {

const mutationKey = getAddWatchlistEntryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addWatchlistEntry>>, AddWatchlistEntryMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addWatchlistEntry(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddWatchlistEntryMutationResult = NonNullable<Awaited<ReturnType<typeof addWatchlistEntry>>>
    export type AddWatchlistEntryMutationBody = BodyType<AddWatchlistEntryBody>
    export type AddWatchlistEntryMutationError = ErrorType<unknown>
    export type AddWatchlistEntryMutationVariables = {data: BodyType<AddWatchlistEntryBody>}

    /**
 * @summary Add a SAM.gov vendor to the watchlist
 */
export const useAddWatchlistEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWatchlistEntry>>, TError,AddWatchlistEntryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addWatchlistEntry>>,
        TError,
        AddWatchlistEntryMutationVariables,
        TContext
      > => {
      return useMutation(getAddWatchlistEntryMutationOptions(options));
    }

export const getRemoveWatchlistEntryUrl = (uei: string,) => {




  return `/api/watchlist/${uei}`
}

/**
 * @summary Remove a vendor from the watchlist
 */
export const removeWatchlistEntry = async (uei: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRemoveWatchlistEntryUrl(uei),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveWatchlistEntryMutationKey = () => ['removeWatchlistEntry'] as const;

export const getRemoveWatchlistEntryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeWatchlistEntry>>, TError,RemoveWatchlistEntryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeWatchlistEntry>>, TError,RemoveWatchlistEntryMutationVariables, TContext> => {

const mutationKey = getRemoveWatchlistEntryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeWatchlistEntry>>, RemoveWatchlistEntryMutationVariables> = (props) => {
          const {uei} = props ?? {};

          return  removeWatchlistEntry(uei,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveWatchlistEntryMutationResult = NonNullable<Awaited<ReturnType<typeof removeWatchlistEntry>>>

    export type RemoveWatchlistEntryMutationError = ErrorType<unknown>
    export type RemoveWatchlistEntryMutationVariables = {uei: string}

    /**
 * @summary Remove a vendor from the watchlist
 */
export const useRemoveWatchlistEntry = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeWatchlistEntry>>, TError,RemoveWatchlistEntryMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeWatchlistEntry>>,
        TError,
        RemoveWatchlistEntryMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveWatchlistEntryMutationOptions(options));
    }

export const getListVendorInvitesUrl = () => {




  return `/api/vendor-invites`
}

/**
 * @summary Invitations sent by the current tenant
 */
export const listVendorInvites = async ( options?: Parameters<typeof customFetch>[1]): Promise<VendorInviteRecord[]> => {

  return customFetch<VendorInviteRecord[]>(getListVendorInvitesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVendorInvitesQueryKey = () => {
    return [
    `/api/vendor-invites`
    ] as const;
    }


export const getListVendorInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listVendorInvites>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVendorInvitesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVendorInvites>>> = ({ signal }) => listVendorInvites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVendorInvites>>, TError, TData> & { queryKey: QueryKey }
}

export type ListVendorInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listVendorInvites>>>
export type ListVendorInvitesQueryError = ErrorType<unknown>


/**
 * @summary Invitations sent by the current tenant
 */

export function useListVendorInvites<TData = Awaited<ReturnType<typeof listVendorInvites>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listVendorInvites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListVendorInvitesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendVendorInviteUrl = () => {




  return `/api/vendor-invites`
}

/**
 * @summary Send a branded invite email to an off-SPN vendor
 */
export const sendVendorInvite = async (sendVendorInviteBody: SendVendorInviteBody, options?: Parameters<typeof customFetch>[1]): Promise<VendorInviteRecord> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<VendorInviteRecord>(getSendVendorInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendVendorInviteBody)
  }
);}





export const getSendVendorInviteMutationKey = () => ['sendVendorInvite'] as const;

export const getSendVendorInviteMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendVendorInvite>>, TError,SendVendorInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendVendorInvite>>, TError,SendVendorInviteMutationVariables, TContext> => {

const mutationKey = getSendVendorInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendVendorInvite>>, SendVendorInviteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendVendorInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendVendorInviteMutationResult = NonNullable<Awaited<ReturnType<typeof sendVendorInvite>>>
    export type SendVendorInviteMutationBody = BodyType<SendVendorInviteBody>
    export type SendVendorInviteMutationError = ErrorType<ApiError>
    export type SendVendorInviteMutationVariables = {data: BodyType<SendVendorInviteBody>}

    /**
 * @summary Send a branded invite email to an off-SPN vendor
 */
export const useSendVendorInvite = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendVendorInvite>>, TError,SendVendorInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendVendorInvite>>,
        TError,
        SendVendorInviteMutationVariables,
        TContext
      > => {
      return useMutation(getSendVendorInviteMutationOptions(options));
    }

export const getRevokeVendorInviteUrl = (uei: string,) => {




  return `/api/vendor-invites/${uei}`
}

/**
 * @summary Revoke (withdraw) a non-accepted invite so the vendor can be re-invited
 */
export const revokeVendorInvite = async (uei: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRevokeVendorInviteUrl(uei),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeVendorInviteMutationKey = () => ['revokeVendorInvite'] as const;

export const getRevokeVendorInviteMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeVendorInvite>>, TError,RevokeVendorInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeVendorInvite>>, TError,RevokeVendorInviteMutationVariables, TContext> => {

const mutationKey = getRevokeVendorInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeVendorInvite>>, RevokeVendorInviteMutationVariables> = (props) => {
          const {uei} = props ?? {};

          return  revokeVendorInvite(uei,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeVendorInviteMutationResult = NonNullable<Awaited<ReturnType<typeof revokeVendorInvite>>>

    export type RevokeVendorInviteMutationError = ErrorType<ApiError>
    export type RevokeVendorInviteMutationVariables = {uei: string}

    /**
 * @summary Revoke (withdraw) a non-accepted invite so the vendor can be re-invited
 */
export const useRevokeVendorInvite = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeVendorInvite>>, TError,RevokeVendorInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeVendorInvite>>,
        TError,
        RevokeVendorInviteMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeVendorInviteMutationOptions(options));
    }

export const getResendVendorInviteUrl = (uei: string,) => {




  return `/api/vendor-invites/${uei}/resend`
}

/**
 * @summary Resend an existing non-accepted invite, optionally to a new email
 */
export const resendVendorInvite = async (uei: string,
    vendorInviteResend: VendorInviteResend, options?: Parameters<typeof customFetch>[1]): Promise<VendorInviteRecord> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<VendorInviteRecord>(getResendVendorInviteUrl(uei),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(vendorInviteResend)
  }
);}





export const getResendVendorInviteMutationKey = () => ['resendVendorInvite'] as const;

export const getResendVendorInviteMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendVendorInvite>>, TError,ResendVendorInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendVendorInvite>>, TError,ResendVendorInviteMutationVariables, TContext> => {

const mutationKey = getResendVendorInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendVendorInvite>>, ResendVendorInviteMutationVariables> = (props) => {
          const {uei,data} = props ?? {};

          return  resendVendorInvite(uei,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendVendorInviteMutationResult = NonNullable<Awaited<ReturnType<typeof resendVendorInvite>>>
    export type ResendVendorInviteMutationBody = BodyType<VendorInviteResend>
    export type ResendVendorInviteMutationError = ErrorType<ApiError>
    export type ResendVendorInviteMutationVariables = {uei: string;data: BodyType<VendorInviteResend>}

    /**
 * @summary Resend an existing non-accepted invite, optionally to a new email
 */
export const useResendVendorInvite = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendVendorInvite>>, TError,ResendVendorInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resendVendorInvite>>,
        TError,
        ResendVendorInviteMutationVariables,
        TContext
      > => {
      return useMutation(getResendVendorInviteMutationOptions(options));
    }

export const getSendVendorInvitesBulkUrl = () => {




  return `/api/vendor-invites/bulk`
}

/**
 * @summary Send multiple vendor invitations in one call (per-row results)
 */
export const sendVendorInvitesBulk = async (sendVendorInvitesBulkBody: SendVendorInvitesBulkBody, options?: Parameters<typeof customFetch>[1]): Promise<BulkInviteResults> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<BulkInviteResults>(getSendVendorInvitesBulkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendVendorInvitesBulkBody)
  }
);}





export const getSendVendorInvitesBulkMutationKey = () => ['sendVendorInvitesBulk'] as const;

export const getSendVendorInvitesBulkMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendVendorInvitesBulk>>, TError,SendVendorInvitesBulkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendVendorInvitesBulk>>, TError,SendVendorInvitesBulkMutationVariables, TContext> => {

const mutationKey = getSendVendorInvitesBulkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendVendorInvitesBulk>>, SendVendorInvitesBulkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendVendorInvitesBulk(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendVendorInvitesBulkMutationResult = NonNullable<Awaited<ReturnType<typeof sendVendorInvitesBulk>>>
    export type SendVendorInvitesBulkMutationBody = BodyType<SendVendorInvitesBulkBody>
    export type SendVendorInvitesBulkMutationError = ErrorType<ApiError>
    export type SendVendorInvitesBulkMutationVariables = {data: BodyType<SendVendorInvitesBulkBody>}

    /**
 * @summary Send multiple vendor invitations in one call (per-row results)
 */
export const useSendVendorInvitesBulk = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendVendorInvitesBulk>>, TError,SendVendorInvitesBulkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendVendorInvitesBulk>>,
        TError,
        SendVendorInvitesBulkMutationVariables,
        TContext
      > => {
      return useMutation(getSendVendorInvitesBulkMutationOptions(options));
    }

export const getOptOutOfInvitesUrl = (token: string,) => {




  return `/api/vendor-invites/opt-out/${token}`
}

/**
 * @summary Recipient opt-out endpoint (token from invite email)
 */
export const optOutOfInvites = async (token: string, options?: Parameters<typeof customFetch>[1]): Promise<OptOutOfInvites200> => {

  return customFetch<OptOutOfInvites200>(getOptOutOfInvitesUrl(token),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOptOutOfInvitesMutationKey = () => ['optOutOfInvites'] as const;

export const getOptOutOfInvitesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof optOutOfInvites>>, TError,OptOutOfInvitesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof optOutOfInvites>>, TError,OptOutOfInvitesMutationVariables, TContext> => {

const mutationKey = getOptOutOfInvitesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof optOutOfInvites>>, OptOutOfInvitesMutationVariables> = (props) => {
          const {token} = props ?? {};

          return  optOutOfInvites(token,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OptOutOfInvitesMutationResult = NonNullable<Awaited<ReturnType<typeof optOutOfInvites>>>

    export type OptOutOfInvitesMutationError = ErrorType<unknown>
    export type OptOutOfInvitesMutationVariables = {token: string}

    /**
 * @summary Recipient opt-out endpoint (token from invite email)
 */
export const useOptOutOfInvites = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof optOutOfInvites>>, TError,OptOutOfInvitesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof optOutOfInvites>>,
        TError,
        OptOutOfInvitesMutationVariables,
        TContext
      > => {
      return useMutation(getOptOutOfInvitesMutationOptions(options));
    }

export const getListMarketplaceOpportunitiesUrl = (params?: ListMarketplaceOpportunitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/marketplace/opportunities?${stringifiedParams}` : `/api/marketplace/opportunities`
}

/**
 * @summary List published marketplace opportunities (filterable)
 */
export const listMarketplaceOpportunities = async (params?: ListMarketplaceOpportunitiesParams, options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceOpportunityWithMatch[]> => {

  return customFetch<MarketplaceOpportunityWithMatch[]>(getListMarketplaceOpportunitiesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMarketplaceOpportunitiesQueryKey = (params?: ListMarketplaceOpportunitiesParams,) => {
    return [
    `/api/marketplace/opportunities`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMarketplaceOpportunitiesQueryOptions = <TData = Awaited<ReturnType<typeof listMarketplaceOpportunities>>, TError = ErrorType<unknown>>(params?: ListMarketplaceOpportunitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMarketplaceOpportunities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMarketplaceOpportunitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMarketplaceOpportunities>>> = ({ signal }) => listMarketplaceOpportunities(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMarketplaceOpportunities>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMarketplaceOpportunitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listMarketplaceOpportunities>>>
export type ListMarketplaceOpportunitiesQueryError = ErrorType<unknown>


/**
 * @summary List published marketplace opportunities (filterable)
 */

export function useListMarketplaceOpportunities<TData = Awaited<ReturnType<typeof listMarketplaceOpportunities>>, TError = ErrorType<unknown>>(
 params?: ListMarketplaceOpportunitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMarketplaceOpportunities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMarketplaceOpportunitiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMarketplaceFilterOptionsUrl = () => {




  return `/api/marketplace/filter-options`
}

/**
 * @summary Distinct filter values present in published, actionable marketplace opportunities
 */
export const getMarketplaceFilterOptions = async ( options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceFilterOptions> => {

  return customFetch<MarketplaceFilterOptions>(getGetMarketplaceFilterOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMarketplaceFilterOptionsQueryKey = () => {
    return [
    `/api/marketplace/filter-options`
    ] as const;
    }


export const getGetMarketplaceFilterOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getMarketplaceFilterOptions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceFilterOptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketplaceFilterOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketplaceFilterOptions>>> = ({ signal }) => getMarketplaceFilterOptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceFilterOptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMarketplaceFilterOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketplaceFilterOptions>>>
export type GetMarketplaceFilterOptionsQueryError = ErrorType<unknown>


/**
 * @summary Distinct filter values present in published, actionable marketplace opportunities
 */

export function useGetMarketplaceFilterOptions<TData = Awaited<ReturnType<typeof getMarketplaceFilterOptions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceFilterOptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMarketplaceFilterOptionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMarketplaceSummaryUrl = () => {




  return `/api/marketplace/summary`
}

/**
 * @summary Stats-strip aggregates for the marketplace opportunities tab
 */
export const getMarketplaceSummary = async ( options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceSummary> => {

  return customFetch<MarketplaceSummary>(getGetMarketplaceSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMarketplaceSummaryQueryKey = () => {
    return [
    `/api/marketplace/summary`
    ] as const;
    }


export const getGetMarketplaceSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getMarketplaceSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketplaceSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketplaceSummary>>> = ({ signal }) => getMarketplaceSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMarketplaceSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketplaceSummary>>>
export type GetMarketplaceSummaryQueryError = ErrorType<unknown>


/**
 * @summary Stats-strip aggregates for the marketplace opportunities tab
 */

export function useGetMarketplaceSummary<TData = Awaited<ReturnType<typeof getMarketplaceSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMarketplaceSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMarketplaceRecommendedOpportunitiesUrl = () => {




  return `/api/marketplace/recommended-opportunities`
}

/**
 * @summary Viewer's top-scoring open opportunities not yet saved or interested-in
 */
export const getMarketplaceRecommendedOpportunities = async ( options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceRecommendedOpportunities> => {

  return customFetch<MarketplaceRecommendedOpportunities>(getGetMarketplaceRecommendedOpportunitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMarketplaceRecommendedOpportunitiesQueryKey = () => {
    return [
    `/api/marketplace/recommended-opportunities`
    ] as const;
    }


export const getGetMarketplaceRecommendedOpportunitiesQueryOptions = <TData = Awaited<ReturnType<typeof getMarketplaceRecommendedOpportunities>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceRecommendedOpportunities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketplaceRecommendedOpportunitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketplaceRecommendedOpportunities>>> = ({ signal }) => getMarketplaceRecommendedOpportunities({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceRecommendedOpportunities>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMarketplaceRecommendedOpportunitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketplaceRecommendedOpportunities>>>
export type GetMarketplaceRecommendedOpportunitiesQueryError = ErrorType<unknown>


/**
 * @summary Viewer's top-scoring open opportunities not yet saved or interested-in
 */

export function useGetMarketplaceRecommendedOpportunities<TData = Awaited<ReturnType<typeof getMarketplaceRecommendedOpportunities>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceRecommendedOpportunities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMarketplaceRecommendedOpportunitiesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMarketplaceTrendingCapabilitiesUrl = () => {




  return `/api/marketplace/trending-capabilities`
}

/**
 * @summary Capability tags trending across open opportunities (min activity threshold)
 */
export const getMarketplaceTrendingCapabilities = async ( options?: Parameters<typeof customFetch>[1]): Promise<TrendingCapability[]> => {

  return customFetch<TrendingCapability[]>(getGetMarketplaceTrendingCapabilitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMarketplaceTrendingCapabilitiesQueryKey = () => {
    return [
    `/api/marketplace/trending-capabilities`
    ] as const;
    }


export const getGetMarketplaceTrendingCapabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof getMarketplaceTrendingCapabilities>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceTrendingCapabilities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketplaceTrendingCapabilitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketplaceTrendingCapabilities>>> = ({ signal }) => getMarketplaceTrendingCapabilities({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceTrendingCapabilities>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMarketplaceTrendingCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketplaceTrendingCapabilities>>>
export type GetMarketplaceTrendingCapabilitiesQueryError = ErrorType<unknown>


/**
 * @summary Capability tags trending across open opportunities (min activity threshold)
 */

export function useGetMarketplaceTrendingCapabilities<TData = Awaited<ReturnType<typeof getMarketplaceTrendingCapabilities>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceTrendingCapabilities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMarketplaceTrendingCapabilitiesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMarketplaceActivityUrl = () => {




  return `/api/marketplace/activity`
}

/**
 * @summary Viewer-scoped recent marketplace activity (own saves, own interest, deadlines)
 */
export const getMarketplaceActivity = async ( options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceActivityEvent[]> => {

  return customFetch<MarketplaceActivityEvent[]>(getGetMarketplaceActivityUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMarketplaceActivityQueryKey = () => {
    return [
    `/api/marketplace/activity`
    ] as const;
    }


export const getGetMarketplaceActivityQueryOptions = <TData = Awaited<ReturnType<typeof getMarketplaceActivity>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketplaceActivityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketplaceActivity>>> = ({ signal }) => getMarketplaceActivity({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMarketplaceActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketplaceActivity>>>
export type GetMarketplaceActivityQueryError = ErrorType<unknown>


/**
 * @summary Viewer-scoped recent marketplace activity (own saves, own interest, deadlines)
 */

export function useGetMarketplaceActivity<TData = Awaited<ReturnType<typeof getMarketplaceActivity>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMarketplaceActivityQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListMyMarketplaceInterestsUrl = () => {




  return `/api/marketplace/my-interests`
}

/**
 * @summary Published opportunities the caller has expressed interest in
 */
export const listMyMarketplaceInterests = async ( options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceOpportunityWithMatch[]> => {

  return customFetch<MarketplaceOpportunityWithMatch[]>(getListMyMarketplaceInterestsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyMarketplaceInterestsQueryKey = () => {
    return [
    `/api/marketplace/my-interests`
    ] as const;
    }


export const getListMyMarketplaceInterestsQueryOptions = <TData = Awaited<ReturnType<typeof listMyMarketplaceInterests>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyMarketplaceInterests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyMarketplaceInterestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyMarketplaceInterests>>> = ({ signal }) => listMyMarketplaceInterests({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyMarketplaceInterests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMyMarketplaceInterestsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyMarketplaceInterests>>>
export type ListMyMarketplaceInterestsQueryError = ErrorType<unknown>


/**
 * @summary Published opportunities the caller has expressed interest in
 */

export function useListMyMarketplaceInterests<TData = Awaited<ReturnType<typeof listMyMarketplaceInterests>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyMarketplaceInterests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMyMarketplaceInterestsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMarketplaceOpportunityUrl = (id: string,) => {




  return `/api/marketplace/opportunities/${id}`
}

export const getMarketplaceOpportunity = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceOpportunityWithMatch> => {

  return customFetch<MarketplaceOpportunityWithMatch>(getGetMarketplaceOpportunityUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMarketplaceOpportunityQueryKey = (id: string,) => {
    return [
    `/api/marketplace/opportunities/${id}`
    ] as const;
    }


export const getGetMarketplaceOpportunityQueryOptions = <TData = Awaited<ReturnType<typeof getMarketplaceOpportunity>>, TError = ErrorType<ApiError>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceOpportunity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketplaceOpportunityQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketplaceOpportunity>>> = ({ signal }) => getMarketplaceOpportunity(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceOpportunity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMarketplaceOpportunityQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketplaceOpportunity>>>
export type GetMarketplaceOpportunityQueryError = ErrorType<ApiError>



export function useGetMarketplaceOpportunity<TData = Awaited<ReturnType<typeof getMarketplaceOpportunity>>, TError = ErrorType<ApiError>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMarketplaceOpportunity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMarketplaceOpportunityQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getExpressInterestUrl = (id: string,) => {




  return `/api/marketplace/opportunities/${id}/express-interest`
}

export const expressInterest = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ExpressInterest200> => {

  return customFetch<ExpressInterest200>(getExpressInterestUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getExpressInterestMutationKey = () => ['expressInterest'] as const;

export const getExpressInterestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof expressInterest>>, TError,ExpressInterestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof expressInterest>>, TError,ExpressInterestMutationVariables, TContext> => {

const mutationKey = getExpressInterestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof expressInterest>>, ExpressInterestMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  expressInterest(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExpressInterestMutationResult = NonNullable<Awaited<ReturnType<typeof expressInterest>>>

    export type ExpressInterestMutationError = ErrorType<unknown>
    export type ExpressInterestMutationVariables = {id: string}

    export const useExpressInterest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof expressInterest>>, TError,ExpressInterestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof expressInterest>>,
        TError,
        ExpressInterestMutationVariables,
        TContext
      > => {
      return useMutation(getExpressInterestMutationOptions(options));
    }

export const getListInterestedPartiesUrl = (id: string,) => {




  return `/api/marketplace/opportunities/${id}/interested-parties`
}

/**
 * @summary Deduplicated list of users who expressed interest (curators and the opportunity creator only)
 */
export const listInterestedParties = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<InterestedParty[]> => {

  return customFetch<InterestedParty[]>(getListInterestedPartiesUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInterestedPartiesQueryKey = (id: string,) => {
    return [
    `/api/marketplace/opportunities/${id}/interested-parties`
    ] as const;
    }


export const getListInterestedPartiesQueryOptions = <TData = Awaited<ReturnType<typeof listInterestedParties>>, TError = ErrorType<ApiError>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInterestedParties>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInterestedPartiesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInterestedParties>>> = ({ signal }) => listInterestedParties(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInterestedParties>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInterestedPartiesQueryResult = NonNullable<Awaited<ReturnType<typeof listInterestedParties>>>
export type ListInterestedPartiesQueryError = ErrorType<ApiError>


/**
 * @summary Deduplicated list of users who expressed interest (curators and the opportunity creator only)
 */

export function useListInterestedParties<TData = Awaited<ReturnType<typeof listInterestedParties>>, TError = ErrorType<ApiError>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInterestedParties>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInterestedPartiesQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddOpportunityToWatchlistUrl = (id: string,) => {




  return `/api/marketplace/opportunities/${id}/watchlist`
}

export const addOpportunityToWatchlist = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<AddOpportunityToWatchlist200> => {

  return customFetch<AddOpportunityToWatchlist200>(getAddOpportunityToWatchlistUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAddOpportunityToWatchlistMutationKey = () => ['addOpportunityToWatchlist'] as const;

export const getAddOpportunityToWatchlistMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOpportunityToWatchlist>>, TError,AddOpportunityToWatchlistMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addOpportunityToWatchlist>>, TError,AddOpportunityToWatchlistMutationVariables, TContext> => {

const mutationKey = getAddOpportunityToWatchlistMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOpportunityToWatchlist>>, AddOpportunityToWatchlistMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  addOpportunityToWatchlist(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddOpportunityToWatchlistMutationResult = NonNullable<Awaited<ReturnType<typeof addOpportunityToWatchlist>>>

    export type AddOpportunityToWatchlistMutationError = ErrorType<unknown>
    export type AddOpportunityToWatchlistMutationVariables = {id: string}

    export const useAddOpportunityToWatchlist = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOpportunityToWatchlist>>, TError,AddOpportunityToWatchlistMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addOpportunityToWatchlist>>,
        TError,
        AddOpportunityToWatchlistMutationVariables,
        TContext
      > => {
      return useMutation(getAddOpportunityToWatchlistMutationOptions(options));
    }

export const getRemoveOpportunityFromWatchlistUrl = (id: string,) => {




  return `/api/marketplace/opportunities/${id}/watchlist`
}

export const removeOpportunityFromWatchlist = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getRemoveOpportunityFromWatchlistUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveOpportunityFromWatchlistMutationKey = () => ['removeOpportunityFromWatchlist'] as const;

export const getRemoveOpportunityFromWatchlistMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOpportunityFromWatchlist>>, TError,RemoveOpportunityFromWatchlistMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeOpportunityFromWatchlist>>, TError,RemoveOpportunityFromWatchlistMutationVariables, TContext> => {

const mutationKey = getRemoveOpportunityFromWatchlistMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeOpportunityFromWatchlist>>, RemoveOpportunityFromWatchlistMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  removeOpportunityFromWatchlist(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveOpportunityFromWatchlistMutationResult = NonNullable<Awaited<ReturnType<typeof removeOpportunityFromWatchlist>>>

    export type RemoveOpportunityFromWatchlistMutationError = ErrorType<unknown>
    export type RemoveOpportunityFromWatchlistMutationVariables = {id: string}

    export const useRemoveOpportunityFromWatchlist = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeOpportunityFromWatchlist>>, TError,RemoveOpportunityFromWatchlistMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeOpportunityFromWatchlist>>,
        TError,
        RemoveOpportunityFromWatchlistMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveOpportunityFromWatchlistMutationOptions(options));
    }

export const getListOpportunityWatchlistUrl = () => {




  return `/api/marketplace/opportunity-watchlist`
}

export const listOpportunityWatchlist = async ( options?: Parameters<typeof customFetch>[1]): Promise<string[]> => {

  return customFetch<string[]>(getListOpportunityWatchlistUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpportunityWatchlistQueryKey = () => {
    return [
    `/api/marketplace/opportunity-watchlist`
    ] as const;
    }


export const getListOpportunityWatchlistQueryOptions = <TData = Awaited<ReturnType<typeof listOpportunityWatchlist>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpportunityWatchlist>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpportunityWatchlistQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpportunityWatchlist>>> = ({ signal }) => listOpportunityWatchlist({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpportunityWatchlist>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpportunityWatchlistQueryResult = NonNullable<Awaited<ReturnType<typeof listOpportunityWatchlist>>>
export type ListOpportunityWatchlistQueryError = ErrorType<unknown>



export function useListOpportunityWatchlist<TData = Awaited<ReturnType<typeof listOpportunityWatchlist>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpportunityWatchlist>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpportunityWatchlistQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListRoadmapItemsUrl = () => {




  return `/api/marketplace/roadmap`
}

/**
 * @summary List published roadmap items
 */
export const listRoadmapItems = async ( options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceRoadmapItem[]> => {

  return customFetch<MarketplaceRoadmapItem[]>(getListRoadmapItemsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRoadmapItemsQueryKey = () => {
    return [
    `/api/marketplace/roadmap`
    ] as const;
    }


export const getListRoadmapItemsQueryOptions = <TData = Awaited<ReturnType<typeof listRoadmapItems>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRoadmapItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRoadmapItemsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRoadmapItems>>> = ({ signal }) => listRoadmapItems({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRoadmapItems>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRoadmapItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listRoadmapItems>>>
export type ListRoadmapItemsQueryError = ErrorType<unknown>


/**
 * @summary List published roadmap items
 */

export function useListRoadmapItems<TData = Awaited<ReturnType<typeof listRoadmapItems>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRoadmapItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRoadmapItemsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRoadmapItemUrl = (id: string,) => {




  return `/api/marketplace/roadmap/${id}`
}

export const getRoadmapItem = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceRoadmapItem> => {

  return customFetch<MarketplaceRoadmapItem>(getGetRoadmapItemUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRoadmapItemQueryKey = (id: string,) => {
    return [
    `/api/marketplace/roadmap/${id}`
    ] as const;
    }


export const getGetRoadmapItemQueryOptions = <TData = Awaited<ReturnType<typeof getRoadmapItem>>, TError = ErrorType<ApiError>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRoadmapItem>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoadmapItemQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoadmapItem>>> = ({ signal }) => getRoadmapItem(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoadmapItem>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRoadmapItemQueryResult = NonNullable<Awaited<ReturnType<typeof getRoadmapItem>>>
export type GetRoadmapItemQueryError = ErrorType<ApiError>



export function useGetRoadmapItem<TData = Awaited<ReturnType<typeof getRoadmapItem>>, TError = ErrorType<ApiError>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRoadmapItem>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRoadmapItemQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubscribeRoadmapItemUrl = (id: string,) => {




  return `/api/marketplace/roadmap/${id}/subscribe`
}

export const subscribeRoadmapItem = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<SubscribeRoadmapItem200> => {

  return customFetch<SubscribeRoadmapItem200>(getSubscribeRoadmapItemUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSubscribeRoadmapItemMutationKey = () => ['subscribeRoadmapItem'] as const;

export const getSubscribeRoadmapItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeRoadmapItem>>, TError,SubscribeRoadmapItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof subscribeRoadmapItem>>, TError,SubscribeRoadmapItemMutationVariables, TContext> => {

const mutationKey = getSubscribeRoadmapItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscribeRoadmapItem>>, SubscribeRoadmapItemMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  subscribeRoadmapItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubscribeRoadmapItemMutationResult = NonNullable<Awaited<ReturnType<typeof subscribeRoadmapItem>>>

    export type SubscribeRoadmapItemMutationError = ErrorType<unknown>
    export type SubscribeRoadmapItemMutationVariables = {id: string}

    export const useSubscribeRoadmapItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscribeRoadmapItem>>, TError,SubscribeRoadmapItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof subscribeRoadmapItem>>,
        TError,
        SubscribeRoadmapItemMutationVariables,
        TContext
      > => {
      return useMutation(getSubscribeRoadmapItemMutationOptions(options));
    }

export const getUnsubscribeRoadmapItemUrl = (id: string,) => {




  return `/api/marketplace/roadmap/${id}/subscribe`
}

export const unsubscribeRoadmapItem = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getUnsubscribeRoadmapItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUnsubscribeRoadmapItemMutationKey = () => ['unsubscribeRoadmapItem'] as const;

export const getUnsubscribeRoadmapItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribeRoadmapItem>>, TError,UnsubscribeRoadmapItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unsubscribeRoadmapItem>>, TError,UnsubscribeRoadmapItemMutationVariables, TContext> => {

const mutationKey = getUnsubscribeRoadmapItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unsubscribeRoadmapItem>>, UnsubscribeRoadmapItemMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  unsubscribeRoadmapItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnsubscribeRoadmapItemMutationResult = NonNullable<Awaited<ReturnType<typeof unsubscribeRoadmapItem>>>

    export type UnsubscribeRoadmapItemMutationError = ErrorType<unknown>
    export type UnsubscribeRoadmapItemMutationVariables = {id: string}

    export const useUnsubscribeRoadmapItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribeRoadmapItem>>, TError,UnsubscribeRoadmapItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unsubscribeRoadmapItem>>,
        TError,
        UnsubscribeRoadmapItemMutationVariables,
        TContext
      > => {
      return useMutation(getUnsubscribeRoadmapItemMutationOptions(options));
    }

export const getListRoadmapSubscriptionsUrl = () => {




  return `/api/marketplace/roadmap-subscriptions`
}

export const listRoadmapSubscriptions = async ( options?: Parameters<typeof customFetch>[1]): Promise<string[]> => {

  return customFetch<string[]>(getListRoadmapSubscriptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRoadmapSubscriptionsQueryKey = () => {
    return [
    `/api/marketplace/roadmap-subscriptions`
    ] as const;
    }


export const getListRoadmapSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof listRoadmapSubscriptions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRoadmapSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRoadmapSubscriptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRoadmapSubscriptions>>> = ({ signal }) => listRoadmapSubscriptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRoadmapSubscriptions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRoadmapSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listRoadmapSubscriptions>>>
export type ListRoadmapSubscriptionsQueryError = ErrorType<unknown>



export function useListRoadmapSubscriptions<TData = Awaited<ReturnType<typeof listRoadmapSubscriptions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRoadmapSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRoadmapSubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListForumThreadsUrl = (params?: ListForumThreadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/marketplace/forum/threads?${stringifiedParams}` : `/api/marketplace/forum/threads`
}

export const listForumThreads = async (params?: ListForumThreadsParams, options?: Parameters<typeof customFetch>[1]): Promise<ForumThread[]> => {

  return customFetch<ForumThread[]>(getListForumThreadsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListForumThreadsQueryKey = (params?: ListForumThreadsParams,) => {
    return [
    `/api/marketplace/forum/threads`, ...(params ? [params] : [])
    ] as const;
    }


export const getListForumThreadsQueryOptions = <TData = Awaited<ReturnType<typeof listForumThreads>>, TError = ErrorType<unknown>>(params?: ListForumThreadsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listForumThreads>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListForumThreadsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listForumThreads>>> = ({ signal }) => listForumThreads(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listForumThreads>>, TError, TData> & { queryKey: QueryKey }
}

export type ListForumThreadsQueryResult = NonNullable<Awaited<ReturnType<typeof listForumThreads>>>
export type ListForumThreadsQueryError = ErrorType<unknown>



export function useListForumThreads<TData = Awaited<ReturnType<typeof listForumThreads>>, TError = ErrorType<unknown>>(
 params?: ListForumThreadsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listForumThreads>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListForumThreadsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateForumThreadUrl = () => {




  return `/api/marketplace/forum/threads`
}

export const createForumThread = async (createForumThreadBody: CreateForumThreadBody, options?: Parameters<typeof customFetch>[1]): Promise<ForumThread> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ForumThread>(getCreateForumThreadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createForumThreadBody)
  }
);}





export const getCreateForumThreadMutationKey = () => ['createForumThread'] as const;

export const getCreateForumThreadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForumThread>>, TError,CreateForumThreadMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createForumThread>>, TError,CreateForumThreadMutationVariables, TContext> => {

const mutationKey = getCreateForumThreadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createForumThread>>, CreateForumThreadMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createForumThread(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateForumThreadMutationResult = NonNullable<Awaited<ReturnType<typeof createForumThread>>>
    export type CreateForumThreadMutationBody = BodyType<CreateForumThreadBody>
    export type CreateForumThreadMutationError = ErrorType<unknown>
    export type CreateForumThreadMutationVariables = {data: BodyType<CreateForumThreadBody>}

    export const useCreateForumThread = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForumThread>>, TError,CreateForumThreadMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createForumThread>>,
        TError,
        CreateForumThreadMutationVariables,
        TContext
      > => {
      return useMutation(getCreateForumThreadMutationOptions(options));
    }

export const getGetForumThreadUrl = (id: string,) => {




  return `/api/marketplace/forum/threads/${id}`
}

export const getForumThread = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<GetForumThread200> => {

  return customFetch<GetForumThread200>(getGetForumThreadUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetForumThreadQueryKey = (id: string,) => {
    return [
    `/api/marketplace/forum/threads/${id}`
    ] as const;
    }


export const getGetForumThreadQueryOptions = <TData = Awaited<ReturnType<typeof getForumThread>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForumThread>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForumThreadQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForumThread>>> = ({ signal }) => getForumThread(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForumThread>>, TError, TData> & { queryKey: QueryKey }
}

export type GetForumThreadQueryResult = NonNullable<Awaited<ReturnType<typeof getForumThread>>>
export type GetForumThreadQueryError = ErrorType<unknown>



export function useGetForumThread<TData = Awaited<ReturnType<typeof getForumThread>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getForumThread>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetForumThreadQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReplyToForumThreadUrl = (id: string,) => {




  return `/api/marketplace/forum/threads/${id}/posts`
}

export const replyToForumThread = async (id: string,
    replyToForumThreadBody: ReplyToForumThreadBody, options?: Parameters<typeof customFetch>[1]): Promise<ForumPost> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ForumPost>(getReplyToForumThreadUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(replyToForumThreadBody)
  }
);}





export const getReplyToForumThreadMutationKey = () => ['replyToForumThread'] as const;

export const getReplyToForumThreadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyToForumThread>>, TError,ReplyToForumThreadMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replyToForumThread>>, TError,ReplyToForumThreadMutationVariables, TContext> => {

const mutationKey = getReplyToForumThreadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replyToForumThread>>, ReplyToForumThreadMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  replyToForumThread(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplyToForumThreadMutationResult = NonNullable<Awaited<ReturnType<typeof replyToForumThread>>>
    export type ReplyToForumThreadMutationBody = BodyType<ReplyToForumThreadBody>
    export type ReplyToForumThreadMutationError = ErrorType<unknown>
    export type ReplyToForumThreadMutationVariables = {id: string;data: BodyType<ReplyToForumThreadBody>}

    export const useReplyToForumThread = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replyToForumThread>>, TError,ReplyToForumThreadMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof replyToForumThread>>,
        TError,
        ReplyToForumThreadMutationVariables,
        TContext
      > => {
      return useMutation(getReplyToForumThreadMutationOptions(options));
    }

export const getReactToPostUrl = (id: string,) => {




  return `/api/marketplace/forum/posts/${id}/react`
}

export const reactToPost = async (id: string,
    reactToPostBody: ReactToPostBody, options?: Parameters<typeof customFetch>[1]): Promise<ReactToPost200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ReactToPost200>(getReactToPostUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reactToPostBody)
  }
);}





export const getReactToPostMutationKey = () => ['reactToPost'] as const;

export const getReactToPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactToPost>>, TError,ReactToPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reactToPost>>, TError,ReactToPostMutationVariables, TContext> => {

const mutationKey = getReactToPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactToPost>>, ReactToPostMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  reactToPost(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReactToPostMutationResult = NonNullable<Awaited<ReturnType<typeof reactToPost>>>
    export type ReactToPostMutationBody = BodyType<ReactToPostBody>
    export type ReactToPostMutationError = ErrorType<unknown>
    export type ReactToPostMutationVariables = {id: string;data: BodyType<ReactToPostBody>}

    export const useReactToPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactToPost>>, TError,ReactToPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reactToPost>>,
        TError,
        ReactToPostMutationVariables,
        TContext
      > => {
      return useMutation(getReactToPostMutationOptions(options));
    }

export const getGetNotificationPrefsUrl = () => {




  return `/api/marketplace/notification-prefs`
}

export const getNotificationPrefs = async ( options?: Parameters<typeof customFetch>[1]): Promise<NotificationPrefs> => {

  return customFetch<NotificationPrefs>(getGetNotificationPrefsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNotificationPrefsQueryKey = () => {
    return [
    `/api/marketplace/notification-prefs`
    ] as const;
    }


export const getGetNotificationPrefsQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationPrefs>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationPrefs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationPrefsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationPrefs>>> = ({ signal }) => getNotificationPrefs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationPrefs>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationPrefsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationPrefs>>>
export type GetNotificationPrefsQueryError = ErrorType<unknown>



export function useGetNotificationPrefs<TData = Awaited<ReturnType<typeof getNotificationPrefs>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationPrefs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetNotificationPrefsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateNotificationPrefsUrl = () => {




  return `/api/marketplace/notification-prefs`
}

export const updateNotificationPrefs = async (updateNotificationPrefsBody: UpdateNotificationPrefsBody, options?: Parameters<typeof customFetch>[1]): Promise<NotificationPrefs> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<NotificationPrefs>(getUpdateNotificationPrefsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateNotificationPrefsBody)
  }
);}





export const getUpdateNotificationPrefsMutationKey = () => ['updateNotificationPrefs'] as const;

export const getUpdateNotificationPrefsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationPrefs>>, TError,UpdateNotificationPrefsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNotificationPrefs>>, TError,UpdateNotificationPrefsMutationVariables, TContext> => {

const mutationKey = getUpdateNotificationPrefsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotificationPrefs>>, UpdateNotificationPrefsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateNotificationPrefs(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationPrefsMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotificationPrefs>>>
    export type UpdateNotificationPrefsMutationBody = BodyType<UpdateNotificationPrefsBody>
    export type UpdateNotificationPrefsMutationError = ErrorType<unknown>
    export type UpdateNotificationPrefsMutationVariables = {data: BodyType<UpdateNotificationPrefsBody>}

    export const useUpdateNotificationPrefs = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationPrefs>>, TError,UpdateNotificationPrefsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateNotificationPrefs>>,
        TError,
        UpdateNotificationPrefsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateNotificationPrefsMutationOptions(options));
    }

export const getUnsubscribeViaTokenUrl = (token: string,
    params?: UnsubscribeViaTokenParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/marketplace/unsubscribe/${token}?${stringifiedParams}` : `/api/marketplace/unsubscribe/${token}`
}

export const unsubscribeViaToken = async (token: string,
    params?: UnsubscribeViaTokenParams, options?: Parameters<typeof customFetch>[1]): Promise<UnsubscribeViaToken200> => {

  return customFetch<UnsubscribeViaToken200>(getUnsubscribeViaTokenUrl(token,params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUnsubscribeViaTokenMutationKey = () => ['unsubscribeViaToken'] as const;

export const getUnsubscribeViaTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribeViaToken>>, TError,UnsubscribeViaTokenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof unsubscribeViaToken>>, TError,UnsubscribeViaTokenMutationVariables, TContext> => {

const mutationKey = getUnsubscribeViaTokenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unsubscribeViaToken>>, UnsubscribeViaTokenMutationVariables> = (props) => {
          const {token,params} = props ?? {};

          return  unsubscribeViaToken(token,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnsubscribeViaTokenMutationResult = NonNullable<Awaited<ReturnType<typeof unsubscribeViaToken>>>

    export type UnsubscribeViaTokenMutationError = ErrorType<unknown>
    export type UnsubscribeViaTokenMutationVariables = {token: string;params?: UnsubscribeViaTokenParams}

    export const useUnsubscribeViaToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unsubscribeViaToken>>, TError,UnsubscribeViaTokenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof unsubscribeViaToken>>,
        TError,
        UnsubscribeViaTokenMutationVariables,
        TContext
      > => {
      return useMutation(getUnsubscribeViaTokenMutationOptions(options));
    }

export const getGrantEngagementManagerUrl = () => {




  return `/api/admin/engagement/role`
}

/**
 * @summary Grant or revoke the Engagement Manager role (platform admin only)
 */
export const grantEngagementManager = async (grantEngagementManagerBody: GrantEngagementManagerBody, options?: Parameters<typeof customFetch>[1]): Promise<GrantEngagementManager200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<GrantEngagementManager200>(getGrantEngagementManagerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(grantEngagementManagerBody)
  }
);}





export const getGrantEngagementManagerMutationKey = () => ['grantEngagementManager'] as const;

export const getGrantEngagementManagerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantEngagementManager>>, TError,GrantEngagementManagerMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof grantEngagementManager>>, TError,GrantEngagementManagerMutationVariables, TContext> => {

const mutationKey = getGrantEngagementManagerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof grantEngagementManager>>, GrantEngagementManagerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  grantEngagementManager(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GrantEngagementManagerMutationResult = NonNullable<Awaited<ReturnType<typeof grantEngagementManager>>>
    export type GrantEngagementManagerMutationBody = BodyType<GrantEngagementManagerBody>
    export type GrantEngagementManagerMutationError = ErrorType<unknown>
    export type GrantEngagementManagerMutationVariables = {data: BodyType<GrantEngagementManagerBody>}

    /**
 * @summary Grant or revoke the Engagement Manager role (platform admin only)
 */
export const useGrantEngagementManager = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantEngagementManager>>, TError,GrantEngagementManagerMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof grantEngagementManager>>,
        TError,
        GrantEngagementManagerMutationVariables,
        TContext
      > => {
      return useMutation(getGrantEngagementManagerMutationOptions(options));
    }

export const getListEngagementManagersUrl = () => {




  return `/api/admin/engagement/role-list`
}

export const listEngagementManagers = async ( options?: Parameters<typeof customFetch>[1]): Promise<ListEngagementManagers200Item[]> => {

  return customFetch<ListEngagementManagers200Item[]>(getListEngagementManagersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEngagementManagersQueryKey = () => {
    return [
    `/api/admin/engagement/role-list`
    ] as const;
    }


export const getListEngagementManagersQueryOptions = <TData = Awaited<ReturnType<typeof listEngagementManagers>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEngagementManagers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEngagementManagersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEngagementManagers>>> = ({ signal }) => listEngagementManagers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEngagementManagers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEngagementManagersQueryResult = NonNullable<Awaited<ReturnType<typeof listEngagementManagers>>>
export type ListEngagementManagersQueryError = ErrorType<unknown>



export function useListEngagementManagers<TData = Awaited<ReturnType<typeof listEngagementManagers>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEngagementManagers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEngagementManagersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCuratedArchiveHealthUrl = () => {




  return `/api/admin/engagement/curated-archive-health`
}

/**
 * @summary Safe health summary for the curated opportunity archive sweep
 */
export const getCuratedArchiveHealth = async ( options?: Parameters<typeof customFetch>[1]): Promise<CuratedArchiveHealth> => {

  return customFetch<CuratedArchiveHealth>(getGetCuratedArchiveHealthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCuratedArchiveHealthQueryKey = () => {
    return [
    `/api/admin/engagement/curated-archive-health`
    ] as const;
    }


export const getGetCuratedArchiveHealthQueryOptions = <TData = Awaited<ReturnType<typeof getCuratedArchiveHealth>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCuratedArchiveHealth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCuratedArchiveHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCuratedArchiveHealth>>> = ({ signal }) => getCuratedArchiveHealth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCuratedArchiveHealth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCuratedArchiveHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getCuratedArchiveHealth>>>
export type GetCuratedArchiveHealthQueryError = ErrorType<unknown>


/**
 * @summary Safe health summary for the curated opportunity archive sweep
 */

export function useGetCuratedArchiveHealth<TData = Awaited<ReturnType<typeof getCuratedArchiveHealth>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCuratedArchiveHealth>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCuratedArchiveHealthQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPlatformAdminsUrl = () => {




  return `/api/admin/platform-admins`
}

/**
 * @summary List all Platform Admins (platform admin only)
 */
export const listPlatformAdmins = async ( options?: Parameters<typeof customFetch>[1]): Promise<ListPlatformAdmins200Item[]> => {

  return customFetch<ListPlatformAdmins200Item[]>(getListPlatformAdminsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlatformAdminsQueryKey = () => {
    return [
    `/api/admin/platform-admins`
    ] as const;
    }


export const getListPlatformAdminsQueryOptions = <TData = Awaited<ReturnType<typeof listPlatformAdmins>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlatformAdmins>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlatformAdminsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlatformAdmins>>> = ({ signal }) => listPlatformAdmins({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlatformAdmins>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPlatformAdminsQueryResult = NonNullable<Awaited<ReturnType<typeof listPlatformAdmins>>>
export type ListPlatformAdminsQueryError = ErrorType<unknown>


/**
 * @summary List all Platform Admins (platform admin only)
 */

export function useListPlatformAdmins<TData = Awaited<ReturnType<typeof listPlatformAdmins>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlatformAdmins>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPlatformAdminsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGrantPlatformAdminUrl = () => {




  return `/api/admin/platform-admins`
}

/**
 * @summary Grant Platform Admin to an existing user by email (platform admin only)
 */
export const grantPlatformAdmin = async (grantPlatformAdminBody: GrantPlatformAdminBody, options?: Parameters<typeof customFetch>[1]): Promise<GrantPlatformAdmin200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<GrantPlatformAdmin200>(getGrantPlatformAdminUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(grantPlatformAdminBody)
  }
);}





export const getGrantPlatformAdminMutationKey = () => ['grantPlatformAdmin'] as const;

export const getGrantPlatformAdminMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantPlatformAdmin>>, TError,GrantPlatformAdminMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof grantPlatformAdmin>>, TError,GrantPlatformAdminMutationVariables, TContext> => {

const mutationKey = getGrantPlatformAdminMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof grantPlatformAdmin>>, GrantPlatformAdminMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  grantPlatformAdmin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GrantPlatformAdminMutationResult = NonNullable<Awaited<ReturnType<typeof grantPlatformAdmin>>>
    export type GrantPlatformAdminMutationBody = BodyType<GrantPlatformAdminBody>
    export type GrantPlatformAdminMutationError = ErrorType<unknown>
    export type GrantPlatformAdminMutationVariables = {data: BodyType<GrantPlatformAdminBody>}

    /**
 * @summary Grant Platform Admin to an existing user by email (platform admin only)
 */
export const useGrantPlatformAdmin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantPlatformAdmin>>, TError,GrantPlatformAdminMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof grantPlatformAdmin>>,
        TError,
        GrantPlatformAdminMutationVariables,
        TContext
      > => {
      return useMutation(getGrantPlatformAdminMutationOptions(options));
    }

export const getRevokePlatformAdminUrl = (userId: string,) => {




  return `/api/admin/platform-admins/${userId}`
}

/**
 * @summary Revoke Platform Admin from a user (platform admin only)
 */
export const revokePlatformAdmin = async (userId: string, options?: Parameters<typeof customFetch>[1]): Promise<RevokePlatformAdmin200> => {

  return customFetch<RevokePlatformAdmin200>(getRevokePlatformAdminUrl(userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokePlatformAdminMutationKey = () => ['revokePlatformAdmin'] as const;

export const getRevokePlatformAdminMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokePlatformAdmin>>, TError,RevokePlatformAdminMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokePlatformAdmin>>, TError,RevokePlatformAdminMutationVariables, TContext> => {

const mutationKey = getRevokePlatformAdminMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokePlatformAdmin>>, RevokePlatformAdminMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  revokePlatformAdmin(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokePlatformAdminMutationResult = NonNullable<Awaited<ReturnType<typeof revokePlatformAdmin>>>

    export type RevokePlatformAdminMutationError = ErrorType<unknown>
    export type RevokePlatformAdminMutationVariables = {userId: string}

    /**
 * @summary Revoke Platform Admin from a user (platform admin only)
 */
export const useRevokePlatformAdmin = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokePlatformAdmin>>, TError,RevokePlatformAdminMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokePlatformAdmin>>,
        TError,
        RevokePlatformAdminMutationVariables,
        TContext
      > => {
      return useMutation(getRevokePlatformAdminMutationOptions(options));
    }

export const getListAllOpportunitiesUrl = () => {




  return `/api/admin/engagement/opportunities`
}

export const listAllOpportunities = async ( options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceOpportunity[]> => {

  return customFetch<MarketplaceOpportunity[]>(getListAllOpportunitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAllOpportunitiesQueryKey = () => {
    return [
    `/api/admin/engagement/opportunities`
    ] as const;
    }


export const getListAllOpportunitiesQueryOptions = <TData = Awaited<ReturnType<typeof listAllOpportunities>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAllOpportunities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllOpportunitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllOpportunities>>> = ({ signal }) => listAllOpportunities({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllOpportunities>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAllOpportunitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listAllOpportunities>>>
export type ListAllOpportunitiesQueryError = ErrorType<unknown>



export function useListAllOpportunities<TData = Awaited<ReturnType<typeof listAllOpportunities>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAllOpportunities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAllOpportunitiesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateOpportunityUrl = () => {




  return `/api/admin/engagement/opportunities`
}

export const createOpportunity = async (marketplaceOpportunityInput: MarketplaceOpportunityInput, options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceOpportunity> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<MarketplaceOpportunity>(getCreateOpportunityUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(marketplaceOpportunityInput)
  }
);}





export const getCreateOpportunityMutationKey = () => ['createOpportunity'] as const;

export const getCreateOpportunityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpportunity>>, TError,CreateOpportunityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOpportunity>>, TError,CreateOpportunityMutationVariables, TContext> => {

const mutationKey = getCreateOpportunityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOpportunity>>, CreateOpportunityMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createOpportunity(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOpportunityMutationResult = NonNullable<Awaited<ReturnType<typeof createOpportunity>>>
    export type CreateOpportunityMutationBody = BodyType<MarketplaceOpportunityInput>
    export type CreateOpportunityMutationError = ErrorType<unknown>
    export type CreateOpportunityMutationVariables = {data: BodyType<MarketplaceOpportunityInput>}

    export const useCreateOpportunity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOpportunity>>, TError,CreateOpportunityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createOpportunity>>,
        TError,
        CreateOpportunityMutationVariables,
        TContext
      > => {
      return useMutation(getCreateOpportunityMutationOptions(options));
    }

export const getBulkCreateDraftOpportunitiesUrl = () => {




  return `/api/admin/engagement/opportunities/bulk-draft`
}

/**
 * @summary Save several curated opportunities in one action, as drafts (default) or published, optionally auto-blasting each published opportunity
 */
export const bulkCreateDraftOpportunities = async (bulkCreateDraftOpportunitiesBody: BulkCreateDraftOpportunitiesBody, options?: Parameters<typeof customFetch>[1]): Promise<BulkCreateDraftOpportunities201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<BulkCreateDraftOpportunities201>(getBulkCreateDraftOpportunitiesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkCreateDraftOpportunitiesBody)
  }
);}





export const getBulkCreateDraftOpportunitiesMutationKey = () => ['bulkCreateDraftOpportunities'] as const;

export const getBulkCreateDraftOpportunitiesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateDraftOpportunities>>, TError,BulkCreateDraftOpportunitiesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkCreateDraftOpportunities>>, TError,BulkCreateDraftOpportunitiesMutationVariables, TContext> => {

const mutationKey = getBulkCreateDraftOpportunitiesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkCreateDraftOpportunities>>, BulkCreateDraftOpportunitiesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  bulkCreateDraftOpportunities(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkCreateDraftOpportunitiesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkCreateDraftOpportunities>>>
    export type BulkCreateDraftOpportunitiesMutationBody = BodyType<BulkCreateDraftOpportunitiesBody>
    export type BulkCreateDraftOpportunitiesMutationError = ErrorType<unknown>
    export type BulkCreateDraftOpportunitiesMutationVariables = {data: BodyType<BulkCreateDraftOpportunitiesBody>}

    /**
 * @summary Save several curated opportunities in one action, as drafts (default) or published, optionally auto-blasting each published opportunity
 */
export const useBulkCreateDraftOpportunities = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkCreateDraftOpportunities>>, TError,BulkCreateDraftOpportunitiesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkCreateDraftOpportunities>>,
        TError,
        BulkCreateDraftOpportunitiesMutationVariables,
        TContext
      > => {
      return useMutation(getBulkCreateDraftOpportunitiesMutationOptions(options));
    }

export const getRepairCuratedOpportunityDeduplicationUrl = () => {




  return `/api/admin/engagement/opportunities/repair-deduplication`
}

/**
 * @summary Archive confirmed duplicate GSA eBuy opportunities without deleting their history
 */
export const repairCuratedOpportunityDeduplication = async ( options?: Parameters<typeof customFetch>[1]): Promise<RepairCuratedOpportunityDeduplication200> => {

  return customFetch<RepairCuratedOpportunityDeduplication200>(getRepairCuratedOpportunityDeduplicationUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRepairCuratedOpportunityDeduplicationMutationKey = () => ['repairCuratedOpportunityDeduplication'] as const;

export const getRepairCuratedOpportunityDeduplicationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof repairCuratedOpportunityDeduplication>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof repairCuratedOpportunityDeduplication>>, TError,void, TContext> => {

const mutationKey = getRepairCuratedOpportunityDeduplicationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof repairCuratedOpportunityDeduplication>>, void> = () => {


          return  repairCuratedOpportunityDeduplication(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RepairCuratedOpportunityDeduplicationMutationResult = NonNullable<Awaited<ReturnType<typeof repairCuratedOpportunityDeduplication>>>

    export type RepairCuratedOpportunityDeduplicationMutationError = ErrorType<unknown>


    /**
 * @summary Archive confirmed duplicate GSA eBuy opportunities without deleting their history
 */
export const useRepairCuratedOpportunityDeduplication = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof repairCuratedOpportunityDeduplication>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof repairCuratedOpportunityDeduplication>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRepairCuratedOpportunityDeduplicationMutationOptions(options));
    }

export const getCuratorExtractOpportunityPdfUrl = () => {




  return `/api/admin/engagement/opportunities/extract-pdf`
}

/**
 * @summary Upload a solicitation PDF (GSA eBuy or other) and start a background AI-extraction job; poll the extract-jobs endpoint for progress. Nothing is persisted to the marketplace.
 */
export const curatorExtractOpportunityPdf = async (curatorExtractOpportunityPdfBody: CuratorExtractOpportunityPdfBody, options?: Parameters<typeof customFetch>[1]): Promise<CuratorExtractJob> => {
    const formData = new FormData();
formData.append(`file`, curatorExtractOpportunityPdfBody.file);

  return customFetch<CuratorExtractJob>(getCuratorExtractOpportunityPdfUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getCuratorExtractOpportunityPdfMutationKey = () => ['curatorExtractOpportunityPdf'] as const;

export const getCuratorExtractOpportunityPdfMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof curatorExtractOpportunityPdf>>, TError,CuratorExtractOpportunityPdfMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof curatorExtractOpportunityPdf>>, TError,CuratorExtractOpportunityPdfMutationVariables, TContext> => {

const mutationKey = getCuratorExtractOpportunityPdfMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof curatorExtractOpportunityPdf>>, CuratorExtractOpportunityPdfMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  curatorExtractOpportunityPdf(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CuratorExtractOpportunityPdfMutationResult = NonNullable<Awaited<ReturnType<typeof curatorExtractOpportunityPdf>>>
    export type CuratorExtractOpportunityPdfMutationBody = BodyType<CuratorExtractOpportunityPdfBody>
    export type CuratorExtractOpportunityPdfMutationError = ErrorType<ApiError>
    export type CuratorExtractOpportunityPdfMutationVariables = {data: BodyType<CuratorExtractOpportunityPdfBody>}

    /**
 * @summary Upload a solicitation PDF (GSA eBuy or other) and start a background AI-extraction job; poll the extract-jobs endpoint for progress. Nothing is persisted to the marketplace.
 */
export const useCuratorExtractOpportunityPdf = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof curatorExtractOpportunityPdf>>, TError,CuratorExtractOpportunityPdfMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof curatorExtractOpportunityPdf>>,
        TError,
        CuratorExtractOpportunityPdfMutationVariables,
        TContext
      > => {
      return useMutation(getCuratorExtractOpportunityPdfMutationOptions(options));
    }

export const getGetCuratorExtractJobUrl = (id: string,) => {




  return `/api/admin/engagement/opportunities/extract-jobs/${id}`
}

/**
 * @summary Poll a background curator PDF extraction job for progress and per-record results
 */
export const getCuratorExtractJob = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<CuratorExtractJob> => {

  return customFetch<CuratorExtractJob>(getGetCuratorExtractJobUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCuratorExtractJobQueryKey = (id: string,) => {
    return [
    `/api/admin/engagement/opportunities/extract-jobs/${id}`
    ] as const;
    }


export const getGetCuratorExtractJobQueryOptions = <TData = Awaited<ReturnType<typeof getCuratorExtractJob>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCuratorExtractJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCuratorExtractJobQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCuratorExtractJob>>> = ({ signal }) => getCuratorExtractJob(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCuratorExtractJob>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCuratorExtractJobQueryResult = NonNullable<Awaited<ReturnType<typeof getCuratorExtractJob>>>
export type GetCuratorExtractJobQueryError = ErrorType<unknown>


/**
 * @summary Poll a background curator PDF extraction job for progress and per-record results
 */

export function useGetCuratorExtractJob<TData = Awaited<ReturnType<typeof getCuratorExtractJob>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCuratorExtractJob>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCuratorExtractJobQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateOpportunityUrl = (id: string,) => {




  return `/api/admin/engagement/opportunities/${id}`
}

export const updateOpportunity = async (id: string,
    marketplaceOpportunityInput: MarketplaceOpportunityInput, options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceOpportunity> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<MarketplaceOpportunity>(getUpdateOpportunityUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(marketplaceOpportunityInput)
  }
);}





export const getUpdateOpportunityMutationKey = () => ['updateOpportunity'] as const;

export const getUpdateOpportunityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpportunity>>, TError,UpdateOpportunityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOpportunity>>, TError,UpdateOpportunityMutationVariables, TContext> => {

const mutationKey = getUpdateOpportunityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOpportunity>>, UpdateOpportunityMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateOpportunity(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOpportunityMutationResult = NonNullable<Awaited<ReturnType<typeof updateOpportunity>>>
    export type UpdateOpportunityMutationBody = BodyType<MarketplaceOpportunityInput>
    export type UpdateOpportunityMutationError = ErrorType<unknown>
    export type UpdateOpportunityMutationVariables = {id: string;data: BodyType<MarketplaceOpportunityInput>}

    export const useUpdateOpportunity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOpportunity>>, TError,UpdateOpportunityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateOpportunity>>,
        TError,
        UpdateOpportunityMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOpportunityMutationOptions(options));
    }

export const getDeleteOpportunityUrl = (id: string,) => {




  return `/api/admin/engagement/opportunities/${id}`
}

export const deleteOpportunity = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteOpportunityUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteOpportunityMutationKey = () => ['deleteOpportunity'] as const;

export const getDeleteOpportunityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOpportunity>>, TError,DeleteOpportunityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOpportunity>>, TError,DeleteOpportunityMutationVariables, TContext> => {

const mutationKey = getDeleteOpportunityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOpportunity>>, DeleteOpportunityMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteOpportunity(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOpportunityMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOpportunity>>>

    export type DeleteOpportunityMutationError = ErrorType<unknown>
    export type DeleteOpportunityMutationVariables = {id: string}

    export const useDeleteOpportunity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOpportunity>>, TError,DeleteOpportunityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteOpportunity>>,
        TError,
        DeleteOpportunityMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteOpportunityMutationOptions(options));
    }

export const getListAllRoadmapItemsUrl = () => {




  return `/api/admin/engagement/roadmap`
}

export const listAllRoadmapItems = async ( options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceRoadmapItem[]> => {

  return customFetch<MarketplaceRoadmapItem[]>(getListAllRoadmapItemsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAllRoadmapItemsQueryKey = () => {
    return [
    `/api/admin/engagement/roadmap`
    ] as const;
    }


export const getListAllRoadmapItemsQueryOptions = <TData = Awaited<ReturnType<typeof listAllRoadmapItems>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAllRoadmapItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllRoadmapItemsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllRoadmapItems>>> = ({ signal }) => listAllRoadmapItems({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllRoadmapItems>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAllRoadmapItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listAllRoadmapItems>>>
export type ListAllRoadmapItemsQueryError = ErrorType<unknown>



export function useListAllRoadmapItems<TData = Awaited<ReturnType<typeof listAllRoadmapItems>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAllRoadmapItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAllRoadmapItemsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateRoadmapItemUrl = () => {




  return `/api/admin/engagement/roadmap`
}

export const createRoadmapItem = async (marketplaceRoadmapItemInput: MarketplaceRoadmapItemInput, options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceRoadmapItem> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<MarketplaceRoadmapItem>(getCreateRoadmapItemUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(marketplaceRoadmapItemInput)
  }
);}





export const getCreateRoadmapItemMutationKey = () => ['createRoadmapItem'] as const;

export const getCreateRoadmapItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRoadmapItem>>, TError,CreateRoadmapItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRoadmapItem>>, TError,CreateRoadmapItemMutationVariables, TContext> => {

const mutationKey = getCreateRoadmapItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRoadmapItem>>, CreateRoadmapItemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createRoadmapItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRoadmapItemMutationResult = NonNullable<Awaited<ReturnType<typeof createRoadmapItem>>>
    export type CreateRoadmapItemMutationBody = BodyType<MarketplaceRoadmapItemInput>
    export type CreateRoadmapItemMutationError = ErrorType<unknown>
    export type CreateRoadmapItemMutationVariables = {data: BodyType<MarketplaceRoadmapItemInput>}

    export const useCreateRoadmapItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRoadmapItem>>, TError,CreateRoadmapItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRoadmapItem>>,
        TError,
        CreateRoadmapItemMutationVariables,
        TContext
      > => {
      return useMutation(getCreateRoadmapItemMutationOptions(options));
    }

export const getUpdateRoadmapItemUrl = (id: string,) => {




  return `/api/admin/engagement/roadmap/${id}`
}

export const updateRoadmapItem = async (id: string,
    marketplaceRoadmapItemInput: MarketplaceRoadmapItemInput, options?: Parameters<typeof customFetch>[1]): Promise<MarketplaceRoadmapItem> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<MarketplaceRoadmapItem>(getUpdateRoadmapItemUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(marketplaceRoadmapItemInput)
  }
);}





export const getUpdateRoadmapItemMutationKey = () => ['updateRoadmapItem'] as const;

export const getUpdateRoadmapItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoadmapItem>>, TError,UpdateRoadmapItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRoadmapItem>>, TError,UpdateRoadmapItemMutationVariables, TContext> => {

const mutationKey = getUpdateRoadmapItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRoadmapItem>>, UpdateRoadmapItemMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateRoadmapItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRoadmapItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateRoadmapItem>>>
    export type UpdateRoadmapItemMutationBody = BodyType<MarketplaceRoadmapItemInput>
    export type UpdateRoadmapItemMutationError = ErrorType<unknown>
    export type UpdateRoadmapItemMutationVariables = {id: string;data: BodyType<MarketplaceRoadmapItemInput>}

    export const useUpdateRoadmapItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoadmapItem>>, TError,UpdateRoadmapItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRoadmapItem>>,
        TError,
        UpdateRoadmapItemMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateRoadmapItemMutationOptions(options));
    }

export const getDeleteRoadmapItemUrl = (id: string,) => {




  return `/api/admin/engagement/roadmap/${id}`
}

export const deleteRoadmapItem = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteRoadmapItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteRoadmapItemMutationKey = () => ['deleteRoadmapItem'] as const;

export const getDeleteRoadmapItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoadmapItem>>, TError,DeleteRoadmapItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRoadmapItem>>, TError,DeleteRoadmapItemMutationVariables, TContext> => {

const mutationKey = getDeleteRoadmapItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRoadmapItem>>, DeleteRoadmapItemMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteRoadmapItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRoadmapItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRoadmapItem>>>

    export type DeleteRoadmapItemMutationError = ErrorType<unknown>
    export type DeleteRoadmapItemMutationVariables = {id: string}

    export const useDeleteRoadmapItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoadmapItem>>, TError,DeleteRoadmapItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteRoadmapItem>>,
        TError,
        DeleteRoadmapItemMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteRoadmapItemMutationOptions(options));
    }

export const getModerateForumThreadUrl = (id: string,) => {




  return `/api/admin/engagement/forum/threads/${id}/moderate`
}

export const moderateForumThread = async (id: string,
    moderateForumThreadBody: ModerateForumThreadBody, options?: Parameters<typeof customFetch>[1]): Promise<ForumThread> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ForumThread>(getModerateForumThreadUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(moderateForumThreadBody)
  }
);}





export const getModerateForumThreadMutationKey = () => ['moderateForumThread'] as const;

export const getModerateForumThreadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderateForumThread>>, TError,ModerateForumThreadMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof moderateForumThread>>, TError,ModerateForumThreadMutationVariables, TContext> => {

const mutationKey = getModerateForumThreadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderateForumThread>>, ModerateForumThreadMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  moderateForumThread(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModerateForumThreadMutationResult = NonNullable<Awaited<ReturnType<typeof moderateForumThread>>>
    export type ModerateForumThreadMutationBody = BodyType<ModerateForumThreadBody>
    export type ModerateForumThreadMutationError = ErrorType<unknown>
    export type ModerateForumThreadMutationVariables = {id: string;data: BodyType<ModerateForumThreadBody>}

    export const useModerateForumThread = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderateForumThread>>, TError,ModerateForumThreadMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof moderateForumThread>>,
        TError,
        ModerateForumThreadMutationVariables,
        TContext
      > => {
      return useMutation(getModerateForumThreadMutationOptions(options));
    }

export const getModerateForumPostUrl = (id: string,) => {




  return `/api/admin/engagement/forum/posts/${id}/moderate`
}

export const moderateForumPost = async (id: string,
    moderateForumPostBody: ModerateForumPostBody, options?: Parameters<typeof customFetch>[1]): Promise<ForumPost> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ForumPost>(getModerateForumPostUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(moderateForumPostBody)
  }
);}





export const getModerateForumPostMutationKey = () => ['moderateForumPost'] as const;

export const getModerateForumPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderateForumPost>>, TError,ModerateForumPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof moderateForumPost>>, TError,ModerateForumPostMutationVariables, TContext> => {

const mutationKey = getModerateForumPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderateForumPost>>, ModerateForumPostMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  moderateForumPost(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ModerateForumPostMutationResult = NonNullable<Awaited<ReturnType<typeof moderateForumPost>>>
    export type ModerateForumPostMutationBody = BodyType<ModerateForumPostBody>
    export type ModerateForumPostMutationError = ErrorType<unknown>
    export type ModerateForumPostMutationVariables = {id: string;data: BodyType<ModerateForumPostBody>}

    export const useModerateForumPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderateForumPost>>, TError,ModerateForumPostMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof moderateForumPost>>,
        TError,
        ModerateForumPostMutationVariables,
        TContext
      > => {
      return useMutation(getModerateForumPostMutationOptions(options));
    }

export const getListEmailCampaignsUrl = () => {




  return `/api/admin/engagement/campaigns`
}

export const listEmailCampaigns = async ( options?: Parameters<typeof customFetch>[1]): Promise<EmailCampaign[]> => {

  return customFetch<EmailCampaign[]>(getListEmailCampaignsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEmailCampaignsQueryKey = () => {
    return [
    `/api/admin/engagement/campaigns`
    ] as const;
    }


export const getListEmailCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof listEmailCampaigns>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmailCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmailCampaignsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmailCampaigns>>> = ({ signal }) => listEmailCampaigns({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmailCampaigns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEmailCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof listEmailCampaigns>>>
export type ListEmailCampaignsQueryError = ErrorType<unknown>



export function useListEmailCampaigns<TData = Awaited<ReturnType<typeof listEmailCampaigns>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEmailCampaigns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEmailCampaignsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSendEmailCampaignUrl = () => {




  return `/api/admin/engagement/campaigns`
}

/**
 * @summary Compose and send (or test-send) a marketplace email campaign
 */
export const sendEmailCampaign = async (sendEmailCampaignBody: SendEmailCampaignBody, options?: Parameters<typeof customFetch>[1]): Promise<EmailCampaign> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<EmailCampaign>(getSendEmailCampaignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendEmailCampaignBody)
  }
);}





export const getSendEmailCampaignMutationKey = () => ['sendEmailCampaign'] as const;

export const getSendEmailCampaignMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailCampaign>>, TError,SendEmailCampaignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendEmailCampaign>>, TError,SendEmailCampaignMutationVariables, TContext> => {

const mutationKey = getSendEmailCampaignMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendEmailCampaign>>, SendEmailCampaignMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sendEmailCampaign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendEmailCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof sendEmailCampaign>>>
    export type SendEmailCampaignMutationBody = BodyType<SendEmailCampaignBody>
    export type SendEmailCampaignMutationError = ErrorType<ApiError>
    export type SendEmailCampaignMutationVariables = {data: BodyType<SendEmailCampaignBody>}

    /**
 * @summary Compose and send (or test-send) a marketplace email campaign
 */
export const useSendEmailCampaign = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmailCampaign>>, TError,SendEmailCampaignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendEmailCampaign>>,
        TError,
        SendEmailCampaignMutationVariables,
        TContext
      > => {
      return useMutation(getSendEmailCampaignMutationOptions(options));
    }

export const getRunWeeklyDigestUrl = () => {




  return `/api/admin/engagement/run-weekly-digest`
}

/**
 * @summary Manually trigger the weekly digest send (also runs on a weekly schedule)
 */
export const runWeeklyDigest = async (runWeeklyDigestBody?: RunWeeklyDigestBody, options?: Parameters<typeof customFetch>[1]): Promise<EmailCampaign> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<EmailCampaign>(getRunWeeklyDigestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(runWeeklyDigestBody)
  }
);}





export const getRunWeeklyDigestMutationKey = () => ['runWeeklyDigest'] as const;

export const getRunWeeklyDigestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runWeeklyDigest>>, TError,RunWeeklyDigestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runWeeklyDigest>>, TError,RunWeeklyDigestMutationVariables, TContext> => {

const mutationKey = getRunWeeklyDigestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runWeeklyDigest>>, RunWeeklyDigestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  runWeeklyDigest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunWeeklyDigestMutationResult = NonNullable<Awaited<ReturnType<typeof runWeeklyDigest>>>
    export type RunWeeklyDigestMutationBody = BodyType<RunWeeklyDigestBody> | undefined
    export type RunWeeklyDigestMutationError = ErrorType<unknown>
    export type RunWeeklyDigestMutationVariables = {data?: BodyType<RunWeeklyDigestBody>}

    /**
 * @summary Manually trigger the weekly digest send (also runs on a weekly schedule)
 */
export const useRunWeeklyDigest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runWeeklyDigest>>, TError,RunWeeklyDigestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runWeeklyDigest>>,
        TError,
        RunWeeklyDigestMutationVariables,
        TContext
      > => {
      return useMutation(getRunWeeklyDigestMutationOptions(options));
    }

export const getGetWeeklyDigestScheduleUrl = () => {




  return `/api/admin/engagement/weekly-digest-schedule`
}

/**
 * @summary Last-run / next-due info for the automatic weekly digest
 */
export const getWeeklyDigestSchedule = async ( options?: Parameters<typeof customFetch>[1]): Promise<WeeklyDigestSchedule> => {

  return customFetch<WeeklyDigestSchedule>(getGetWeeklyDigestScheduleUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWeeklyDigestScheduleQueryKey = () => {
    return [
    `/api/admin/engagement/weekly-digest-schedule`
    ] as const;
    }


export const getGetWeeklyDigestScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getWeeklyDigestSchedule>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWeeklyDigestSchedule>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWeeklyDigestScheduleQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWeeklyDigestSchedule>>> = ({ signal }) => getWeeklyDigestSchedule({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWeeklyDigestSchedule>>, TError, TData> & { queryKey: QueryKey }
}

export type GetWeeklyDigestScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getWeeklyDigestSchedule>>>
export type GetWeeklyDigestScheduleQueryError = ErrorType<unknown>


/**
 * @summary Last-run / next-due info for the automatic weekly digest
 */

export function useGetWeeklyDigestSchedule<TData = Awaited<ReturnType<typeof getWeeklyDigestSchedule>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getWeeklyDigestSchedule>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetWeeklyDigestScheduleQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateWeeklyDigestScheduleUrl = () => {




  return `/api/admin/engagement/weekly-digest-schedule`
}

/**
 * @summary Set the automatic weekly digest weekday and optional UTC hour
 */
export const updateWeeklyDigestSchedule = async (updateWeeklyDigestScheduleBody: UpdateWeeklyDigestScheduleBody, options?: Parameters<typeof customFetch>[1]): Promise<UpdateWeeklyDigestSchedule200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<UpdateWeeklyDigestSchedule200>(getUpdateWeeklyDigestScheduleUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateWeeklyDigestScheduleBody)
  }
);}





export const getUpdateWeeklyDigestScheduleMutationKey = () => ['updateWeeklyDigestSchedule'] as const;

export const getUpdateWeeklyDigestScheduleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWeeklyDigestSchedule>>, TError,UpdateWeeklyDigestScheduleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateWeeklyDigestSchedule>>, TError,UpdateWeeklyDigestScheduleMutationVariables, TContext> => {

const mutationKey = getUpdateWeeklyDigestScheduleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWeeklyDigestSchedule>>, UpdateWeeklyDigestScheduleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateWeeklyDigestSchedule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWeeklyDigestScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof updateWeeklyDigestSchedule>>>
    export type UpdateWeeklyDigestScheduleMutationBody = BodyType<UpdateWeeklyDigestScheduleBody>
    export type UpdateWeeklyDigestScheduleMutationError = ErrorType<unknown>
    export type UpdateWeeklyDigestScheduleMutationVariables = {data: BodyType<UpdateWeeklyDigestScheduleBody>}

    /**
 * @summary Set the automatic weekly digest weekday and optional UTC hour
 */
export const useUpdateWeeklyDigestSchedule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWeeklyDigestSchedule>>, TError,UpdateWeeklyDigestScheduleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateWeeklyDigestSchedule>>,
        TError,
        UpdateWeeklyDigestScheduleMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWeeklyDigestScheduleMutationOptions(options));
    }

export const getListNaicsUrl = (params?: ListNaicsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reference-data/naics?${stringifiedParams}` : `/api/reference-data/naics`
}

export const listNaics = async (params?: ListNaicsParams, options?: Parameters<typeof customFetch>[1]): Promise<NaicsCode[]> => {

  return customFetch<NaicsCode[]>(getListNaicsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNaicsQueryKey = (params?: ListNaicsParams,) => {
    return [
    `/api/reference-data/naics`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNaicsQueryOptions = <TData = Awaited<ReturnType<typeof listNaics>>, TError = ErrorType<unknown>>(params?: ListNaicsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNaics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNaicsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNaics>>> = ({ signal }) => listNaics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNaics>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNaicsQueryResult = NonNullable<Awaited<ReturnType<typeof listNaics>>>
export type ListNaicsQueryError = ErrorType<unknown>



export function useListNaics<TData = Awaited<ReturnType<typeof listNaics>>, TError = ErrorType<unknown>>(
 params?: ListNaicsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNaics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNaicsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateNaicsUrl = () => {




  return `/api/reference-data/naics`
}

/**
 * @summary Platform admin — add a NAICS code
 */
export const createNaics = async (createNaicsBody: CreateNaicsBody, options?: Parameters<typeof customFetch>[1]): Promise<NaicsCode> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<NaicsCode>(getCreateNaicsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createNaicsBody)
  }
);}





export const getCreateNaicsMutationKey = () => ['createNaics'] as const;

export const getCreateNaicsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNaics>>, TError,CreateNaicsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createNaics>>, TError,CreateNaicsMutationVariables, TContext> => {

const mutationKey = getCreateNaicsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNaics>>, CreateNaicsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createNaics(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateNaicsMutationResult = NonNullable<Awaited<ReturnType<typeof createNaics>>>
    export type CreateNaicsMutationBody = BodyType<CreateNaicsBody>
    export type CreateNaicsMutationError = ErrorType<unknown>
    export type CreateNaicsMutationVariables = {data: BodyType<CreateNaicsBody>}

    /**
 * @summary Platform admin — add a NAICS code
 */
export const useCreateNaics = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNaics>>, TError,CreateNaicsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createNaics>>,
        TError,
        CreateNaicsMutationVariables,
        TContext
      > => {
      return useMutation(getCreateNaicsMutationOptions(options));
    }

export const getUpdateNaicsUrl = (code: string,) => {




  return `/api/reference-data/naics/${code}`
}

export const updateNaics = async (code: string,
    updateNaicsBody: UpdateNaicsBody, options?: Parameters<typeof customFetch>[1]): Promise<NaicsCode> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<NaicsCode>(getUpdateNaicsUrl(code),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateNaicsBody)
  }
);}





export const getUpdateNaicsMutationKey = () => ['updateNaics'] as const;

export const getUpdateNaicsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNaics>>, TError,UpdateNaicsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNaics>>, TError,UpdateNaicsMutationVariables, TContext> => {

const mutationKey = getUpdateNaicsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNaics>>, UpdateNaicsMutationVariables> = (props) => {
          const {code,data} = props ?? {};

          return  updateNaics(code,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNaicsMutationResult = NonNullable<Awaited<ReturnType<typeof updateNaics>>>
    export type UpdateNaicsMutationBody = BodyType<UpdateNaicsBody>
    export type UpdateNaicsMutationError = ErrorType<unknown>
    export type UpdateNaicsMutationVariables = {code: string;data: BodyType<UpdateNaicsBody>}

    export const useUpdateNaics = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNaics>>, TError,UpdateNaicsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateNaics>>,
        TError,
        UpdateNaicsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateNaicsMutationOptions(options));
    }

export const getListPscUrl = (params?: ListPscParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reference-data/psc?${stringifiedParams}` : `/api/reference-data/psc`
}

export const listPsc = async (params?: ListPscParams, options?: Parameters<typeof customFetch>[1]): Promise<PscCode[]> => {

  return customFetch<PscCode[]>(getListPscUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPscQueryKey = (params?: ListPscParams,) => {
    return [
    `/api/reference-data/psc`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPscQueryOptions = <TData = Awaited<ReturnType<typeof listPsc>>, TError = ErrorType<unknown>>(params?: ListPscParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPsc>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPscQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPsc>>> = ({ signal }) => listPsc(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPsc>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPscQueryResult = NonNullable<Awaited<ReturnType<typeof listPsc>>>
export type ListPscQueryError = ErrorType<unknown>



export function useListPsc<TData = Awaited<ReturnType<typeof listPsc>>, TError = ErrorType<unknown>>(
 params?: ListPscParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPsc>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPscQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePscUrl = () => {




  return `/api/reference-data/psc`
}

export const createPsc = async (createPscBody: CreatePscBody, options?: Parameters<typeof customFetch>[1]): Promise<PscCode> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<PscCode>(getCreatePscUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPscBody)
  }
);}





export const getCreatePscMutationKey = () => ['createPsc'] as const;

export const getCreatePscMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPsc>>, TError,CreatePscMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPsc>>, TError,CreatePscMutationVariables, TContext> => {

const mutationKey = getCreatePscMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPsc>>, CreatePscMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPsc(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePscMutationResult = NonNullable<Awaited<ReturnType<typeof createPsc>>>
    export type CreatePscMutationBody = BodyType<CreatePscBody>
    export type CreatePscMutationError = ErrorType<unknown>
    export type CreatePscMutationVariables = {data: BodyType<CreatePscBody>}

    export const useCreatePsc = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPsc>>, TError,CreatePscMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPsc>>,
        TError,
        CreatePscMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePscMutationOptions(options));
    }

export const getUpdatePscUrl = (code: string,) => {




  return `/api/reference-data/psc/${code}`
}

export const updatePsc = async (code: string,
    updatePscBody: UpdatePscBody, options?: Parameters<typeof customFetch>[1]): Promise<PscCode> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<PscCode>(getUpdatePscUrl(code),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePscBody)
  }
);}





export const getUpdatePscMutationKey = () => ['updatePsc'] as const;

export const getUpdatePscMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePsc>>, TError,UpdatePscMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePsc>>, TError,UpdatePscMutationVariables, TContext> => {

const mutationKey = getUpdatePscMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePsc>>, UpdatePscMutationVariables> = (props) => {
          const {code,data} = props ?? {};

          return  updatePsc(code,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePscMutationResult = NonNullable<Awaited<ReturnType<typeof updatePsc>>>
    export type UpdatePscMutationBody = BodyType<UpdatePscBody>
    export type UpdatePscMutationError = ErrorType<unknown>
    export type UpdatePscMutationVariables = {code: string;data: BodyType<UpdatePscBody>}

    export const useUpdatePsc = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePsc>>, TError,UpdatePscMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePsc>>,
        TError,
        UpdatePscMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePscMutationOptions(options));
    }

export const getListAgenciesUrl = (params?: ListAgenciesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reference-data/agencies?${stringifiedParams}` : `/api/reference-data/agencies`
}

export const listAgencies = async (params?: ListAgenciesParams, options?: Parameters<typeof customFetch>[1]): Promise<Agency[]> => {

  return customFetch<Agency[]>(getListAgenciesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAgenciesQueryKey = (params?: ListAgenciesParams,) => {
    return [
    `/api/reference-data/agencies`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAgenciesQueryOptions = <TData = Awaited<ReturnType<typeof listAgencies>>, TError = ErrorType<unknown>>(params?: ListAgenciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgencies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgenciesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgencies>>> = ({ signal }) => listAgencies(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgencies>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAgenciesQueryResult = NonNullable<Awaited<ReturnType<typeof listAgencies>>>
export type ListAgenciesQueryError = ErrorType<unknown>



export function useListAgencies<TData = Awaited<ReturnType<typeof listAgencies>>, TError = ErrorType<unknown>>(
 params?: ListAgenciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgencies>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAgenciesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAgencyUrl = () => {




  return `/api/reference-data/agencies`
}

export const createAgency = async (createAgencyBody: CreateAgencyBody, options?: Parameters<typeof customFetch>[1]): Promise<Agency> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Agency>(getCreateAgencyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createAgencyBody)
  }
);}





export const getCreateAgencyMutationKey = () => ['createAgency'] as const;

export const getCreateAgencyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgency>>, TError,CreateAgencyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAgency>>, TError,CreateAgencyMutationVariables, TContext> => {

const mutationKey = getCreateAgencyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAgency>>, CreateAgencyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAgency(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAgencyMutationResult = NonNullable<Awaited<ReturnType<typeof createAgency>>>
    export type CreateAgencyMutationBody = BodyType<CreateAgencyBody>
    export type CreateAgencyMutationError = ErrorType<unknown>
    export type CreateAgencyMutationVariables = {data: BodyType<CreateAgencyBody>}

    export const useCreateAgency = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgency>>, TError,CreateAgencyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAgency>>,
        TError,
        CreateAgencyMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAgencyMutationOptions(options));
    }

export const getGetAgencyTreeUrl = () => {




  return `/api/reference-data/agencies/tree`
}

/**
 * @summary Hierarchical (department → sub-agency → office) tree
 */
export const getAgencyTree = async ( options?: Parameters<typeof customFetch>[1]): Promise<AgencyTreeNode[]> => {

  return customFetch<AgencyTreeNode[]>(getGetAgencyTreeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgencyTreeQueryKey = () => {
    return [
    `/api/reference-data/agencies/tree`
    ] as const;
    }


export const getGetAgencyTreeQueryOptions = <TData = Awaited<ReturnType<typeof getAgencyTree>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyTree>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgencyTreeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgencyTree>>> = ({ signal }) => getAgencyTree({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgencyTree>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgencyTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getAgencyTree>>>
export type GetAgencyTreeQueryError = ErrorType<unknown>


/**
 * @summary Hierarchical (department → sub-agency → office) tree
 */

export function useGetAgencyTree<TData = Awaited<ReturnType<typeof getAgencyTree>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyTree>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgencyTreeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAgencyUrl = (code: string,) => {




  return `/api/reference-data/agencies/${code}`
}

export const updateAgency = async (code: string,
    updateAgencyBody: UpdateAgencyBody, options?: Parameters<typeof customFetch>[1]): Promise<Agency> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Agency>(getUpdateAgencyUrl(code),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAgencyBody)
  }
);}





export const getUpdateAgencyMutationKey = () => ['updateAgency'] as const;

export const getUpdateAgencyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgency>>, TError,UpdateAgencyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAgency>>, TError,UpdateAgencyMutationVariables, TContext> => {

const mutationKey = getUpdateAgencyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAgency>>, UpdateAgencyMutationVariables> = (props) => {
          const {code,data} = props ?? {};

          return  updateAgency(code,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAgencyMutationResult = NonNullable<Awaited<ReturnType<typeof updateAgency>>>
    export type UpdateAgencyMutationBody = BodyType<UpdateAgencyBody>
    export type UpdateAgencyMutationError = ErrorType<unknown>
    export type UpdateAgencyMutationVariables = {code: string;data: BodyType<UpdateAgencyBody>}

    export const useUpdateAgency = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgency>>, TError,UpdateAgencyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAgency>>,
        TError,
        UpdateAgencyMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAgencyMutationOptions(options));
    }

export const getListContractVehiclesUrl = () => {




  return `/api/reference-data/contract-vehicles`
}

export const listContractVehicles = async ( options?: Parameters<typeof customFetch>[1]): Promise<ContractVehicle[]> => {

  return customFetch<ContractVehicle[]>(getListContractVehiclesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListContractVehiclesQueryKey = () => {
    return [
    `/api/reference-data/contract-vehicles`
    ] as const;
    }


export const getListContractVehiclesQueryOptions = <TData = Awaited<ReturnType<typeof listContractVehicles>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listContractVehicles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListContractVehiclesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listContractVehicles>>> = ({ signal }) => listContractVehicles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listContractVehicles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListContractVehiclesQueryResult = NonNullable<Awaited<ReturnType<typeof listContractVehicles>>>
export type ListContractVehiclesQueryError = ErrorType<unknown>



export function useListContractVehicles<TData = Awaited<ReturnType<typeof listContractVehicles>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listContractVehicles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListContractVehiclesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateContractVehicleUrl = () => {




  return `/api/reference-data/contract-vehicles`
}

export const createContractVehicle = async (createContractVehicleBody: CreateContractVehicleBody, options?: Parameters<typeof customFetch>[1]): Promise<ContractVehicle> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ContractVehicle>(getCreateContractVehicleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createContractVehicleBody)
  }
);}





export const getCreateContractVehicleMutationKey = () => ['createContractVehicle'] as const;

export const getCreateContractVehicleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContractVehicle>>, TError,CreateContractVehicleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createContractVehicle>>, TError,CreateContractVehicleMutationVariables, TContext> => {

const mutationKey = getCreateContractVehicleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContractVehicle>>, CreateContractVehicleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createContractVehicle(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateContractVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof createContractVehicle>>>
    export type CreateContractVehicleMutationBody = BodyType<CreateContractVehicleBody>
    export type CreateContractVehicleMutationError = ErrorType<unknown>
    export type CreateContractVehicleMutationVariables = {data: BodyType<CreateContractVehicleBody>}

    export const useCreateContractVehicle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContractVehicle>>, TError,CreateContractVehicleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createContractVehicle>>,
        TError,
        CreateContractVehicleMutationVariables,
        TContext
      > => {
      return useMutation(getCreateContractVehicleMutationOptions(options));
    }

export const getUpdateContractVehicleUrl = (code: string,) => {




  return `/api/reference-data/contract-vehicles/${code}`
}

export const updateContractVehicle = async (code: string,
    updateContractVehicleBody: UpdateContractVehicleBody, options?: Parameters<typeof customFetch>[1]): Promise<ContractVehicle> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ContractVehicle>(getUpdateContractVehicleUrl(code),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateContractVehicleBody)
  }
);}





export const getUpdateContractVehicleMutationKey = () => ['updateContractVehicle'] as const;

export const getUpdateContractVehicleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContractVehicle>>, TError,UpdateContractVehicleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateContractVehicle>>, TError,UpdateContractVehicleMutationVariables, TContext> => {

const mutationKey = getUpdateContractVehicleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContractVehicle>>, UpdateContractVehicleMutationVariables> = (props) => {
          const {code,data} = props ?? {};

          return  updateContractVehicle(code,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContractVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof updateContractVehicle>>>
    export type UpdateContractVehicleMutationBody = BodyType<UpdateContractVehicleBody>
    export type UpdateContractVehicleMutationError = ErrorType<unknown>
    export type UpdateContractVehicleMutationVariables = {code: string;data: BodyType<UpdateContractVehicleBody>}

    export const useUpdateContractVehicle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContractVehicle>>, TError,UpdateContractVehicleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateContractVehicle>>,
        TError,
        UpdateContractVehicleMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateContractVehicleMutationOptions(options));
    }

export const getListCertificationsUrl = () => {




  return `/api/reference-data/certifications`
}

export const listCertifications = async ( options?: Parameters<typeof customFetch>[1]): Promise<Certification[]> => {

  return customFetch<Certification[]>(getListCertificationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCertificationsQueryKey = () => {
    return [
    `/api/reference-data/certifications`
    ] as const;
    }


export const getListCertificationsQueryOptions = <TData = Awaited<ReturnType<typeof listCertifications>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCertifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCertificationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCertifications>>> = ({ signal }) => listCertifications({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCertifications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCertificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listCertifications>>>
export type ListCertificationsQueryError = ErrorType<unknown>



export function useListCertifications<TData = Awaited<ReturnType<typeof listCertifications>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCertifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCertificationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCertificationUrl = () => {




  return `/api/reference-data/certifications`
}

export const createCertification = async (createCertificationBody: CreateCertificationBody, options?: Parameters<typeof customFetch>[1]): Promise<Certification> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<Certification>(getCreateCertificationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCertificationBody)
  }
);}





export const getCreateCertificationMutationKey = () => ['createCertification'] as const;

export const getCreateCertificationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCertification>>, TError,CreateCertificationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCertification>>, TError,CreateCertificationMutationVariables, TContext> => {

const mutationKey = getCreateCertificationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCertification>>, CreateCertificationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createCertification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCertificationMutationResult = NonNullable<Awaited<ReturnType<typeof createCertification>>>
    export type CreateCertificationMutationBody = BodyType<CreateCertificationBody>
    export type CreateCertificationMutationError = ErrorType<unknown>
    export type CreateCertificationMutationVariables = {data: BodyType<CreateCertificationBody>}

    export const useCreateCertification = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCertification>>, TError,CreateCertificationMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCertification>>,
        TError,
        CreateCertificationMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCertificationMutationOptions(options));
    }

export const getListClearancesUrl = () => {




  return `/api/reference-data/clearances`
}

export const listClearances = async ( options?: Parameters<typeof customFetch>[1]): Promise<Clearance[]> => {

  return customFetch<Clearance[]>(getListClearancesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListClearancesQueryKey = () => {
    return [
    `/api/reference-data/clearances`
    ] as const;
    }


export const getListClearancesQueryOptions = <TData = Awaited<ReturnType<typeof listClearances>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClearances>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListClearancesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClearances>>> = ({ signal }) => listClearances({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClearances>>, TError, TData> & { queryKey: QueryKey }
}

export type ListClearancesQueryResult = NonNullable<Awaited<ReturnType<typeof listClearances>>>
export type ListClearancesQueryError = ErrorType<unknown>



export function useListClearances<TData = Awaited<ReturnType<typeof listClearances>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClearances>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListClearancesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListCapabilityTagsUrl = (params?: ListCapabilityTagsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reference-data/capability-tags?${stringifiedParams}` : `/api/reference-data/capability-tags`
}

export const listCapabilityTags = async (params?: ListCapabilityTagsParams, options?: Parameters<typeof customFetch>[1]): Promise<CapabilityTag[]> => {

  return customFetch<CapabilityTag[]>(getListCapabilityTagsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCapabilityTagsQueryKey = (params?: ListCapabilityTagsParams,) => {
    return [
    `/api/reference-data/capability-tags`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCapabilityTagsQueryOptions = <TData = Awaited<ReturnType<typeof listCapabilityTags>>, TError = ErrorType<unknown>>(params?: ListCapabilityTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCapabilityTags>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCapabilityTagsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCapabilityTags>>> = ({ signal }) => listCapabilityTags(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCapabilityTags>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCapabilityTagsQueryResult = NonNullable<Awaited<ReturnType<typeof listCapabilityTags>>>
export type ListCapabilityTagsQueryError = ErrorType<unknown>



export function useListCapabilityTags<TData = Awaited<ReturnType<typeof listCapabilityTags>>, TError = ErrorType<unknown>>(
 params?: ListCapabilityTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCapabilityTags>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCapabilityTagsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCapabilityTagUrl = () => {




  return `/api/reference-data/capability-tags`
}

/**
 * @summary Submit a capability tag (defaults to pending unless caller is platform admin)
 */
export const createCapabilityTag = async (createCapabilityTagBody: CreateCapabilityTagBody, options?: Parameters<typeof customFetch>[1]): Promise<CapabilityTag> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<CapabilityTag>(getCreateCapabilityTagUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCapabilityTagBody)
  }
);}





export const getCreateCapabilityTagMutationKey = () => ['createCapabilityTag'] as const;

export const getCreateCapabilityTagMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCapabilityTag>>, TError,CreateCapabilityTagMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCapabilityTag>>, TError,CreateCapabilityTagMutationVariables, TContext> => {

const mutationKey = getCreateCapabilityTagMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCapabilityTag>>, CreateCapabilityTagMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createCapabilityTag(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCapabilityTagMutationResult = NonNullable<Awaited<ReturnType<typeof createCapabilityTag>>>
    export type CreateCapabilityTagMutationBody = BodyType<CreateCapabilityTagBody>
    export type CreateCapabilityTagMutationError = ErrorType<unknown>
    export type CreateCapabilityTagMutationVariables = {data: BodyType<CreateCapabilityTagBody>}

    /**
 * @summary Submit a capability tag (defaults to pending unless caller is platform admin)
 */
export const useCreateCapabilityTag = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCapabilityTag>>, TError,CreateCapabilityTagMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCapabilityTag>>,
        TError,
        CreateCapabilityTagMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCapabilityTagMutationOptions(options));
    }

export const getUpdateCapabilityTagUrl = (id: string,) => {




  return `/api/reference-data/capability-tags/${id}`
}

/**
 * @summary Platform admin — promote / merge / rename a capability tag
 */
export const updateCapabilityTag = async (id: string,
    updateCapabilityTagBody: UpdateCapabilityTagBody, options?: Parameters<typeof customFetch>[1]): Promise<CapabilityTag> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<CapabilityTag>(getUpdateCapabilityTagUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCapabilityTagBody)
  }
);}





export const getUpdateCapabilityTagMutationKey = () => ['updateCapabilityTag'] as const;

export const getUpdateCapabilityTagMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCapabilityTag>>, TError,UpdateCapabilityTagMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCapabilityTag>>, TError,UpdateCapabilityTagMutationVariables, TContext> => {

const mutationKey = getUpdateCapabilityTagMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCapabilityTag>>, UpdateCapabilityTagMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateCapabilityTag(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCapabilityTagMutationResult = NonNullable<Awaited<ReturnType<typeof updateCapabilityTag>>>
    export type UpdateCapabilityTagMutationBody = BodyType<UpdateCapabilityTagBody>
    export type UpdateCapabilityTagMutationError = ErrorType<unknown>
    export type UpdateCapabilityTagMutationVariables = {id: string;data: BodyType<UpdateCapabilityTagBody>}

    /**
 * @summary Platform admin — promote / merge / rename a capability tag
 */
export const useUpdateCapabilityTag = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCapabilityTag>>, TError,UpdateCapabilityTagMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCapabilityTag>>,
        TError,
        UpdateCapabilityTagMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCapabilityTagMutationOptions(options));
    }

export const getListReferenceDataRequestsUrl = (params?: ListReferenceDataRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reference-data/requests?${stringifiedParams}` : `/api/reference-data/requests`
}

export const listReferenceDataRequests = async (params?: ListReferenceDataRequestsParams, options?: Parameters<typeof customFetch>[1]): Promise<ReferenceDataRequest[]> => {

  return customFetch<ReferenceDataRequest[]>(getListReferenceDataRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListReferenceDataRequestsQueryKey = (params?: ListReferenceDataRequestsParams,) => {
    return [
    `/api/reference-data/requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListReferenceDataRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listReferenceDataRequests>>, TError = ErrorType<unknown>>(params?: ListReferenceDataRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReferenceDataRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReferenceDataRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listReferenceDataRequests>>> = ({ signal }) => listReferenceDataRequests(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listReferenceDataRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListReferenceDataRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listReferenceDataRequests>>>
export type ListReferenceDataRequestsQueryError = ErrorType<unknown>



export function useListReferenceDataRequests<TData = Awaited<ReturnType<typeof listReferenceDataRequests>>, TError = ErrorType<unknown>>(
 params?: ListReferenceDataRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listReferenceDataRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListReferenceDataRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateReferenceDataRequestUrl = () => {




  return `/api/reference-data/requests`
}

export const createReferenceDataRequest = async (createReferenceDataRequestBody: CreateReferenceDataRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<ReferenceDataRequest> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ReferenceDataRequest>(getCreateReferenceDataRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createReferenceDataRequestBody)
  }
);}





export const getCreateReferenceDataRequestMutationKey = () => ['createReferenceDataRequest'] as const;

export const getCreateReferenceDataRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReferenceDataRequest>>, TError,CreateReferenceDataRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createReferenceDataRequest>>, TError,CreateReferenceDataRequestMutationVariables, TContext> => {

const mutationKey = getCreateReferenceDataRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReferenceDataRequest>>, CreateReferenceDataRequestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createReferenceDataRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateReferenceDataRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createReferenceDataRequest>>>
    export type CreateReferenceDataRequestMutationBody = BodyType<CreateReferenceDataRequestBody>
    export type CreateReferenceDataRequestMutationError = ErrorType<unknown>
    export type CreateReferenceDataRequestMutationVariables = {data: BodyType<CreateReferenceDataRequestBody>}

    export const useCreateReferenceDataRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReferenceDataRequest>>, TError,CreateReferenceDataRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createReferenceDataRequest>>,
        TError,
        CreateReferenceDataRequestMutationVariables,
        TContext
      > => {
      return useMutation(getCreateReferenceDataRequestMutationOptions(options));
    }

export const getDecideReferenceDataRequestUrl = (id: string,) => {




  return `/api/reference-data/requests/${id}/decide`
}

/**
 * @summary Platform admin — approve or reject a request
 */
export const decideReferenceDataRequest = async (id: string,
    decideReferenceDataRequestBody: DecideReferenceDataRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<ReferenceDataRequest> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<ReferenceDataRequest>(getDecideReferenceDataRequestUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(decideReferenceDataRequestBody)
  }
);}





export const getDecideReferenceDataRequestMutationKey = () => ['decideReferenceDataRequest'] as const;

export const getDecideReferenceDataRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decideReferenceDataRequest>>, TError,DecideReferenceDataRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof decideReferenceDataRequest>>, TError,DecideReferenceDataRequestMutationVariables, TContext> => {

const mutationKey = getDecideReferenceDataRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof decideReferenceDataRequest>>, DecideReferenceDataRequestMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  decideReferenceDataRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DecideReferenceDataRequestMutationResult = NonNullable<Awaited<ReturnType<typeof decideReferenceDataRequest>>>
    export type DecideReferenceDataRequestMutationBody = BodyType<DecideReferenceDataRequestBody>
    export type DecideReferenceDataRequestMutationError = ErrorType<unknown>
    export type DecideReferenceDataRequestMutationVariables = {id: string;data: BodyType<DecideReferenceDataRequestBody>}

    /**
 * @summary Platform admin — approve or reject a request
 */
export const useDecideReferenceDataRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof decideReferenceDataRequest>>, TError,DecideReferenceDataRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof decideReferenceDataRequest>>,
        TError,
        DecideReferenceDataRequestMutationVariables,
        TContext
      > => {
      return useMutation(getDecideReferenceDataRequestMutationOptions(options));
    }

export const getCreateAccessRequestUrl = () => {




  return `/api/access-requests`
}

/**
 * @summary Public — submit a request to access SPN (owner review required)
 */
export const createAccessRequest = async (createAccessRequestBody: CreateAccessRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<CreateAccessRequest200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<CreateAccessRequest200>(getCreateAccessRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createAccessRequestBody)
  }
);}





export const getCreateAccessRequestMutationKey = () => ['createAccessRequest'] as const;

export const getCreateAccessRequestMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessRequest>>, TError,CreateAccessRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAccessRequest>>, TError,CreateAccessRequestMutationVariables, TContext> => {

const mutationKey = getCreateAccessRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAccessRequest>>, CreateAccessRequestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAccessRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAccessRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createAccessRequest>>>
    export type CreateAccessRequestMutationBody = BodyType<CreateAccessRequestBody>
    export type CreateAccessRequestMutationError = ErrorType<ApiError>
    export type CreateAccessRequestMutationVariables = {data: BodyType<CreateAccessRequestBody>}

    /**
 * @summary Public — submit a request to access SPN (owner review required)
 */
export const useCreateAccessRequest = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAccessRequest>>, TError,CreateAccessRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAccessRequest>>,
        TError,
        CreateAccessRequestMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAccessRequestMutationOptions(options));
    }

export const getRecordFunnelEventUrl = () => {




  return `/api/analytics/events`
}

/**
 * Records only a normalized anonymous browser id, source, campaign, experiment variant, page, and allowlisted event name. Events expire automatically and must never contain email, notes, tokens, or request contents.
 * @summary Public — record a privacy-safe funnel event
 */
export const recordFunnelEvent = async (recordFunnelEventBody: RecordFunnelEventBody, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<void>(getRecordFunnelEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(recordFunnelEventBody)
  }
);}





export const getRecordFunnelEventMutationKey = () => ['recordFunnelEvent'] as const;

export const getRecordFunnelEventMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordFunnelEvent>>, TError,RecordFunnelEventMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordFunnelEvent>>, TError,RecordFunnelEventMutationVariables, TContext> => {

const mutationKey = getRecordFunnelEventMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordFunnelEvent>>, RecordFunnelEventMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  recordFunnelEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordFunnelEventMutationResult = NonNullable<Awaited<ReturnType<typeof recordFunnelEvent>>>
    export type RecordFunnelEventMutationBody = BodyType<RecordFunnelEventBody>
    export type RecordFunnelEventMutationError = ErrorType<ApiError>
    export type RecordFunnelEventMutationVariables = {data: BodyType<RecordFunnelEventBody>}

    /**
 * @summary Public — record a privacy-safe funnel event
 */
export const useRecordFunnelEvent = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordFunnelEvent>>, TError,RecordFunnelEventMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordFunnelEvent>>,
        TError,
        RecordFunnelEventMutationVariables,
        TContext
      > => {
      return useMutation(getRecordFunnelEventMutationOptions(options));
    }

export const getGetAdminFunnelAnalyticsUrl = (params?: GetAdminFunnelAnalyticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/analytics/funnel?${stringifiedParams}` : `/api/admin/analytics/funnel`
}

/**
 * @summary Platform admin — aggregate approval-gate funnel metrics
 */
export const getAdminFunnelAnalytics = async (params?: GetAdminFunnelAnalyticsParams, options?: Parameters<typeof customFetch>[1]): Promise<GetAdminFunnelAnalytics200> => {

  return customFetch<GetAdminFunnelAnalytics200>(getGetAdminFunnelAnalyticsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminFunnelAnalyticsQueryKey = (params?: GetAdminFunnelAnalyticsParams,) => {
    return [
    `/api/admin/analytics/funnel`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAdminFunnelAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminFunnelAnalytics>>, TError = ErrorType<ApiError>>(params?: GetAdminFunnelAnalyticsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminFunnelAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminFunnelAnalyticsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminFunnelAnalytics>>> = ({ signal }) => getAdminFunnelAnalytics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminFunnelAnalytics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminFunnelAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminFunnelAnalytics>>>
export type GetAdminFunnelAnalyticsQueryError = ErrorType<ApiError>


/**
 * @summary Platform admin — aggregate approval-gate funnel metrics
 */

export function useGetAdminFunnelAnalytics<TData = Awaited<ReturnType<typeof getAdminFunnelAnalytics>>, TError = ErrorType<ApiError>>(
 params?: GetAdminFunnelAnalyticsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminFunnelAnalytics>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminFunnelAnalyticsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAccessRequestsUrl = (params?: ListAccessRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/access-requests?${stringifiedParams}` : `/api/admin/access-requests`
}

/**
 * @summary Platform admin — list access requests, filterable by status
 */
export const listAccessRequests = async (params?: ListAccessRequestsParams, options?: Parameters<typeof customFetch>[1]): Promise<AccessRequest[]> => {

  return customFetch<AccessRequest[]>(getListAccessRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAccessRequestsQueryKey = (params?: ListAccessRequestsParams,) => {
    return [
    `/api/admin/access-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAccessRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listAccessRequests>>, TError = ErrorType<unknown>>(params?: ListAccessRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccessRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccessRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccessRequests>>> = ({ signal }) => listAccessRequests(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccessRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccessRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccessRequests>>>
export type ListAccessRequestsQueryError = ErrorType<unknown>


/**
 * @summary Platform admin — list access requests, filterable by status
 */

export function useListAccessRequests<TData = Awaited<ReturnType<typeof listAccessRequests>>, TError = ErrorType<unknown>>(
 params?: ListAccessRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccessRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccessRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getApproveAccessRequestUrl = (id: string,) => {




  return `/api/admin/access-requests/${id}/approve`
}

/**
 * @summary Platform admin — approve and email the requester a magic link
 */
export const approveAccessRequest = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<AccessRequest> => {

  return customFetch<AccessRequest>(getApproveAccessRequestUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApproveAccessRequestMutationKey = () => ['approveAccessRequest'] as const;

export const getApproveAccessRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAccessRequest>>, TError,ApproveAccessRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveAccessRequest>>, TError,ApproveAccessRequestMutationVariables, TContext> => {

const mutationKey = getApproveAccessRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAccessRequest>>, ApproveAccessRequestMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  approveAccessRequest(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveAccessRequestMutationResult = NonNullable<Awaited<ReturnType<typeof approveAccessRequest>>>

    export type ApproveAccessRequestMutationError = ErrorType<unknown>
    export type ApproveAccessRequestMutationVariables = {id: string}

    /**
 * @summary Platform admin — approve and email the requester a magic link
 */
export const useApproveAccessRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAccessRequest>>, TError,ApproveAccessRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveAccessRequest>>,
        TError,
        ApproveAccessRequestMutationVariables,
        TContext
      > => {
      return useMutation(getApproveAccessRequestMutationOptions(options));
    }

export const getRejectAccessRequestUrl = (id: string,) => {




  return `/api/admin/access-requests/${id}/reject`
}

/**
 * @summary Platform admin — decline an access request (optional reason)
 */
export const rejectAccessRequest = async (id: string,
    rejectAccessRequestBody?: RejectAccessRequestBody, options?: Parameters<typeof customFetch>[1]): Promise<AccessRequest> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AccessRequest>(getRejectAccessRequestUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(rejectAccessRequestBody)
  }
);}





export const getRejectAccessRequestMutationKey = () => ['rejectAccessRequest'] as const;

export const getRejectAccessRequestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAccessRequest>>, TError,RejectAccessRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectAccessRequest>>, TError,RejectAccessRequestMutationVariables, TContext> => {

const mutationKey = getRejectAccessRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectAccessRequest>>, RejectAccessRequestMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  rejectAccessRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectAccessRequestMutationResult = NonNullable<Awaited<ReturnType<typeof rejectAccessRequest>>>
    export type RejectAccessRequestMutationBody = BodyType<RejectAccessRequestBody> | undefined
    export type RejectAccessRequestMutationError = ErrorType<unknown>
    export type RejectAccessRequestMutationVariables = {id: string;data?: BodyType<RejectAccessRequestBody>}

    /**
 * @summary Platform admin — decline an access request (optional reason)
 */
export const useRejectAccessRequest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAccessRequest>>, TError,RejectAccessRequestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectAccessRequest>>,
        TError,
        RejectAccessRequestMutationVariables,
        TContext
      > => {
      return useMutation(getRejectAccessRequestMutationOptions(options));
    }

export const getBulkRejectAccessRequestsUrl = () => {




  return `/api/admin/access-requests/bulk-reject`
}

/**
 * @summary Platform admin — decline many pending access requests at once
 */
export const bulkRejectAccessRequests = async (bulkRejectAccessRequestsBody: BulkRejectAccessRequestsBody, options?: Parameters<typeof customFetch>[1]): Promise<BulkRejectAccessRequests200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<BulkRejectAccessRequests200>(getBulkRejectAccessRequestsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkRejectAccessRequestsBody)
  }
);}





export const getBulkRejectAccessRequestsMutationKey = () => ['bulkRejectAccessRequests'] as const;

export const getBulkRejectAccessRequestsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkRejectAccessRequests>>, TError,BulkRejectAccessRequestsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkRejectAccessRequests>>, TError,BulkRejectAccessRequestsMutationVariables, TContext> => {

const mutationKey = getBulkRejectAccessRequestsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkRejectAccessRequests>>, BulkRejectAccessRequestsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  bulkRejectAccessRequests(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkRejectAccessRequestsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkRejectAccessRequests>>>
    export type BulkRejectAccessRequestsMutationBody = BodyType<BulkRejectAccessRequestsBody>
    export type BulkRejectAccessRequestsMutationError = ErrorType<unknown>
    export type BulkRejectAccessRequestsMutationVariables = {data: BodyType<BulkRejectAccessRequestsBody>}

    /**
 * @summary Platform admin — decline many pending access requests at once
 */
export const useBulkRejectAccessRequests = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkRejectAccessRequests>>, TError,BulkRejectAccessRequestsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkRejectAccessRequests>>,
        TError,
        BulkRejectAccessRequestsMutationVariables,
        TContext
      > => {
      return useMutation(getBulkRejectAccessRequestsMutationOptions(options));
    }

export const getSeedReferenceDataUrl = () => {




  return `/api/admin/reference-data/seed`
}

/**
 * @summary Platform admin — re-load bundled JSON seed files into the canonical reference tables
 */
export const seedReferenceData = async ( options?: Parameters<typeof customFetch>[1]): Promise<SeedReferenceDataResult> => {

  return customFetch<SeedReferenceDataResult>(getSeedReferenceDataUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSeedReferenceDataMutationKey = () => ['seedReferenceData'] as const;

export const getSeedReferenceDataMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof seedReferenceData>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof seedReferenceData>>, TError,void, TContext> => {

const mutationKey = getSeedReferenceDataMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof seedReferenceData>>, void> = () => {


          return  seedReferenceData(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SeedReferenceDataMutationResult = NonNullable<Awaited<ReturnType<typeof seedReferenceData>>>

    export type SeedReferenceDataMutationError = ErrorType<unknown>


    /**
 * @summary Platform admin — re-load bundled JSON seed files into the canonical reference tables
 */
export const useSeedReferenceData = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof seedReferenceData>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof seedReferenceData>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSeedReferenceDataMutationOptions(options));
    }

export const getSyncOpportunitiesUrl = () => {




  return `/api/opportunities/sync`
}

/**
 * @summary Ingest federal opportunities from SAM.gov and queue rescoring for the current tenant
 */
export const syncOpportunities = async (opportunitySyncBody?: OpportunitySyncBody, options?: Parameters<typeof customFetch>[1]): Promise<OpportunitySyncResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<OpportunitySyncResult>(getSyncOpportunitiesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(opportunitySyncBody)
  }
);}





export const getSyncOpportunitiesMutationKey = () => ['syncOpportunities'] as const;

export const getSyncOpportunitiesMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncOpportunities>>, TError,SyncOpportunitiesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof syncOpportunities>>, TError,SyncOpportunitiesMutationVariables, TContext> => {

const mutationKey = getSyncOpportunitiesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncOpportunities>>, SyncOpportunitiesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  syncOpportunities(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncOpportunitiesMutationResult = NonNullable<Awaited<ReturnType<typeof syncOpportunities>>>
    export type SyncOpportunitiesMutationBody = BodyType<OpportunitySyncBody> | undefined
    export type SyncOpportunitiesMutationError = ErrorType<ApiError>
    export type SyncOpportunitiesMutationVariables = {data?: BodyType<OpportunitySyncBody>}

    /**
 * @summary Ingest federal opportunities from SAM.gov and queue rescoring for the current tenant
 */
export const useSyncOpportunities = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncOpportunities>>, TError,SyncOpportunitiesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof syncOpportunities>>,
        TError,
        SyncOpportunitiesMutationVariables,
        TContext
      > => {
      return useMutation(getSyncOpportunitiesMutationOptions(options));
    }

export const getListOpportunityMatchesUrl = (params?: ListOpportunityMatchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/opportunities/matches?${stringifiedParams}` : `/api/opportunities/matches`
}

/**
 * @summary Ranked opportunity matches for the current tenant
 */
export const listOpportunityMatches = async (params?: ListOpportunityMatchesParams, options?: Parameters<typeof customFetch>[1]): Promise<OpportunityMatchList> => {

  return customFetch<OpportunityMatchList>(getListOpportunityMatchesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpportunityMatchesQueryKey = (params?: ListOpportunityMatchesParams,) => {
    return [
    `/api/opportunities/matches`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOpportunityMatchesQueryOptions = <TData = Awaited<ReturnType<typeof listOpportunityMatches>>, TError = ErrorType<unknown>>(params?: ListOpportunityMatchesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpportunityMatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpportunityMatchesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpportunityMatches>>> = ({ signal }) => listOpportunityMatches(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpportunityMatches>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpportunityMatchesQueryResult = NonNullable<Awaited<ReturnType<typeof listOpportunityMatches>>>
export type ListOpportunityMatchesQueryError = ErrorType<unknown>


/**
 * @summary Ranked opportunity matches for the current tenant
 */

export function useListOpportunityMatches<TData = Awaited<ReturnType<typeof listOpportunityMatches>>, TError = ErrorType<unknown>>(
 params?: ListOpportunityMatchesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpportunityMatches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpportunityMatchesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAnalyzeOpportunityExtractFileUrl = () => {




  return `/api/opportunities/analyze/extract-file`
}

/**
 * @summary Upload a PDF/DOCX solicitation and AI-extract structured fields for review
 */
export const analyzeOpportunityExtractFile = async (analyzeOpportunityExtractFileBody: AnalyzeOpportunityExtractFileBody, options?: Parameters<typeof customFetch>[1]): Promise<SolicitationExtractionResult> => {
    const formData = new FormData();
formData.append(`file`, analyzeOpportunityExtractFileBody.file);

  return customFetch<SolicitationExtractionResult>(getAnalyzeOpportunityExtractFileUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getAnalyzeOpportunityExtractFileMutationKey = () => ['analyzeOpportunityExtractFile'] as const;

export const getAnalyzeOpportunityExtractFileMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeOpportunityExtractFile>>, TError,AnalyzeOpportunityExtractFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof analyzeOpportunityExtractFile>>, TError,AnalyzeOpportunityExtractFileMutationVariables, TContext> => {

const mutationKey = getAnalyzeOpportunityExtractFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analyzeOpportunityExtractFile>>, AnalyzeOpportunityExtractFileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  analyzeOpportunityExtractFile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnalyzeOpportunityExtractFileMutationResult = NonNullable<Awaited<ReturnType<typeof analyzeOpportunityExtractFile>>>
    export type AnalyzeOpportunityExtractFileMutationBody = BodyType<AnalyzeOpportunityExtractFileBody>
    export type AnalyzeOpportunityExtractFileMutationError = ErrorType<ApiError>
    export type AnalyzeOpportunityExtractFileMutationVariables = {data: BodyType<AnalyzeOpportunityExtractFileBody>}

    /**
 * @summary Upload a PDF/DOCX solicitation and AI-extract structured fields for review
 */
export const useAnalyzeOpportunityExtractFile = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeOpportunityExtractFile>>, TError,AnalyzeOpportunityExtractFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof analyzeOpportunityExtractFile>>,
        TError,
        AnalyzeOpportunityExtractFileMutationVariables,
        TContext
      > => {
      return useMutation(getAnalyzeOpportunityExtractFileMutationOptions(options));
    }

export const getAnalyzeOpportunityExtractTextUrl = () => {




  return `/api/opportunities/analyze/extract-text`
}

/**
 * @summary Submit pasted solicitation text and AI-extract structured fields for review
 */
export const analyzeOpportunityExtractText = async (analyzeOpportunityTextBody: AnalyzeOpportunityTextBody, options?: Parameters<typeof customFetch>[1]): Promise<SolicitationExtractionResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<SolicitationExtractionResult>(getAnalyzeOpportunityExtractTextUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(analyzeOpportunityTextBody)
  }
);}





export const getAnalyzeOpportunityExtractTextMutationKey = () => ['analyzeOpportunityExtractText'] as const;

export const getAnalyzeOpportunityExtractTextMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeOpportunityExtractText>>, TError,AnalyzeOpportunityExtractTextMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof analyzeOpportunityExtractText>>, TError,AnalyzeOpportunityExtractTextMutationVariables, TContext> => {

const mutationKey = getAnalyzeOpportunityExtractTextMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analyzeOpportunityExtractText>>, AnalyzeOpportunityExtractTextMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  analyzeOpportunityExtractText(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnalyzeOpportunityExtractTextMutationResult = NonNullable<Awaited<ReturnType<typeof analyzeOpportunityExtractText>>>
    export type AnalyzeOpportunityExtractTextMutationBody = BodyType<AnalyzeOpportunityTextBody>
    export type AnalyzeOpportunityExtractTextMutationError = ErrorType<ApiError>
    export type AnalyzeOpportunityExtractTextMutationVariables = {data: BodyType<AnalyzeOpportunityTextBody>}

    /**
 * @summary Submit pasted solicitation text and AI-extract structured fields for review
 */
export const useAnalyzeOpportunityExtractText = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeOpportunityExtractText>>, TError,AnalyzeOpportunityExtractTextMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof analyzeOpportunityExtractText>>,
        TError,
        AnalyzeOpportunityExtractTextMutationVariables,
        TContext
      > => {
      return useMutation(getAnalyzeOpportunityExtractTextMutationOptions(options));
    }

export const getAnalyzeOpportunitySamUrlUrl = () => {




  return `/api/opportunities/analyze/sam-url`
}

/**
 * @summary Resolve a SAM.gov notice URL via the SAM API, store it as a shared opportunity and score it
 */
export const analyzeOpportunitySamUrl = async (analyzeOpportunitySamUrlBody: AnalyzeOpportunitySamUrlBody, options?: Parameters<typeof customFetch>[1]): Promise<AnalyzedOpportunityCreated> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AnalyzedOpportunityCreated>(getAnalyzeOpportunitySamUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(analyzeOpportunitySamUrlBody)
  }
);}





export const getAnalyzeOpportunitySamUrlMutationKey = () => ['analyzeOpportunitySamUrl'] as const;

export const getAnalyzeOpportunitySamUrlMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeOpportunitySamUrl>>, TError,AnalyzeOpportunitySamUrlMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof analyzeOpportunitySamUrl>>, TError,AnalyzeOpportunitySamUrlMutationVariables, TContext> => {

const mutationKey = getAnalyzeOpportunitySamUrlMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analyzeOpportunitySamUrl>>, AnalyzeOpportunitySamUrlMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  analyzeOpportunitySamUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnalyzeOpportunitySamUrlMutationResult = NonNullable<Awaited<ReturnType<typeof analyzeOpportunitySamUrl>>>
    export type AnalyzeOpportunitySamUrlMutationBody = BodyType<AnalyzeOpportunitySamUrlBody>
    export type AnalyzeOpportunitySamUrlMutationError = ErrorType<ApiError>
    export type AnalyzeOpportunitySamUrlMutationVariables = {data: BodyType<AnalyzeOpportunitySamUrlBody>}

    /**
 * @summary Resolve a SAM.gov notice URL via the SAM API, store it as a shared opportunity and score it
 */
export const useAnalyzeOpportunitySamUrl = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeOpportunitySamUrl>>, TError,AnalyzeOpportunitySamUrlMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof analyzeOpportunitySamUrl>>,
        TError,
        AnalyzeOpportunitySamUrlMutationVariables,
        TContext
      > => {
      return useMutation(getAnalyzeOpportunitySamUrlMutationOptions(options));
    }

export const getCreateAnalyzedOpportunityUrl = () => {




  return `/api/opportunities/analyze`
}

/**
 * @summary Create a tenant-private uploaded opportunity from confirmed fields and score it
 */
export const createAnalyzedOpportunity = async (createAnalyzedOpportunityBody: CreateAnalyzedOpportunityBody, options?: Parameters<typeof customFetch>[1]): Promise<AnalyzedOpportunityCreated> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<AnalyzedOpportunityCreated>(getCreateAnalyzedOpportunityUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createAnalyzedOpportunityBody)
  }
);}





export const getCreateAnalyzedOpportunityMutationKey = () => ['createAnalyzedOpportunity'] as const;

export const getCreateAnalyzedOpportunityMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalyzedOpportunity>>, TError,CreateAnalyzedOpportunityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAnalyzedOpportunity>>, TError,CreateAnalyzedOpportunityMutationVariables, TContext> => {

const mutationKey = getCreateAnalyzedOpportunityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnalyzedOpportunity>>, CreateAnalyzedOpportunityMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAnalyzedOpportunity(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAnalyzedOpportunityMutationResult = NonNullable<Awaited<ReturnType<typeof createAnalyzedOpportunity>>>
    export type CreateAnalyzedOpportunityMutationBody = BodyType<CreateAnalyzedOpportunityBody>
    export type CreateAnalyzedOpportunityMutationError = ErrorType<unknown>
    export type CreateAnalyzedOpportunityMutationVariables = {data: BodyType<CreateAnalyzedOpportunityBody>}

    /**
 * @summary Create a tenant-private uploaded opportunity from confirmed fields and score it
 */
export const useCreateAnalyzedOpportunity = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalyzedOpportunity>>, TError,CreateAnalyzedOpportunityMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAnalyzedOpportunity>>,
        TError,
        CreateAnalyzedOpportunityMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAnalyzedOpportunityMutationOptions(options));
    }

export const getOpportunityWhatIfUrl = (id: string,) => {




  return `/api/opportunities/${id}/what-if`
}

/**
 * @summary Ephemeral what-if teaming score with a chosen subset of roster partners
 */
export const opportunityWhatIf = async (id: string,
    opportunityWhatIfBody: OpportunityWhatIfBody, options?: Parameters<typeof customFetch>[1]): Promise<OpportunityWhatIfResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<OpportunityWhatIfResult>(getOpportunityWhatIfUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(opportunityWhatIfBody)
  }
);}





export const getOpportunityWhatIfMutationKey = () => ['opportunityWhatIf'] as const;

export const getOpportunityWhatIfMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof opportunityWhatIf>>, TError,OpportunityWhatIfMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof opportunityWhatIf>>, TError,OpportunityWhatIfMutationVariables, TContext> => {

const mutationKey = getOpportunityWhatIfMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof opportunityWhatIf>>, OpportunityWhatIfMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  opportunityWhatIf(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpportunityWhatIfMutationResult = NonNullable<Awaited<ReturnType<typeof opportunityWhatIf>>>
    export type OpportunityWhatIfMutationBody = BodyType<OpportunityWhatIfBody>
    export type OpportunityWhatIfMutationError = ErrorType<unknown>
    export type OpportunityWhatIfMutationVariables = {id: string;data: BodyType<OpportunityWhatIfBody>}

    /**
 * @summary Ephemeral what-if teaming score with a chosen subset of roster partners
 */
export const useOpportunityWhatIf = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof opportunityWhatIf>>, TError,OpportunityWhatIfMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof opportunityWhatIf>>,
        TError,
        OpportunityWhatIfMutationVariables,
        TContext
      > => {
      return useMutation(getOpportunityWhatIfMutationOptions(options));
    }

export const getRescoreOpportunitiesUrl = () => {




  return `/api/opportunities/rescore`
}

/**
 * @summary Queue a background rescore of all opportunities for the current tenant
 */
export const rescoreOpportunities = async ( options?: Parameters<typeof customFetch>[1]): Promise<RescoreOpportunities202> => {

  return customFetch<RescoreOpportunities202>(getRescoreOpportunitiesUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRescoreOpportunitiesMutationKey = () => ['rescoreOpportunities'] as const;

export const getRescoreOpportunitiesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rescoreOpportunities>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rescoreOpportunities>>, TError,void, TContext> => {

const mutationKey = getRescoreOpportunitiesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rescoreOpportunities>>, void> = () => {


          return  rescoreOpportunities(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RescoreOpportunitiesMutationResult = NonNullable<Awaited<ReturnType<typeof rescoreOpportunities>>>

    export type RescoreOpportunitiesMutationError = ErrorType<unknown>


    /**
 * @summary Queue a background rescore of all opportunities for the current tenant
 */
export const useRescoreOpportunities = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rescoreOpportunities>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rescoreOpportunities>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRescoreOpportunitiesMutationOptions(options));
    }

export const getGetOpportunityMatchUrl = (id: string,) => {




  return `/api/opportunities/${id}`
}

/**
 * @summary Opportunity detail with tenant score, partner scores and arrangement comparison
 */
export const getOpportunityMatch = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<OpportunityMatchDetail> => {

  return customFetch<OpportunityMatchDetail>(getGetOpportunityMatchUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOpportunityMatchQueryKey = (id: string,) => {
    return [
    `/api/opportunities/${id}`
    ] as const;
    }


export const getGetOpportunityMatchQueryOptions = <TData = Awaited<ReturnType<typeof getOpportunityMatch>>, TError = ErrorType<ApiError>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpportunityMatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpportunityMatchQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpportunityMatch>>> = ({ signal }) => getOpportunityMatch(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpportunityMatch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOpportunityMatchQueryResult = NonNullable<Awaited<ReturnType<typeof getOpportunityMatch>>>
export type GetOpportunityMatchQueryError = ErrorType<ApiError>


/**
 * @summary Opportunity detail with tenant score, partner scores and arrangement comparison
 */

export function useGetOpportunityMatch<TData = Awaited<ReturnType<typeof getOpportunityMatch>>, TError = ErrorType<ApiError>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpportunityMatch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOpportunityMatchQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getPromoteOpportunityToMarketplaceUrl = (id: string,) => {




  return `/api/opportunities/${id}/promote`
}

/**
 * @summary Engagement managers — promote an ingested opportunity into the curated Marketplace
 */
export const promoteOpportunityToMarketplace = async (id: string,
    promoteOpportunityToMarketplaceBody?: PromoteOpportunityToMarketplaceBody, options?: Parameters<typeof customFetch>[1]): Promise<PromoteOpportunityToMarketplace201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<PromoteOpportunityToMarketplace201>(getPromoteOpportunityToMarketplaceUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(promoteOpportunityToMarketplaceBody)
  }
);}





export const getPromoteOpportunityToMarketplaceMutationKey = () => ['promoteOpportunityToMarketplace'] as const;

export const getPromoteOpportunityToMarketplaceMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteOpportunityToMarketplace>>, TError,PromoteOpportunityToMarketplaceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof promoteOpportunityToMarketplace>>, TError,PromoteOpportunityToMarketplaceMutationVariables, TContext> => {

const mutationKey = getPromoteOpportunityToMarketplaceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof promoteOpportunityToMarketplace>>, PromoteOpportunityToMarketplaceMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  promoteOpportunityToMarketplace(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PromoteOpportunityToMarketplaceMutationResult = NonNullable<Awaited<ReturnType<typeof promoteOpportunityToMarketplace>>>
    export type PromoteOpportunityToMarketplaceMutationBody = BodyType<PromoteOpportunityToMarketplaceBody> | undefined
    export type PromoteOpportunityToMarketplaceMutationError = ErrorType<ApiError>
    export type PromoteOpportunityToMarketplaceMutationVariables = {id: string;data?: BodyType<PromoteOpportunityToMarketplaceBody>}

    /**
 * @summary Engagement managers — promote an ingested opportunity into the curated Marketplace
 */
export const usePromoteOpportunityToMarketplace = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteOpportunityToMarketplace>>, TError,PromoteOpportunityToMarketplaceMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof promoteOpportunityToMarketplace>>,
        TError,
        PromoteOpportunityToMarketplaceMutationVariables,
        TContext
      > => {
      return useMutation(getPromoteOpportunityToMarketplaceMutationOptions(options));
    }

export const getRescoreAllTenantsUrl = () => {




  return `/api/admin/opportunities/rescore-all`
}

/**
 * @summary Platform admin — queue scoring jobs for every tenant with a vendor profile
 */
export const rescoreAllTenants = async ( options?: Parameters<typeof customFetch>[1]): Promise<RescoreAllTenants202> => {

  return customFetch<RescoreAllTenants202>(getRescoreAllTenantsUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRescoreAllTenantsMutationKey = () => ['rescoreAllTenants'] as const;

export const getRescoreAllTenantsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rescoreAllTenants>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rescoreAllTenants>>, TError,void, TContext> => {

const mutationKey = getRescoreAllTenantsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rescoreAllTenants>>, void> = () => {


          return  rescoreAllTenants(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RescoreAllTenantsMutationResult = NonNullable<Awaited<ReturnType<typeof rescoreAllTenants>>>

    export type RescoreAllTenantsMutationError = ErrorType<unknown>


    /**
 * @summary Platform admin — queue scoring jobs for every tenant with a vendor profile
 */
export const useRescoreAllTenants = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rescoreAllTenants>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rescoreAllTenants>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRescoreAllTenantsMutationOptions(options));
    }

export const getListOpportunitySyncRunsUrl = (params?: ListOpportunitySyncRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/opportunities/sync-runs?${stringifiedParams}` : `/api/admin/opportunities/sync-runs`
}

/**
 * @summary Platform admin — opportunity sync run history with GovCon fallback detection
 */
export const listOpportunitySyncRuns = async (params?: ListOpportunitySyncRunsParams, options?: Parameters<typeof customFetch>[1]): Promise<ListOpportunitySyncRuns200> => {

  return customFetch<ListOpportunitySyncRuns200>(getListOpportunitySyncRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOpportunitySyncRunsQueryKey = (params?: ListOpportunitySyncRunsParams,) => {
    return [
    `/api/admin/opportunities/sync-runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOpportunitySyncRunsQueryOptions = <TData = Awaited<ReturnType<typeof listOpportunitySyncRuns>>, TError = ErrorType<unknown>>(params?: ListOpportunitySyncRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpportunitySyncRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOpportunitySyncRunsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOpportunitySyncRuns>>> = ({ signal }) => listOpportunitySyncRuns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOpportunitySyncRuns>>, TError, TData> & { queryKey: QueryKey }
}

export type ListOpportunitySyncRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listOpportunitySyncRuns>>>
export type ListOpportunitySyncRunsQueryError = ErrorType<unknown>


/**
 * @summary Platform admin — opportunity sync run history with GovCon fallback detection
 */

export function useListOpportunitySyncRuns<TData = Awaited<ReturnType<typeof listOpportunitySyncRuns>>, TError = ErrorType<unknown>>(
 params?: ListOpportunitySyncRunsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listOpportunitySyncRuns>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListOpportunitySyncRunsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListPartnersUrl = () => {




  return `/api/partners`
}

/**
 * @summary List the current tenant's teaming partner roster
 */
export const listPartners = async ( options?: Parameters<typeof customFetch>[1]): Promise<TeamingPartner[]> => {

  return customFetch<TeamingPartner[]>(getListPartnersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPartnersQueryKey = () => {
    return [
    `/api/partners`
    ] as const;
    }


export const getListPartnersQueryOptions = <TData = Awaited<ReturnType<typeof listPartners>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPartnersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPartners>>> = ({ signal }) => listPartners({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof listPartners>>>
export type ListPartnersQueryError = ErrorType<unknown>


/**
 * @summary List the current tenant's teaming partner roster
 */

export function useListPartners<TData = Awaited<ReturnType<typeof listPartners>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPartnersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddPartnerUrl = () => {




  return `/api/partners`
}

/**
 * @summary Add an SPN vendor to the teaming partner roster
 */
export const addPartner = async (addPartnerBody: AddPartnerBody, options?: Parameters<typeof customFetch>[1]): Promise<TeamingPartner> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TeamingPartner>(getAddPartnerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addPartnerBody)
  }
);}





export const getAddPartnerMutationKey = () => ['addPartner'] as const;

export const getAddPartnerMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPartner>>, TError,AddPartnerMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addPartner>>, TError,AddPartnerMutationVariables, TContext> => {

const mutationKey = getAddPartnerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPartner>>, AddPartnerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addPartner(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddPartnerMutationResult = NonNullable<Awaited<ReturnType<typeof addPartner>>>
    export type AddPartnerMutationBody = BodyType<AddPartnerBody>
    export type AddPartnerMutationError = ErrorType<ApiError>
    export type AddPartnerMutationVariables = {data: BodyType<AddPartnerBody>}

    /**
 * @summary Add an SPN vendor to the teaming partner roster
 */
export const useAddPartner = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPartner>>, TError,AddPartnerMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addPartner>>,
        TError,
        AddPartnerMutationVariables,
        TContext
      > => {
      return useMutation(getAddPartnerMutationOptions(options));
    }

export const getRemovePartnerUrl = (partnerTenantId: string,) => {




  return `/api/partners/${partnerTenantId}`
}

/**
 * @summary Remove a vendor from the teaming partner roster
 */
export const removePartner = async (partnerTenantId: string, options?: Parameters<typeof customFetch>[1]): Promise<RemovePartner200> => {

  return customFetch<RemovePartner200>(getRemovePartnerUrl(partnerTenantId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemovePartnerMutationKey = () => ['removePartner'] as const;

export const getRemovePartnerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePartner>>, TError,RemovePartnerMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removePartner>>, TError,RemovePartnerMutationVariables, TContext> => {

const mutationKey = getRemovePartnerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removePartner>>, RemovePartnerMutationVariables> = (props) => {
          const {partnerTenantId} = props ?? {};

          return  removePartner(partnerTenantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemovePartnerMutationResult = NonNullable<Awaited<ReturnType<typeof removePartner>>>

    export type RemovePartnerMutationError = ErrorType<unknown>
    export type RemovePartnerMutationVariables = {partnerTenantId: string}

    /**
 * @summary Remove a vendor from the teaming partner roster
 */
export const useRemovePartner = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePartner>>, TError,RemovePartnerMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removePartner>>,
        TError,
        RemovePartnerMutationVariables,
        TContext
      > => {
      return useMutation(getRemovePartnerMutationOptions(options));
    }

export const getPartnerTopOpportunitiesUrl = (partnerTenantId: string,
    params?: PartnerTopOpportunitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/partners/${partnerTenantId}/top-opportunities?${stringifiedParams}` : `/api/partners/${partnerTenantId}/top-opportunities`
}

/**
 * @summary Opportunities this partner scores highest on (for the current tenant's view)
 */
export const partnerTopOpportunities = async (partnerTenantId: string,
    params?: PartnerTopOpportunitiesParams, options?: Parameters<typeof customFetch>[1]): Promise<PartnerTopOpportunity[]> => {

  return customFetch<PartnerTopOpportunity[]>(getPartnerTopOpportunitiesUrl(partnerTenantId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPartnerTopOpportunitiesQueryKey = (partnerTenantId: string,
    params?: PartnerTopOpportunitiesParams,) => {
    return [
    `/api/partners/${partnerTenantId}/top-opportunities`, ...(params ? [params] : [])
    ] as const;
    }


export const getPartnerTopOpportunitiesQueryOptions = <TData = Awaited<ReturnType<typeof partnerTopOpportunities>>, TError = ErrorType<unknown>>(partnerTenantId: string,
    params?: PartnerTopOpportunitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof partnerTopOpportunities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPartnerTopOpportunitiesQueryKey(partnerTenantId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof partnerTopOpportunities>>> = ({ signal }) => partnerTopOpportunities(partnerTenantId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: partnerTenantId !== null && partnerTenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof partnerTopOpportunities>>, TError, TData> & { queryKey: QueryKey }
}

export type PartnerTopOpportunitiesQueryResult = NonNullable<Awaited<ReturnType<typeof partnerTopOpportunities>>>
export type PartnerTopOpportunitiesQueryError = ErrorType<unknown>


/**
 * @summary Opportunities this partner scores highest on (for the current tenant's view)
 */

export function usePartnerTopOpportunities<TData = Awaited<ReturnType<typeof partnerTopOpportunities>>, TError = ErrorType<unknown>>(
 partnerTenantId: string,
    params?: PartnerTopOpportunitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof partnerTopOpportunities>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getPartnerTopOpportunitiesQueryOptions(partnerTenantId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTenantSettingsUrl = () => {




  return `/api/tenants/current/settings`
}

/**
 * @summary Update tenant settings (target agencies for opportunity matching)
 */
export const updateTenantSettings = async (updateTenantSettingsBody: UpdateTenantSettingsBody, options?: Parameters<typeof customFetch>[1]): Promise<TenantSettings> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<TenantSettings>(getUpdateTenantSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateTenantSettingsBody)
  }
);}





export const getUpdateTenantSettingsMutationKey = () => ['updateTenantSettings'] as const;

export const getUpdateTenantSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenantSettings>>, TError,UpdateTenantSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTenantSettings>>, TError,UpdateTenantSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateTenantSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTenantSettings>>, UpdateTenantSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateTenantSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTenantSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateTenantSettings>>>
    export type UpdateTenantSettingsMutationBody = BodyType<UpdateTenantSettingsBody>
    export type UpdateTenantSettingsMutationError = ErrorType<unknown>
    export type UpdateTenantSettingsMutationVariables = {data: BodyType<UpdateTenantSettingsBody>}

    /**
 * @summary Update tenant settings (target agencies for opportunity matching)
 */
export const useUpdateTenantSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTenantSettings>>, TError,UpdateTenantSettingsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTenantSettings>>,
        TError,
        UpdateTenantSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTenantSettingsMutationOptions(options));
    }

